<template>
  <div>
    <!-- Loader pantalla completa mientras se genera la factura FEL -->
    <div
      v-if="(cargandoPago && generarFactura) || cargandoPagoCombinado || cargandoPagoCombinadoRC || esperandoImpresion"
      style="
        position: fixed;
        inset: 0;
        background: rgba(0, 0, 0, 0.72);
        z-index: 9999;
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;
        gap: 16px;
      "
    >
      <div
        class="spinner-border text-light"
        style="width: 3.5rem; height: 3.5rem"
      ></div>
      <div class="text-white fw-semibold fs-5">
        Generando factura electrónica...
      </div>
      <div class="text-white-50 small">
        Por favor espere, procesando con la SAT
      </div>
    </div>
    <div
      v-if="mostrarToast"
      class="toast-container position-fixed top-0 end-0 p-3"
      style="z-index: 1055"
    >
      <div class="toast show align-items-center text-white" :class="toastColor">
        <div class="d-flex">
          <div class="toast-body">
            <i :class="iconoToast" class="me-2"></i> {{ alerta.mensaje }}
          </div>
          <button
            type="button"
            class="btn-close btn-close-white me-2 m-auto"
            @click="cerrarToast"
          ></button>
        </div>
      </div>
    </div>

    <!-- Contenido -->
    <div class="card p-4 shadow-sm">
      <div class="d-flex align-items-center mb-4">
        <button class="btn btn-outline-secondary me-3" @click="volver">
          ← Regresar
        </button>
        <h3 class="m-0 flex-grow-1 text-center">Pagar por Habitaciones</h3>
      </div>

      <div v-if="cargando" class="text-center py-5">
        <p>Cargando habitaciones...</p>
      </div>

      <div v-else>
        <!-- Botones de operaciones generales (solo si hay más de 1 habitación) -->
        <div
          v-if="habitaciones.length > 1"
          class="operaciones-generales mb-4 p-3 border rounded bg-light"
        >
          <h5 class="mb-3">
            <i class="bi bi-house-fill me-2"></i>Operaciones de Toda la Reserva
          </h5>
          <div class="d-flex gap-2 flex-wrap">
            <button
              class="btn btn-success"
              @click="abrirModalPagoReservaCompleta"
              :disabled="saldoTotalPendiente <= 0"
              :title="
                saldoTotalPendiente <= 0
                  ? 'No hay saldo pendiente'
                  : 'Pagar toda la reserva'
              "
            >
              <i class="bi bi-cash-stack me-2"></i>
              Pagar Total de la Reserva (Q{{
                Number(saldoTotalPendiente).toFixed(2)
              }})
            </button>
            <button
              class="btn btn-danger"
              @click="confirmarCheckoutReservaCompleta"
              :disabled="!puedeHacerCheckoutReservaCompleta"
              :title="mensajeEstadoCheckoutCompleto"
            >
              <i class="bi bi-box-arrow-right me-2"></i>
              Checkout de Toda la Reserva
            </button>
          </div>
        </div>

        <!-- Botones de habitaciones -->
        <div class="habitaciones-tabs mb-4">
          <button
            v-for="hab in habitaciones"
            :key="hab.IdReservaHabitacion"
            class="btn me-2 mb-2"
            :class="
              habitacionSeleccionada?.IdReservaHabitacion ===
              hab.IdReservaHabitacion
                ? 'btn-primary'
                : 'btn-outline-primary'
            "
            @click="seleccionarHabitacion(hab)"
          >
            <i class="bi bi-door-open me-1"></i>
            Hab. {{ hab.habitacion?.Numero }}
            <span v-if="hab.EstadoPago" class="badge bg-success ms-2"
              >Pagado</span
            >
          </button>
        </div>

        <!-- Detalle de habitación seleccionada -->
        <div v-if="habitacionSeleccionada" class="habitacion-detalle">
          <!-- Info general -->
          <div class="row mb-4">
            <div class="col-md-6">
              <div class="info-card">
                <h5>
                  <i class="bi bi-door-closed me-2"></i>Habitación
                  {{ habitacionSeleccionada.habitacion?.Numero }}
                </h5>
                <p class="mb-1">
                  <strong>Tipo:</strong>
                  {{ habitacionSeleccionada.habitacion?.tipo?.Nombre || "---" }}
                </p>
                <p class="mb-1">
                  <strong>Personas:</strong>
                  {{ habitacionSeleccionada.CantidadPersonasAlojadas }}
                </p>
                <p class="mb-0">
                  <strong>Precio Habitación:</strong> Q.{{
                    Number(habitacionSeleccionada.TotalHabitacion || 0).toFixed(
                      2,
                    )
                  }}
                </p>
              </div>
            </div>
            <div class="col-md-6">
              <div class="info-card totales">
                <h5><i class="bi bi-calculator me-2"></i>Totales</h5>
                <p class="mb-1">
                  <strong>Habitación:</strong> Q.{{
                    Number(habitacionSeleccionada.TotalHabitacion || 0).toFixed(
                      2,
                    )
                  }}
                </p>
                <p class="mb-1">
                  <strong>Restaurante:</strong> Q.{{
                    Number(
                      habitacionSeleccionada.TotalRestaurante || 0,
                    ).toFixed(2)
                  }}
                  <button
                    v-if="habitacionSeleccionada.cuentas_pedido?.length"
                    class="btn btn-sm btn-outline-primary ms-2 py-0 px-1"
                    @click="abrirModalRestaurante"
                    title="Ver detalles"
                  >
                    <i class="bx bx-show"></i>
                  </button>
                </p>
                <p class="mb-1">
                  <strong>Servicios Extra:</strong> Q.{{
                    Number(
                      habitacionSeleccionada.TotalServiciosExtra || 0,
                    ).toFixed(2)
                  }}
                  <button
                    v-if="habitacionSeleccionada.servicios_extra?.length"
                    class="btn btn-sm btn-outline-primary ms-2 py-0 px-1"
                    @click="abrirModalServiciosExtra"
                    title="Ver detalles"
                  >
                    <i class="bx bx-show"></i>
                  </button>
                </p>
                <hr />
                <p class="mb-1 fs-5">
                  <strong>Total Consumido:</strong> Q.{{
                    Number(habitacionSeleccionada.TotalConsumido || 0).toFixed(
                      2,
                    )
                  }}
                </p>
                <p
                  v-if="Number(habitacionSeleccionada.SaldoDescuento || 0) > 0"
                  class="mb-1 fs-5 text-success"
                >
                  <strong>Descuento Aplicado:</strong> Q.{{
                    Number(habitacionSeleccionada.SaldoDescuento || 0).toFixed(
                      2,
                    )
                  }}
                </p>
                <p class="mb-0 fs-5 text-danger">
                  <strong>Saldo Pendiente:</strong> Q.{{
                    Number(
                      habitacionSeleccionada.SaldoPendienteHabitacion || 0,
                    ).toFixed(2)
                  }}
                </p>
              </div>
            </div>
          </div>

          <!-- Botones -->
          <div class="text-center mt-4">
            <button
              class="btn btn-success btn-sm me-2"
              @click="abrirModalPago"
              :disabled="
                habitacionSeleccionada.EstadoPago ||
                Number(habitacionSeleccionada.SaldoPendienteHabitacion || 0) <=
                  0
              "
            >
              <i class="bi bi-cash me-1"></i>
              {{
                habitacionSeleccionada.EstadoPago ||
                Number(habitacionSeleccionada.SaldoPendienteHabitacion || 0) <=
                  0
                  ? "Ya Pagado"
                  : "Registrar Pago"
              }}
            </button>
            <button
              class="btn btn-warning btn-sm me-2"
              @click="abrirModalDescuento"
              :disabled="
                habitacionSeleccionada.EstadoPago ||
                habitacionSeleccionada.SaldoPendienteHabitacion <= 0
              "
            >
              <i class="bi bi-percent me-1"></i>
              Aplicar Descuento
            </button>
            <button
              v-if="Number(habitacionSeleccionada.SaldoDescuento || 0) > 0"
              class="btn btn-outline-danger btn-sm me-2"
              @click="modalQuitarDescuentoVisible = true"
              :disabled="habitacionSeleccionada.CheckOut != null"
              title="Revertir el descuento aplicado a esta habitación"
            >
              <i class="bi bi-x-circle me-1"></i>
              Quitar Descuento
            </button>
            <button
              class="btn btn-info btn-sm me-2"
              @click="abrirModalAgregarServicioExtra"
              :disabled="habitacionSeleccionada.CheckOut != null"
              title="Agregar servicio extra a esta habitación"
            >
              <i class="bi bi-basket me-1"></i>
              Agregar Servicio Extra
            </button>
            <button
              class="btn btn-outline-info btn-sm me-2"
              @click="abrirModalPagos"
            >
              <i class="bi bi-list-check me-1"></i>
              Ver Pagos Realizados
            </button>
            <button
              class="btn btn-sm"
              :class="puedeHacerCheckout ? 'btn-danger' : 'btn-secondary'"
              @click="realizarCheckout"
              :disabled="!puedeHacerCheckout || habitacionSeleccionada.CheckOut"
              :title="
                habitacionSeleccionada.CheckOut
                  ? 'Checkout ya realizado'
                  : !puedeHacerCheckout
                  ? 'Debe pagar completamente antes de hacer checkout'
                  : 'Hacer checkout'
              "
            >
              <i class="bi bi-box-arrow-right me-1"></i>
              {{
                habitacionSeleccionada.CheckOut
                  ? "Checkout Realizado"
                  : "Hacer Checkout"
              }}
            </button>
            <button
              v-if="esAdminORecepcionista && habitacionSeleccionada.CheckOut"
              class="btn btn-outline-warning btn-sm ms-2"
              @click="revertirCheckout"
              title="Revertir checkout (solo Admin)"
            >
              <i class="bi bi-arrow-counterclockwise me-1"></i>
              Revertir Checkout
            </button>
          </div>
        </div>
      </div>
    </div>

    <!-- Modal Pregunta Factura -->
    <div
      v-if="mostrarModalFactura"
      class="modal fade show d-block"
      tabindex="-1"
      style="background-color: rgba(0, 0, 0, 0.5)"
    >
      <div class="modal-dialog modal-dialog-centered">
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title">🧾 Tipo de Pago</h5>
            <button class="btn-close" @click="cerrarModalFactura"></button>
          </div>
          <div class="modal-body text-center">
            <!-- Paso 0 (nuevo): ¿Normal o crédito? -->
            <div v-if="pasoModalFactura === 0">
              <p class="mb-4">¿Cómo desea registrar este pago?</p>
              <div class="d-flex justify-content-center gap-3 flex-wrap">
                <button class="btn btn-primary" @click="pasoModalFactura = 1">
                  💳 Pago normal
                </button>
                <button class="btn btn-warning" @click="iniciarFlujoCreditoDesdeModal">
                  📋 Pago a crédito
                </button>
              </div>
            </div>
            <!-- Paso 1: ¿Necesita factura? (solo pago normal) -->
            <div v-else-if="pasoModalFactura === 1">
              <p class="mb-4">¿Desea generar factura para este pago?</p>
              <div class="d-flex justify-content-center gap-3">
                <button class="btn btn-success" @click="avanzarANitOCf">
                  ✅ Sí, con factura
                </button>
                <button
                  class="btn btn-secondary"
                  @click="seleccionarSinFactura"
                >
                  ❌ No, sin factura
                </button>
              </div>
              <div class="mt-3">
                <button class="btn btn-link btn-sm text-muted" @click="pasoModalFactura = 0">
                  ← Volver
                </button>
              </div>
            </div>
            <!-- Paso 2: ¿NIT o CF? -->
            <div v-else-if="pasoModalFactura === 2">
              <p class="mb-4">
                ¿La factura va a nombre de un NIT o Consumidor Final?
              </p>
              <div class="d-flex justify-content-center gap-3">
                <button
                  class="btn btn-primary"
                  @click="seleccionarTipoFactura(true)"
                >
                  🪦 Con NIT
                </button>
                <button
                  class="btn btn-secondary"
                  @click="seleccionarTipoFactura(false)"
                >
                  👤 Consumidor Final (CF)
                </button>
              </div>
              <div class="mt-3">
                <button
                  class="btn btn-link btn-sm text-muted"
                  @click="pasoModalFactura = 1"
                >
                  ← Volver
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- Modal Pagar (Bento selection + payment form) -->
    <div
      v-if="modalPagoVisible"
      class="modal fade show d-block"
      tabindex="-1"
      style="background-color: rgba(0, 0, 0, 0.5)"
    >
      <div class="modal-dialog modal-dialog-centered modal-lg">
        <div class="modal-content">

          <!-- ══ VISTA SELECCIÓN DE ÍTEMS ══ -->
          <template v-if="vistaPago === 'seleccion'">
            <div class="modal-header">
              <div>
                <h5 class="modal-title">
                  <i class="bi bi-list-check me-2 text-primary"></i>Seleccionar Ítems a Cobrar
                </h5>
                <small class="text-muted">
                  Hab. {{ habitacionSeleccionada?.habitacion?.Numero }} · Paso 1 de 2
                </small>
              </div>
              <button class="btn-close" @click="cerrarModalPago"></button>
            </div>
            <div class="modal-body p-0">
              <!-- Instrucciones -->
              <div class="alert alert-light border-start border-4 border-primary rounded-0 mb-0 py-2 px-3">
                <small class="text-muted">
                  <i class="bi bi-info-circle me-1 text-primary"></i>
                  <strong>Instrucciones:</strong> Marca los cargos a cobrar. Para pago parcial, ajusta el monto en el campo Q.
                </small>
              </div>
              <!-- Controles y total -->
              <div class="px-3 py-2 border-bottom bg-light d-flex align-items-center justify-content-between flex-wrap gap-2">
                <div class="d-flex gap-2">
                  <button class="btn btn-outline-secondary btn-sm" @click="deseleccionarTodo">
                    <i class="bi bi-square me-1"></i>Ninguno
                  </button>
                  <button class="btn btn-outline-primary btn-sm" @click="seleccionarTodo">
                    <i class="bi bi-check-all me-1"></i>Todo
                  </button>
                </div>
                <div class="fw-bold text-success fs-5">
                  Q{{ totalSeleccionado.toFixed(2) }}
                  <small class="text-muted fw-normal fs-6 ms-1">seleccionado</small>
                </div>
              </div>
              <!-- Pago Combinado: repartir el total entre varios métodos con una sola factura -->
              <div v-if="generarFactura" class="px-3 py-2 border-bottom bg-light">
                <div class="form-check">
                  <input
                    id="checkPagoCombinado"
                    v-model="pagoCombinado"
                    type="checkbox"
                    class="form-check-input"
                  />
                  <label class="form-check-label fw-semibold" for="checkPagoCombinado">
                    🧩 Pago Combinado: generar solo una factura repartida entre varios métodos de pago
                  </label>
                </div>
              </div>
              <!-- Lista agrupada por tipo -->
              <div class="p-3 d-flex flex-column gap-1" style="max-height: 55vh; overflow-y: auto">
                <div v-if="Object.keys(seleccion).length === 0" class="text-center text-muted py-4">
                  <i class="bi bi-check-circle fs-3 d-block mb-2 text-success"></i>
                  No hay ítems pendientes de pago
                </div>

                <!-- CONSUMOS DE RESTAURANTE -->
                <template v-if="seleccionCuentas.length">
                  <div class="d-flex align-items-center gap-2 mt-2 mb-1">
                    <i class="bi bi-cup-straw text-warning"></i>
                    <span class="small fw-bold text-uppercase text-secondary">Consumos de Restaurante</span>
                    <hr class="flex-grow-1 my-0">
                    <span class="badge bg-warning text-dark rounded-pill">{{ seleccionCuentas.length }}</span>
                  </div>
                  <div
                    v-for="[key, item] in seleccionCuentas"
                    :key="key"
                    class="border rounded-3 p-3 cursor-pointer"
                    :class="item.activo ? 'border-warning bg-warning bg-opacity-10' : 'opacity-50 bg-light'"
                    role="button"
                    @click="toggleSeleccion(key)"
                  >
                    <div class="d-flex align-items-center gap-3">
                      <input type="checkbox" class="form-check-input flex-shrink-0" style="width:20px;height:20px"
                        :checked="item.activo" @change.stop="toggleSeleccion(key)" @click.stop />
                      <div class="flex-grow-1 min-w-0">
                        <div class="fw-semibold">{{ item.label }}</div>
                        <small v-if="item.idPedido" class="text-muted">
                          <i class="bi bi-receipt me-1"></i>Comanda #{{ item.idPedido }}
                        </small>
                      </div>
                      <div class="text-end flex-shrink-0" @click.stop>
                        <template v-if="item.activo">
                          <div class="d-flex align-items-center gap-1">
                            <span class="text-muted small">Q</span>
                            <input type="number" step="0.01" min="0.01" :max="item.max"
                              v-model.number="item.monto" @change="clampMontoSeleccion(key)"
                              class="form-control form-control-sm text-end" style="width:90px" />
                          </div>
                          <small class="text-muted d-block text-end">máx Q{{ item.max.toFixed(2) }}</small>
                        </template>
                        <div v-else class="fw-bold text-muted">Q{{ item.max.toFixed(2) }}</div>
                      </div>
                    </div>
                  </div>
                </template>

                <!-- SERVICIOS EXTRA -->
                <template v-if="seleccionServicios.length">
                  <div class="d-flex align-items-center gap-2 mt-2 mb-1">
                    <i class="bi bi-star text-info"></i>
                    <span class="small fw-bold text-uppercase text-secondary">Servicios Extra</span>
                    <hr class="flex-grow-1 my-0">
                    <span class="badge bg-info rounded-pill">{{ seleccionServicios.length }}</span>
                  </div>
                  <div
                    v-for="[key, item] in seleccionServicios"
                    :key="key"
                    class="border rounded-3 p-3"
                    :class="item.activo ? 'border-info bg-info bg-opacity-10' : 'opacity-50 bg-light'"
                    role="button"
                    @click="toggleSeleccion(key)"
                  >
                    <div class="d-flex align-items-center gap-3">
                      <input type="checkbox" class="form-check-input flex-shrink-0" style="width:20px;height:20px"
                        :checked="item.activo" @change.stop="toggleSeleccion(key)" @click.stop />
                      <div class="flex-grow-1 min-w-0">
                        <div class="fw-semibold">{{ item.label }}</div>
                      </div>
                      <div class="text-end flex-shrink-0" @click.stop>
                        <template v-if="item.activo">
                          <div class="d-flex align-items-center gap-1">
                            <span class="text-muted small">Q</span>
                            <input type="number" step="0.01" min="0.01" :max="item.max"
                              v-model.number="item.monto" @change="clampMontoSeleccion(key)"
                              class="form-control form-control-sm text-end" style="width:90px" />
                          </div>
                          <small class="text-muted d-block text-end">máx Q{{ item.max.toFixed(2) }}</small>
                        </template>
                        <div v-else class="fw-bold text-muted">Q{{ item.max.toFixed(2) }}</div>
                      </div>
                    </div>
                  </div>
                </template>

                <!-- HOSPEDAJE -->
                <template v-if="seleccionHospedaje.length">
                  <div class="d-flex align-items-center gap-2 mt-2 mb-1">
                    <i class="bi bi-house-fill text-primary"></i>
                    <span class="small fw-bold text-uppercase text-secondary">Hospedaje</span>
                    <hr class="flex-grow-1 my-0">
                    <span class="badge bg-primary rounded-pill">{{ seleccionHospedaje.length }}</span>
                  </div>
                  <div
                    v-for="[key, item] in seleccionHospedaje"
                    :key="key"
                    class="border rounded-3 p-3"
                    :class="item.activo ? 'border-primary bg-primary bg-opacity-10' : 'opacity-50 bg-light'"
                    role="button"
                    @click="toggleSeleccion(key)"
                  >
                    <div class="d-flex align-items-center gap-3">
                      <input type="checkbox" class="form-check-input flex-shrink-0" style="width:20px;height:20px"
                        :checked="item.activo" @change.stop="toggleSeleccion(key)" @click.stop />
                      <div class="flex-grow-1 min-w-0">
                        <div class="fw-semibold">{{ item.label }}</div>
                      </div>
                      <div class="text-end flex-shrink-0" @click.stop>
                        <template v-if="item.activo">
                          <div class="d-flex align-items-center gap-1">
                            <span class="text-muted small">Q</span>
                            <input type="number" step="0.01" min="0.01" :max="item.max"
                              v-model.number="item.monto" @change="clampMontoSeleccion(key)"
                              class="form-control form-control-sm text-end" style="width:90px" />
                          </div>
                          <small class="text-muted d-block text-end">máx Q{{ item.max.toFixed(2) }}</small>
                        </template>
                        <div v-else class="fw-bold text-muted">Q{{ item.max.toFixed(2) }}</div>
                      </div>
                    </div>
                  </div>
                </template>
              </div>
            </div>
            <div class="modal-footer justify-content-between">
              <button class="btn btn-secondary" @click="cerrarModalPago">Cancelar</button>
              <button class="btn btn-primary" @click="irAPago" :disabled="!puedeIrAPago">
                Continuar <i class="bi bi-arrow-right ms-1"></i> Q{{ totalSeleccionado.toFixed(2) }}
              </button>
            </div>
          </template>

          <!-- ══ VISTA FORMULARIO DE PAGO ══ -->
          <template v-else>
            <div class="modal-header">
              <div class="d-flex align-items-center gap-2">
                <button class="btn btn-sm btn-outline-secondary" @click="volverASeleccion">← Volver</button>
                <h5 class="modal-title mb-0">💳 Registrar Pago</h5>
              </div>
              <button class="btn-close" @click="cerrarModalPago"></button>
            </div>
            <div class="modal-body">

              <!-- Resumen de ítems seleccionados -->
              <div class="alert alert-info py-2 mb-3">
                <div class="d-flex justify-content-between align-items-center">
                  <strong>Total:</strong>
                  <span class="fs-5 fw-bold">Q{{ totalSeleccionado.toFixed(2) }}</span>
                </div>
                <div class="small mt-1">
                  <div v-if="hayHospedajeSeleccionado" class="d-flex justify-content-between">
                    <span>Hospedaje:</span>
                    <span>Q{{ totalHospedajeSeleccionado.toFixed(2) }}</span>
                  </div>
                  <div v-if="hayCuentaSeleccionada" class="d-flex justify-content-between">
                    <span>Restaurante:</span>
                    <span class="text-warning fw-bold">Q{{ totalCuentasSeleccionadas.toFixed(2) }}</span>
                  </div>
                  <div v-if="hayServicioSeleccionado" class="d-flex justify-content-between">
                    <span>Servicios:</span>
                    <span class="text-info fw-bold">Q{{ totalServiciosSeleccionados.toFixed(2) }}</span>
                  </div>
                </div>
              </div>

              <!-- Datos FEL receptor -->
              <div v-if="requiereFactura" class="mb-3">
                <label class="form-label fw-semibold">NIT del Receptor</label>
                <div class="input-group">
                  <input
                    v-model="nitReceptor"
                    @input="nitVerificado = false"
                    type="text"
                    class="form-control"
                    placeholder="Ej: 1234567"
                  />
                  <button
                    class="btn btn-outline-primary btn-sm"
                    type="button"
                    @click="verificarNitManual"
                    :disabled="cargandoVerificacionNit || !nitReceptor.trim()"
                  >
                    <span v-if="cargandoVerificacionNit" class="spinner-border spinner-border-sm"></span>
                    <span v-else>Verificar</span>
                  </button>
                </div>
                <small v-if="nitVerificado" class="text-success">
                  <i class="bi bi-check-circle-fill me-1"></i>NIT verificado
                </small>
                <small v-else-if="nitReceptor.trim()" class="text-warning">
                  <i class="bi bi-exclamation-triangle me-1"></i>Debes verificar el NIT antes de pagar
                </small>
              </div>
              <div v-if="requiereFactura" class="mb-3">
                <label class="form-label fw-semibold">Nombre del Receptor</label>
                <input v-model="nombreReceptor" type="text" class="form-control" placeholder="Nombre completo" />
              </div>
              <div v-if="generarFactura && !requiereFactura" class="alert alert-secondary py-2 mb-3">
                <small>🧾 Factura: <strong>Consumidor Final (CF)</strong></small>
              </div>
              <div v-if="generarFactura" class="mb-3">
                <label class="form-label fw-semibold">Dirección (opcional)</label>
                <input v-model="direccionReceptor" type="text" class="form-control" placeholder="Ciudad" />
              </div>

              <!-- Extranjero (sin FEL) -->
              <div v-if="!generarFactura" class="mb-3">
                <div class="form-check">
                  <input id="checkExtranjero" v-model="esExtranjero" type="checkbox" class="form-check-input" />
                  <label class="form-check-label" for="checkExtranjero">
                    🌍 Cliente extranjero (factura externa)
                  </label>
                </div>
                <div v-if="esExtranjero" class="mt-2">
                  <label class="form-label small fw-semibold">Número de Factura (Opcional)</label>
                  <input
                    v-model="numeroFacturaManual"
                    type="text"
                    class="form-control form-control-sm"
                    placeholder="Ej: A-001-00123456"
                    maxlength="50"
                  />
                  <small class="text-muted d-block mt-1">Factura generada fuera del sistema, solo para referencia</small>
                </div>
              </div>

              <!-- Opciones FEL: descripción personalizada / Otros servicios -->
              <div v-if="generarFactura" class="mb-2 form-check">
                <input
                  id="checkDetalladoHotel"
                  v-model="descripcionDetalladaHotel"
                  @change="onDetalladoHotelChange"
                  type="checkbox"
                  class="form-check-input"
                  :disabled="otroServicioHotel || otroServicioTodo || !hayHospedajeSeleccionado"
                />
                <label
                  class="form-check-label"
                  :class="{ 'text-muted': otroServicioHotel || otroServicioTodo || !hayHospedajeSeleccionado }"
                  for="checkDetalladoHotel"
                >
                  Detallar hospedaje en factura (descripción, cantidad y precio unitario)
                </label>
              </div>
              <div v-if="generarFactura && descripcionDetalladaHotel && hayHospedajeSeleccionado" class="mb-3">
                <EditorLineasFactura
                  :total-objetivo="totalDetalleHospedaje"
                  :descripcion-sugerida="`Hospedaje Hab. ${habitacionSeleccionada?.habitacion?.Numero || ''}`.trim()"
                  etiqueta="hospedaje"
                  placeholder-descripcion="Ej: Noches habitación doble"
                  v-model="lineasDetalleHotel"
                  @update:valido="lineasDetalleHotelValidas = $event"
                />
              </div>
              <div v-if="generarFactura" class="mb-2 form-check">
                <input
                  id="checkOtroServicioHotel"
                  v-model="otroServicioHotel"
                  @change="onOtroServicioHotelChange"
                  type="checkbox"
                  class="form-check-input"
                  :disabled="descripcionDetalladaHotel || otroServicioTodo || (!hayHospedajeSeleccionado && !hayServicioSeleccionado)"
                />
                <label
                  class="form-check-label"
                  :class="{ 'text-muted': descripcionDetalladaHotel || otroServicioTodo || (!hayHospedajeSeleccionado && !hayServicioSeleccionado) }"
                  for="checkOtroServicioHotel"
                >
                  Facturar hospedaje como Otros servicios (solo IVA)
                </label>
              </div>
              <div v-if="generarFactura" class="mb-2 form-check">
                <input
                  id="checkDetalladoRest"
                  v-model="descripcionDetalladaRestaurante"
                  @change="onDetalladoRestauranteChange"
                  type="checkbox"
                  class="form-check-input"
                  :disabled="otroServicioRestaurante || otroServicioTodo || !hayCuentaSeleccionada"
                />
                <label
                  class="form-check-label"
                  :class="{ 'text-muted': otroServicioRestaurante || otroServicioTodo || !hayCuentaSeleccionada }"
                  for="checkDetalladoRest"
                >
                  Detallar restaurante en factura (descripción, cantidad y precio unitario)
                </label>
              </div>
              <div v-if="generarFactura && descripcionDetalladaRestaurante && hayCuentaSeleccionada" class="mb-3">
                <EditorLineasFactura
                  :total-objetivo="totalDetalleCuentas"
                  descripcion-sugerida="Consumo Restaurante"
                  etiqueta="restaurante"
                  v-model="lineasDetalleRestaurante"
                  @update:valido="lineasDetalleRestauranteValidas = $event"
                />
              </div>
              <div v-if="generarFactura" class="mb-2 form-check">
                <input
                  id="checkOtroServicioRest"
                  v-model="otroServicioRestaurante"
                  @change="onOtroServicioRestauranteChange"
                  type="checkbox"
                  class="form-check-input"
                  :disabled="descripcionDetalladaRestaurante || otroServicioTodo || !hayCuentaSeleccionada"
                />
                <label
                  class="form-check-label"
                  :class="{ 'text-muted': descripcionDetalladaRestaurante || otroServicioTodo || !hayCuentaSeleccionada }"
                  for="checkOtroServicioRest"
                >
                  Facturar restaurante como Otros servicios (solo IVA)
                </label>
              </div>
              <div v-if="generarFactura && hayCuentaSeleccionada && hayHospedajeSeleccionado" class="mb-3 form-check">
                <input
                  id="checkOtroServicioTodo"
                  v-model="otroServicioTodo"
                  @change="onOtroServicioTodoChange"
                  type="checkbox"
                  class="form-check-input"
                  :disabled="descripcionDetalladaHotel || descripcionDetalladaRestaurante"
                />
                <label
                  class="form-check-label"
                  :class="{ 'text-muted': descripcionDetalladaHotel || descripcionDetalladaRestaurante }"
                  for="checkOtroServicioTodo"
                >
                  Facturar todo como Otros servicios (solo IVA)
                </label>
              </div>

              <!-- Método de pago (un solo método) -->
              <template v-if="!pagoCombinado">
                <div class="mb-3">
                  <label class="form-label fw-semibold">Método de Pago</label>
                  <select v-model="metodoPagoSeleccionado" class="form-select">
                    <option :value="null" disabled>Seleccione un método</option>
                    <option v-for="metodo in metodosPago" :key="metodo.IdMetodoPago" :value="metodo.IdMetodoPago">
                      {{ metodo.Metodo }}
                    </option>
                  </select>
                </div>

                <!-- Cuenta bancaria (método 2) -->
                <div v-if="metodoPagoSeleccionado === 2" class="mb-3">
                  <label class="form-label fw-semibold">Cuenta Bancaria</label>
                  <select v-model="cuentaBancariaSeleccionada" class="form-select">
                    <option :value="null" disabled>Seleccione una cuenta</option>
                    <option v-for="cuenta in cuentas" :key="cuenta.IdCuentaBancaria" :value="cuenta.IdCuentaBancaria">
                      {{ cuenta.Banco }} - {{ cuenta.NombreCuenta }} ({{ cuenta.NumeroCuenta }})
                    </option>
                  </select>
                </div>

                <!-- Efectivo recibido (solo método efectivo, para calcular cambio) -->
                <div v-if="esPagoEfectivo" class="mb-3">
                  <label class="form-label fw-semibold">Efectivo recibido (Q)</label>
                  <input
                    v-model.number="montoPago"
                    @input="onMontoPagoInput"
                    type="number"
                    step="0.01"
                    min="0.01"
                    class="form-control"
                    placeholder="Dejar igual si es el monto exacto"
                  />
                </div>

                <!-- Cambio -->
                <div v-if="cambioHotel > 0" class="alert alert-warning py-2 mb-3">
                  <div class="d-flex justify-content-between">
                    <span>💵 Efectivo recibido:</span>
                    <strong>Q{{ (montoPago || 0).toFixed(2) }}</strong>
                  </div>
                  <div class="d-flex justify-content-between border-top pt-1 mt-1">
                    <span>➡️ <strong>CAMBIO:</strong></span>
                    <strong class="fs-5">Q{{ cambioHotel.toFixed(2) }}</strong>
                  </div>
                </div>

                <!-- Número de referencia (métodos 2, 3, 4) -->
                <div
                  v-if="metodoPagoSeleccionado === 2 || metodoPagoSeleccionado === 3 || metodoPagoSeleccionado === 4"
                  class="mb-3"
                >
                  <label class="form-label fw-semibold">Número de Referencia</label>
                  <input v-model="numeroReferencia" type="text" class="form-control" placeholder="Referencia de transacción" />
                </div>
              </template>

              <!-- Pago Combinado: repartir el total entre varios métodos -->
              <div v-else class="mb-3">
                <label class="form-label fw-semibold">Métodos de Pago</label>
                <SelectorPagosCombinados
                  :total="totalSeleccionado"
                  :metodos-pago="metodosPago"
                  :cuentas-bancarias="cuentas"
                  v-model="pagosCombinados"
                  @update:valido="pagosCombinadosValidos = $event"
                />
              </div>
            </div>
            <div class="modal-footer">
              <button class="btn btn-secondary" @click="cerrarModalPago">Cancelar</button>
              <button
                v-if="!pagoCombinado"
                class="btn btn-success"
                @click="procesarPago"
                :disabled="
                  cargandoPago ||
                  !metodoPagoSeleccionado ||
                  totalSeleccionado <= 0 ||
                  (metodoPagoSeleccionado === 2 && !cuentaBancariaSeleccionada) ||
                  (requiereReferencia(metodoPagoSeleccionado) && !String(numeroReferencia).trim()) ||
                  (requiereFactura && !nitVerificado) ||
                  detalleFacturaInvalido
                "
              >
                <span v-if="cargandoPago" class="spinner-border spinner-border-sm me-2"></span>
                <span v-if="cargandoPago && requiereFactura">Generando factura...</span>
                <span v-else>Confirmar Pago Q{{ totalSeleccionado.toFixed(2) }}</span>
              </button>
              <button
                v-else
                class="btn btn-success"
                @click="procesarPagoCombinado"
                :disabled="cargandoPagoCombinado || !pagosCombinadosValidos || (requiereFactura && !nitVerificado) || detalleFacturaInvalido"
              >
                <span v-if="cargandoPagoCombinado" class="spinner-border spinner-border-sm me-2"></span>
                <span v-if="cargandoPagoCombinado">Generando factura...</span>
                <span v-else>Confirmar Pago Combinado Q{{ totalSeleccionado.toFixed(2) }}</span>
              </button>
            </div>
            <div v-if="(cargandoPago && requiereFactura) || cargandoPagoCombinado" class="text-center py-2 border-top">
              <small class="text-muted">
                <i class="bi bi-shield-check me-1 text-success"></i>
                Procesando factura electrónica con la SAT...
              </small>
            </div>
          </template>

        </div>
      </div>
    </div>

    <!-- Modal Restaurante -->
    <div
      v-if="modalRestauranteVisible"
      class="modal fade show d-block"
      tabindex="-1"
      style="background-color: rgba(0, 0, 0, 0.5)"
    >
      <div class="modal-dialog modal-dialog-centered modal-lg">
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title">
              <i class="bi bi-cup-straw me-2"></i>Consumos de Restaurante
            </h5>
            <button class="btn-close" @click="cerrarModalRestaurante"></button>
          </div>
          <div class="modal-body">
            <div
              v-for="(cuenta, idx) in habitacionSeleccionada?.cuentas_pedido"
              :key="cuenta.IdCuentaPedido"
              class="mb-3"
            >
              <h6 class="border-bottom pb-2 d-flex align-items-center flex-wrap gap-2">
                <span>{{ cuenta.NombreCuenta || "Cuenta " + (idx + 1) }}</span>
                <span
                  v-if="cuenta.IdPedido || cuenta.pedido?.IdPedido"
                  class="badge bg-secondary fw-normal"
                >
                  <i class="bi bi-receipt me-1"></i>Comanda #{{ cuenta.IdPedido || cuenta.pedido?.IdPedido }}
                </span>
                <span
                  v-if="cuenta.pedido?.FechaHora"
                  class="text-muted small"
                >
                  ({{ formatearFechaHora(cuenta.pedido.FechaHora) }})
                </span>
                <button
                  class="btn btn-sm btn-outline-warning ms-auto py-0 px-2"
                  @click="abrirModalCambiarHabitacionComanda(cuenta)"
                  title="Mover comanda a otra habitación"
                >
                  🔄 Cambiar habitación
                </button>
              </h6>
              <table class="table table-sm">
                <thead class="table-light">
                  <tr>
                    <th>Platillo</th>
                    <th class="text-center">Cant.</th>
                    <th class="text-end">Subtotal</th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="det in cuenta.detalles" :key="det.IdCuentaDetalle">
                    <td>
                      {{ det.detalle_pedido?.platillo?.Nombre || "Platillo" }}
                    </td>
                    <td class="text-center">{{ det.Cantidad }}</td>
                    <td class="text-end">
                      Q.{{ Number(det.Subtotal || 0).toFixed(2) }}
                    </td>
                  </tr>
                </tbody>
                <tfoot>
                  <tr>
                    <td colspan="2" class="text-end">
                      <strong>Subtotal:</strong>
                    </td>
                    <td class="text-end">
                      Q.{{ Number(cuenta.Subtotal || 0).toFixed(2) }}
                    </td>
                  </tr>
                  <tr>
                    <td colspan="3">
                      <div class="d-flex align-items-center flex-wrap gap-2">
                        <strong>Propina:</strong>
                        <span>Q.{{ Number(cuenta.Propina || 0).toFixed(2) }}</span>
                        <label class="switch mb-0">
                          <input
                            type="checkbox"
                            :checked="Number(cuenta.Propina) > 0"
                            @change="togglePropinaCuentaHabitacion(cuenta, $event.target.checked)"
                            :disabled="propinaCargando === cuenta.IdCuentaPedido || cuenta.Estado === 2 || cuenta.Estado === 3"
                          />
                          <span class="slider"></span>
                        </label>
                        <span class="small">{{ Number(cuenta.Propina) > 0 ? "Con propina" : "Sin propina" }}</span>
                        <div v-if="Number(cuenta.Propina) > 0" class="d-flex align-items-center gap-1">
                          <span class="small text-muted">Monto:</span>
                          <div class="input-group input-group-sm" style="width: 120px">
                            <span class="input-group-text px-1">Q</span>
                            <input
                              type="number"
                              class="form-control form-control-sm"
                              v-model.number="cuenta._propinaPersonalizada"
                              min="0.01"
                              step="0.01"
                              :disabled="propinaCargando === cuenta.IdCuentaPedido || cuenta.Estado === 2 || cuenta.Estado === 3"
                              placeholder="10% auto"
                              title="Dejar vacío para usar el 10% automático"
                              @blur="aplicarPropinaPersonalizadaHabitacion(cuenta)"
                              @keydown.enter.prevent="aplicarPropinaPersonalizadaHabitacion(cuenta)"
                            />
                          </div>
                        </div>
                        <span v-if="cuenta.Estado === 2 || cuenta.Estado === 3" class="badge bg-secondary">
                          Cuenta pagada/unificada — propina bloqueada
                        </span>
                      </div>
                    </td>
                  </tr>
                  <tr>
                    <td colspan="2" class="text-end">
                      <strong>Total:</strong>
                    </td>
                    <td class="text-end">
                      <strong
                        >Q.{{ Number(cuenta.Total || 0).toFixed(2) }}</strong
                      >
                    </td>
                  </tr>
                </tfoot>
              </table>
            </div>
          </div>
          <div class="modal-footer">
            <button class="btn btn-secondary" @click="cerrarModalRestaurante">
              Cerrar
            </button>
          </div>
        </div>
      </div>
    </div>

    <!-- Modal Cambiar Habitación de Comanda -->
    <div
      v-if="mostrarModalCambiarHabitacionComanda"
      class="modal fade show d-block"
      tabindex="-1"
      style="background-color: rgba(0,0,0,0.6); z-index: 1060"
    >
      <div class="modal-dialog modal-dialog-centered">
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title">🔄 Cambiar Habitación de Comanda</h5>
            <button class="btn-close" @click="cerrarModalCambiarHabitacionComanda"></button>
          </div>
          <div class="modal-body">
            <div class="alert alert-info py-2 small mb-3">
              <strong>Comanda:</strong> {{ cuentaCambiandoHabitacion?.NombreCuenta }}<br />
              <strong>Total:</strong> Q{{ Number(cuentaCambiandoHabitacion?.Total || 0).toFixed(2) }}
            </div>
            <p class="text-muted small mb-2">
              Busque la nueva reserva a la que se moverá esta comanda. Los saldos de ambas habitaciones se actualizarán automáticamente.
            </p>
            <label class="form-label fw-semibold small">Buscar reserva</label>
            <input
              v-model="busquedaReservaCambioComanda"
              class="form-control mb-2"
              placeholder="Código de reserva, nombre o habitación"
              @input="debouncedBuscarReservaCambioComanda"
            />
            <ul
              v-if="reservasCambioComanda.length"
              class="list-group mt-1"
            >
              <li
                v-for="res in reservasCambioComanda"
                :key="res.IdReserva"
                class="list-group-item p-2"
              >
                <div class="fw-semibold small mb-1">
                  R00{{ res.IdReserva }} — {{ res.huesped?.Nombre }} {{ res.huesped?.Apellido }}
                </div>
                <ul
                  v-if="Array.isArray(res.habitaciones_info) && res.habitaciones_info.length"
                  class="list-group ms-2"
                >
                  <li
                    v-for="hab in res.habitaciones_info"
                    :key="hab.IdReservaHabitacion"
                    class="list-group-item list-group-item-action py-1 small"
                    :class="{ active: habitacionCambioComanda?.IdReservaHabitacion === hab.IdReservaHabitacion }"
                    @click="seleccionarHabitacionCambioComanda(res, hab)"
                    role="button"
                  >
                    🛏️ Habitación {{ hab.Numero }}
                  </li>
                </ul>
              </li>
            </ul>
            <div v-if="habitacionCambioComanda" class="alert alert-success mt-3 small">
              ✅ Se moverá a: Habitación <strong>{{ habitacionCambioComanda.Numero }}</strong>
            </div>
          </div>
          <div class="modal-footer">
            <button
              class="btn btn-secondary"
              @click="cerrarModalCambiarHabitacionComanda"
              :disabled="cargandoCambioHabitacionComanda"
            >Cancelar</button>
            <button
              class="btn btn-warning"
              @click="confirmarCambioHabitacionComanda"
              :disabled="!habitacionCambioComanda || cargandoCambioHabitacionComanda"
            >
              <span v-if="cargandoCambioHabitacionComanda" class="spinner-border spinner-border-sm me-2"></span>
              Confirmar Cambio
            </button>
          </div>
        </div>
      </div>
    </div>

    <!-- Modal Servicios Extra -->
    <div
      v-if="modalServiciosExtraVisible"
      class="modal fade show d-block"
      tabindex="-1"
      style="background-color: rgba(0, 0, 0, 0.5)"
    >
      <div class="modal-dialog modal-dialog-centered">
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title">
              <i class="bi bi-basket me-2"></i>Servicios Extra
            </h5>
            <button
              class="btn-close"
              @click="cerrarModalServiciosExtra"
            ></button>
          </div>
          <div class="modal-body">
            <table class="table table-sm">
              <thead class="table-light">
                <tr>
                  <th>Servicio</th>
                  <th class="text-center">Cant.</th>
                  <th class="text-center">Fecha/Hora</th>
                  <th class="text-end">Total</th>
                </tr>
              </thead>
              <tbody>
                <template
                  v-for="servicio in habitacionSeleccionada?.servicios_extra"
                  :key="servicio.IdServicioExtraTotal"
                >
                  <tr
                    v-for="det in servicio.detalles"
                    :key="det.DetalleServicioExtra"
                  >
                    <td>{{ det.servicios_extras?.Nombre || "Servicio" }}</td>
                    <td class="text-center">{{ det.Cantidad }}</td>
                    <td class="text-center">
                      {{
                        formatearFechaHora(
                          servicio.FechaHora || servicio.FechaVentaServicio,
                        )
                      }}
                    </td>
                    <td class="text-end">
                      Q.{{ Number(servicio.Total || 0).toFixed(2) }}
                    </td>
                  </tr>
                </template>
              </tbody>
              <tfoot>
                <tr>
                  <td colspan="3" class="text-end">
                    <strong>Total Servicios:</strong>
                  </td>
                  <td class="text-end">
                    <strong
                      >Q.{{
                        Number(
                          habitacionSeleccionada?.TotalServiciosExtra || 0,
                        ).toFixed(2)
                      }}</strong
                    >
                  </td>
                </tr>
              </tfoot>
            </table>
          </div>
          <div class="modal-footer">
            <button
              class="btn btn-secondary"
              @click="cerrarModalServiciosExtra"
            >
              Cerrar
            </button>
          </div>
        </div>
      </div>
    </div>

    <!-- Modal Agregar Servicio Extra a Habitación -->
    <div
      v-if="modalAgregarServicioExtraVisible"
      class="modal fade show d-block"
      tabindex="-1"
      style="background-color: rgba(0, 0, 0, 0.5)"
    >
      <div class="modal-dialog modal-lg modal-dialog-centered">
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title">
              <i class="bi bi-basket me-2"></i>Agregar Servicio Extra a
              Habitación {{ habitacionSeleccionada?.habitacion?.Numero }}
            </h5>
            <button
              class="btn-close"
              @click="cerrarModalAgregarServicioExtra"
            ></button>
          </div>
          <div class="modal-body">
            <!-- Buscador de servicios -->
            <div class="mb-3">
              <input
                type="text"
                class="form-control"
                placeholder="Buscar servicio por nombre..."
                v-model="busquedaServicioExtra"
              />
            </div>

            <!-- Servicios -->
            <div class="mb-3" style="max-height: 220px; overflow-y: auto">
              <div v-if="serviciosExtraFiltrados.length" class="row g-2">
                <div
                  class="col-md-4"
                  v-for="serv in serviciosExtraFiltrados"
                  :key="serv.IdServicio"
                >
                  <div
                    class="border p-2 rounded d-flex justify-content-between align-items-center"
                  >
                    <span class="small"
                      >{{ serv.Nombre }} (Q{{
                        Number(serv.precio).toFixed(2)
                      }})</span
                    >
                    <button
                      class="btn btn-sm btn-outline-primary"
                      @click="agregarServicioExtraAlCarrito(serv)"
                    >
                      +
                    </button>
                  </div>
                </div>
              </div>
              <p
                v-else-if="serviciosExtraResultados.length === 0"
                class="text-muted text-center small py-2"
              >
                Cargando servicios...
              </p>
              <p v-else class="text-muted text-center small py-2">
                Sin resultados para "{{ busquedaServicioExtra }}"
              </p>
            </div>

            <!-- Carrito de servicios a agregar -->
            <div v-if="carritoServiciosExtra.length" class="table-responsive">
              <table
                class="table table-sm table-bordered align-middle text-center"
              >
                <thead class="table-light">
                  <tr>
                    <th>Servicio</th>
                    <th>Precio</th>
                    <th style="width: 80px">Cant.</th>
                    <th>Total</th>
                    <th style="width: 50px"></th>
                  </tr>
                </thead>
                <tbody>
                  <tr
                    v-for="(item, idx) in carritoServiciosExtra"
                    :key="item.IdServicio"
                  >
                    <td class="text-start">{{ item.Nombre }}</td>
                    <td>Q{{ Number(item.precio).toFixed(2) }}</td>
                    <td>
                      <input
                        type="number"
                        v-model.number="item.cantidad"
                        class="form-control form-control-sm text-center"
                        min="1"
                      />
                    </td>
                    <td>Q{{ (item.cantidad * item.precio).toFixed(2) }}</td>
                    <td>
                      <button
                        class="btn btn-sm btn-danger py-0 px-1"
                        @click="carritoServiciosExtra.splice(idx, 1)"
                      >
                        ✕
                      </button>
                    </td>
                  </tr>
                </tbody>
                <tfoot>
                  <tr>
                    <th colspan="3" class="text-end">Total:</th>
                    <th colspan="2">
                      Q{{ totalCarritoServiciosExtra.toFixed(2) }}
                    </th>
                  </tr>
                </tfoot>
              </table>
            </div>
            <div v-else class="text-muted text-center py-3">
              Seleccione servicios de la lista
            </div>
          </div>
          <div class="modal-footer">
            <button
              class="btn btn-secondary"
              @click="cerrarModalAgregarServicioExtra"
            >
              Cancelar
            </button>
            <button
              class="btn btn-success"
              @click="confirmarAgregarServiciosExtra"
              :disabled="
                !carritoServiciosExtra.length || cargandoAgregarServicio
              "
            >
              <span
                v-if="cargandoAgregarServicio"
                class="spinner-border spinner-border-sm me-1"
              ></span>
              Cargar a Habitación (Q{{ totalCarritoServiciosExtra.toFixed(2) }})
            </button>
          </div>
        </div>
      </div>
    </div>

    <!-- Modal Lista de Pagos -->
    <div
      v-if="mostrarModalPagos"
      class="modal fade show d-block"
      tabindex="-1"
      style="background-color: rgba(0, 0, 0, 0.5)"
    >
      <div class="modal-dialog modal-lg modal-dialog-centered">
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title">💰 Pagos Realizados</h5>
            <button class="btn-close" @click="cerrarModalPagos"></button>
          </div>
          <div class="modal-body">
            <div v-if="pagosHabitacion.length" class="table-responsive">
              <table class="table table-striped table-bordered align-middle">
                <thead class="bg-light">
                  <tr>
                    <th>Fecha</th>
                    <th>Método</th>
                    <th>Monto</th>
                    <th>Referencia</th>
                    <th>Estado</th>
                    <th>Acciones</th>
                  </tr>
                </thead>
                <tbody>
                  <tr
                    v-for="pago in pagosHabitacion"
                    :key="pago.IdPagoHospedajeHotel"
                  >
                    <td>{{ formatearFechaHora(pago.FechaHora) }}</td>
                    <td>
                      {{ pago.metodo_pago?.Metodo || "N/A" }}
                      <small
                        v-if="pago.cuenta_bancaria"
                        class="d-block text-muted"
                      >
                        {{ pago.cuenta_bancaria.NombreCuenta }} -
                        {{ pago.cuenta_bancaria.Banco }} -
                        {{ pago.cuenta_bancaria.NumeroCuenta }}
                      </small>
                    </td>
                    <td>Q{{ parseFloat(pago.Monto).toFixed(2) }}</td>
                    <td>{{ pago.NumeroReferencia || "-" }}</td>
                    <td>
                      <span
                        :class="
                          pago.Anulado === 1
                            ? 'badge bg-danger'
                            : 'badge bg-success'
                        "
                      >
                        {{ pago.Anulado === 1 ? "Anulado" : "Activo" }}
                      </span>
                    </td>
                    <td>
                      <div v-if="pago.factura_fel?.uuid" class="btn-group me-1">
                        <button
                          class="btn btn-outline-warning btn-sm"
                          @click="imprimirFacturaCarta(pago.factura_fel.uuid)"
                          title="Imprimir factura en hoja carta"
                        >
                          📝 Factura
                        </button>
                        <button
                          class="btn btn-outline-warning btn-sm"
                          @click="descargarFacturaCarta(pago.factura_fel.uuid)"
                          title="Descargar factura carta (PDF)"
                        >
                          <i class="bx bxs-download"></i>
                        </button>
                      </div>
                      <div v-if="pago.factura_fel?.uuid" class="btn-group me-1">
                        <button
                          class="btn btn-outline-success btn-sm"
                          @click="imprimirPdfFel(pago.factura_fel.uuid)"
                          title="Reimprimir factura electrónica (TotalDoc)"
                        >
                          📄 Cert.
                        </button>
                        <button
                          class="btn btn-outline-success btn-sm"
                          @click="descargarPdfFel(pago.factura_fel.uuid)"
                          title="Descargar PDF del certificador"
                        >
                          <i class="bx bxs-download"></i>
                        </button>
                      </div>
                      <div v-if="pago.factura_fel?.uuid" class="btn-group me-1">
                        <button
                          class="btn btn-outline-secondary btn-sm"
                          @click="imprimirTicketTermica(pago.factura_fel.uuid)"
                          title="Imprimir ticket térmico 80mm"
                        >
                          🧾 Térmica
                        </button>
                        <button
                          class="btn btn-outline-secondary btn-sm"
                          @click="descargarTicketTermica(pago.factura_fel.uuid)"
                          title="Descargar ticket térmico (PDF)"
                        >
                          <i class="bx bxs-download"></i>
                        </button>
                      </div>
                      <button
                        class="btn btn-outline-primary btn-sm me-1"
                        @click="imprimirPago(pago)"
                        title="Imprimir comprobante"
                      >
                        🖨️ Recibo
                      </button>
                      <button
                        v-if="
                          pago.Anulado === 0 &&
                          !pago.factura_fel &&
                          pago.metodo_pago?.UsoMetodo === 2 &&
                          !pago.cuenta_bancaria
                        "
                        class="btn btn-outline-success btn-sm me-1"
                        @click="abrirModalReemitir(pago)"
                        title="Generar factura electrónica para este pago"
                      >
                        🧾 Generar Factura
                      </button>
                      <button
                        v-if="pago.Anulado === 0"
                        class="btn btn-outline-danger btn-sm"
                        @click="confirmarAnularPago(pago)"
                        :disabled="cargandoPago"
                      >
                        ❌ Cancelar pago
                      </button>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
            <div v-else class="text-center text-muted py-3">
              No hay pagos registrados para esta habitación.
            </div>

            <!-- Resumen de pagos totales si hay múltiples habitaciones -->
            <div v-if="habitaciones.length > 1" class="mt-3 pt-3 border-top">
              <h6 class="text-muted">Resumen de toda la reserva:</h6>
              <div class="row">
                <div class="col-md-6">
                  <p class="mb-1">
                    <strong>Total Consumido:</strong> Q{{
                      calcularTotalConsumidoReserva().toFixed(2)
                    }}
                  </p>
                  <p class="mb-1">
                    <strong>Total Pagado:</strong> Q{{
                      calcularTotalPagadoReserva().toFixed(2)
                    }}
                  </p>
                </div>
                <div class="col-md-6">
                  <p class="mb-1">
                    <strong>Saldo Pendiente:</strong> Q{{
                      Number(saldoTotalPendiente).toFixed(2)
                    }}
                  </p>
                  <p class="mb-1">
                    <strong>Habitaciones:</strong> {{ habitaciones.length }}
                  </p>
                </div>
              </div>
            </div>
          </div>
          <div class="modal-footer">
            <button
              v-if="habitaciones.length > 1"
              class="btn btn-primary me-auto"
              @click="imprimirResumenTodosPagos"
            >
              <i class="bi bi-printer me-1"></i> Imprimir Resumen Total
            </button>
            <button class="btn btn-secondary" @click="cerrarModalPagos">
              Cerrar
            </button>
          </div>
        </div>
      </div>
    </div>

    <!-- Modal Confirmación Cancelar Pago -->
    <div
      v-if="mostrarConfirmacionAnular"
      class="modal fade show d-block"
      tabindex="-1"
      style="background-color: rgba(0, 0, 0, 0.6)"
    >
      <div class="modal-dialog modal-dialog-centered">
        <div class="modal-content">
          <div class="modal-header bg-danger text-white">
            <h5 class="modal-title">⚠️ Cancelar Pago</h5>
            <button
              class="btn-close btn-close-white"
              @click="cancelarAnulacion"
            ></button>
          </div>
          <div class="modal-body">
            <div v-if="pagoAAnular" class="alert alert-warning mb-3">
              <strong>Pago a cancelar:</strong><br />
              Monto:
              <span class="fw-bold"
                >Q{{ parseFloat(pagoAAnular.Monto).toFixed(2) }}</span
              ><br />
              Método: {{ pagoAAnular.metodo_pago?.Metodo || "N/A" }}<br />
              Fecha: {{ formatearFechaHora(pagoAAnular.FechaHora) }}
            </div>
            <p class="mb-2 fw-semibold">Esta acción realizará lo siguiente:</p>
            <ul class="text-muted small mb-0">
              <li>
                Se cancelará el pago y se restaurará el saldo pendiente de la
                habitación.
              </li>
              <li>El pago será eliminado de los registros contables.</li>
              <li v-if="pagoAAnular && pagoAAnular.factura_fel">
                La factura electrónica asociada será removida de los reportes.
              </li>
            </ul>
            <p class="text-danger small mt-2 mb-0">
              <strong>Esta acción no se puede deshacer.</strong>
            </p>
          </div>
          <div class="modal-footer justify-content-center">
            <button class="btn btn-secondary" @click="cancelarAnulacion">
              No, mantener pago
            </button>
            <button
              class="btn btn-danger"
              @click="anularPago"
              :disabled="cargandoPago"
            >
              <span
                v-if="cargandoPago"
                class="spinner-border spinner-border-sm me-2"
              ></span>
              Sí, cancelar pago
            </button>
          </div>
        </div>
      </div>
    </div>

    <!-- Modal Re-emitir FEL -->
    <div
      v-if="mostrarModalReemitir"
      class="modal fade show d-block"
      tabindex="-1"
      style="background-color: rgba(0, 0, 0, 0.5)"
    >
      <div class="modal-dialog modal-dialog-centered">
        <div class="modal-content">
          <div class="modal-header bg-warning text-dark">
            <h5 class="modal-title">🔄 Re-emitir Factura Electrónica</h5>
            <button class="btn-close" @click="cerrarModalReemitir"></button>
          </div>
          <div class="modal-body">
            <p class="text-muted small mb-3">
              Se generará una nueva factura FEL para el pago de
              <strong
                >Q{{ parseFloat(reemitirPago?.Monto || 0).toFixed(2) }}</strong
              >. Deje en blanco para emitir a Consumidor Final (CF).
            </p>
            <div class="mb-3">
              <label class="form-label fw-semibold">NIT del receptor</label>
              <input
                v-model="reemitirNit"
                type="text"
                class="form-control"
                placeholder="CF (Consumidor Final)"
              />
            </div>
            <div class="mb-3">
              <label class="form-label fw-semibold">Nombre del receptor</label>
              <input
                v-model="reemitirNombre"
                type="text"
                class="form-control"
                placeholder="Consumidor Final"
              />
            </div>
          </div>
          <div class="modal-footer justify-content-center">
            <button
              class="btn btn-secondary"
              @click="cerrarModalReemitir"
              :disabled="cargandoReemitir"
            >
              Cancelar
            </button>
            <button
              class="btn btn-warning"
              @click="reemitirFactura"
              :disabled="cargandoReemitir"
            >
              <span
                v-if="cargandoReemitir"
                class="spinner-border spinner-border-sm me-2"
              ></span>
              🔄 Re-emitir Factura
            </button>
          </div>
        </div>
      </div>
    </div>

    <!-- Modal Pago a Crédito (Hotel) -->
    <div
      v-if="mostrarModalCreditoHotel"
      class="modal fade show d-block"
      tabindex="-1"
      style="background-color: rgba(0, 0, 0, 0.5)"
    >
      <div class="modal-dialog modal-dialog-centered">
        <div class="modal-content">
          <div class="modal-header bg-warning text-dark">
            <h5 class="modal-title">📋 Registrar Pago a Crédito</h5>
            <button class="btn-close" @click="cerrarModalCreditoHotel"></button>
          </div>
          <div class="modal-body">
            <!-- Paso 1: ¿Con factura? -->
            <div v-if="creditoHotelPaso === 1" class="text-center">
              <p class="mb-4">¿Desea generar factura para este crédito?</p>
              <div class="d-flex justify-content-center gap-3">
                <button class="btn btn-success" @click="creditoConFactura = true; creditoHotelPaso = 2">
                  ✅ Sí, con factura
                </button>
                <button class="btn btn-secondary" @click="creditoConFactura = false; creditoHotelPaso = 3">
                  ❌ No, sin factura
                </button>
              </div>
            </div>

            <!-- Paso 2: ¿NIT o CF? -->
            <div v-else-if="creditoHotelPaso === 2" class="text-center">
              <p class="mb-4">¿La factura va a nombre de un NIT o Consumidor Final?</p>
              <div class="d-flex justify-content-center gap-3">
                <button class="btn btn-primary" @click="creditoConNit = true; creditoHotelPaso = 3">
                  🪦 Con NIT
                </button>
                <button class="btn btn-secondary" @click="creditoConNit = false; creditoHotelPaso = 3">
                  👤 Consumidor Final (CF)
                </button>
              </div>
              <div class="mt-3">
                <button class="btn btn-link btn-sm text-muted" @click="creditoHotelPaso = 1">← Volver</button>
              </div>
            </div>

            <!-- Paso 3: Formulario -->
            <div v-else-if="creditoHotelPaso === 3">
              <div class="alert alert-info">
                <strong>Monto a crédito:</strong> Q{{ parseFloat(habitacionSeleccionada?.SaldoPendienteHabitacion || 0).toFixed(2) }}
              </div>
              <p class="text-muted small mb-3">
                El saldo de la habitación quedará en cero. El crédito deberá ser cobrado antes de la fecha de vencimiento.
              </p>
              <!-- Nombre del cliente -->
              <div class="mb-3">
                <label class="form-label fw-semibold">Nombre del cliente</label>
                <input v-model="creditoHotelNombre" type="text" class="form-control" placeholder="Nombre completo" />
              </div>
              <!-- NIT: solo si eligió con factura y con NIT -->
              <div v-if="creditoConFactura && creditoConNit" class="mb-3">
                <label class="form-label fw-semibold">NIT <span class="text-danger">*</span></label>
                <div class="input-group">
                  <input
                    v-model="creditoHotelNit"
                    @input="creditoNitVerificado = false"
                    type="text"
                    class="form-control"
                    placeholder="ej: 7654321-0"
                  />
                  <button
                    class="btn btn-outline-primary btn-sm"
                    type="button"
                    @click="verificarNitCreditoHotel"
                    :disabled="cargandoVerificacionNitCredito || !creditoHotelNit.trim()"
                  >
                    <span v-if="cargandoVerificacionNitCredito" class="spinner-border spinner-border-sm"></span>
                    <span v-else>Verificar</span>
                  </button>
                </div>
                <small v-if="creditoNitVerificado" class="text-success">
                  <i class="bi bi-check-circle-fill me-1"></i>NIT verificado
                </small>
                <small v-else-if="creditoHotelNit.trim()" class="text-warning">
                  <i class="bi bi-exclamation-triangle me-1"></i>Debes verificar el NIT antes de continuar
                </small>
              </div>
              <!-- Dirección -->
              <div class="mb-3">
                <label class="form-label fw-semibold">Dirección (opcional)</label>
                <input v-model="creditoHotelDireccion" type="text" class="form-control" placeholder="Ciudad" />
              </div>
              <!-- Descripción -->
              <div class="mb-3">
                <label class="form-label fw-semibold">Descripción del gasto</label>
                <input v-model="creditoHotelDescripcion" type="text" class="form-control" placeholder="Ej: Hospedaje y consumos - Suite 101" />
                <small class="text-muted">Este texto aparecerá en la factura como descripción</small>
              </div>
              <!-- Opciones FEL (solo si es con factura) -->
              <div v-if="creditoConFactura" class="mb-3 form-check">
                <input
                  id="checkOtroServicioCredito"
                  v-model="creditoOtroServicio"
                  type="checkbox"
                  class="form-check-input"
                />
                <label class="form-check-label" for="checkOtroServicioCredito">
                  Facturar como Otros servicios (solo IVA)
                </label>
              </div>
              <!-- Fecha vencimiento -->
              <div class="mb-3">
                <label class="form-label fw-semibold">
                  Fecha de vencimiento <span class="text-danger">*</span>
                </label>
                <input
                  v-model="creditoHotelFechaVencimiento"
                  type="date"
                  class="form-control"
                  :min="fechaMinimaCreditoHotel"
                />
                <small class="text-muted">Debe ser una fecha futura.</small>
              </div>
              <div class="mt-3">
                <button class="btn btn-link btn-sm text-muted" @click="creditoHotelPaso = creditoConFactura ? 2 : 1">← Volver</button>
              </div>
            </div>
          </div>
          <div class="modal-footer">
            <button
              class="btn btn-secondary"
              @click="cerrarModalCreditoHotel"
              :disabled="cargandoCreditoHotel"
            >
              Cancelar
            </button>
            <button
              v-if="creditoHotelPaso === 3"
              class="btn btn-warning"
              @click="procesarPagoCreditoHotel"
              :disabled="cargandoCreditoHotel || !creditoHotelFechaVencimiento || (creditoConFactura && creditoConNit && (!creditoHotelNit || !creditoNitVerificado))"
            >
              <span v-if="cargandoCreditoHotel" class="spinner-border spinner-border-sm me-2"></span>
              Registrar Crédito
            </button>
          </div>
        </div>
      </div>
    </div>

    <!-- Modal Aplicar Descuento -->
    <div
      v-if="modalDescuentoVisible"
      class="modal fade show d-block"
      tabindex="-1"
      style="background-color: rgba(0, 0, 0, 0.5)"
    >
      <div class="modal-dialog modal-dialog-centered">
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title">Aplicar Código de Descuento</h5>
            <button class="btn-close" @click="cerrarModalDescuento"></button>
          </div>
          <div class="modal-body">
            <!-- Saldo pendiente -->
            <div class="alert alert-info">
              <strong>Saldo Pendiente:</strong> Q{{
                parseFloat(
                  habitacionSeleccionada?.SaldoPendienteHabitacion || 0,
                ).toFixed(2)
              }}
            </div>

            <!-- Código de descuento -->
            <div class="mb-3">
              <label class="form-label fw-semibold">Código de Descuento</label>
              <input
                v-model="codigoDescuento"
                type="text"
                class="form-control"
                placeholder="Ingrese el código de descuento"
                @keyup.enter="aplicarDescuento"
              />
            </div>
          </div>
          <div class="modal-footer">
            <button class="btn btn-secondary" @click="cerrarModalDescuento">
              Cancelar
            </button>
            <button
              class="btn btn-warning"
              @click="aplicarDescuento"
              :disabled="cargandoDescuento || !codigoDescuento"
            >
              <span
                v-if="cargandoDescuento"
                class="spinner-border spinner-border-sm me-2"
              ></span>
              Aplicar Descuento
            </button>
          </div>
        </div>
      </div>
    </div>

    <!-- Modal Quitar Descuento -->
    <div
      v-if="modalQuitarDescuentoVisible"
      class="modal fade show d-block"
      tabindex="-1"
      style="background-color: rgba(0, 0, 0, 0.5)"
    >
      <div class="modal-dialog modal-dialog-centered">
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title">Quitar Descuento</h5>
            <button
              class="btn-close"
              @click="modalQuitarDescuentoVisible = false"
            ></button>
          </div>
          <div class="modal-body">
            <p>
              ¿Está seguro de quitar el descuento aplicado a esta habitación?
              Se revertirá el siguiente monto al saldo pendiente:
            </p>
            <div class="alert alert-warning">
              <strong>Monto a revertir:</strong> Q{{
                Number(habitacionSeleccionada?.SaldoDescuento || 0).toFixed(2)
              }}
            </div>
          </div>
          <div class="modal-footer">
            <button
              class="btn btn-secondary"
              @click="modalQuitarDescuentoVisible = false"
            >
              Cancelar
            </button>
            <button
              class="btn btn-danger"
              @click="confirmarQuitarDescuento"
              :disabled="cargandoQuitarDescuento"
            >
              <span
                v-if="cargandoQuitarDescuento"
                class="spinner-border spinner-border-sm me-2"
              ></span>
              Quitar Descuento
            </button>
          </div>
        </div>
      </div>
    </div>

    <!-- Modal Pregunta Factura Reserva Completa -->
    <div
      v-if="mostrarModalFacturaReservaCompleta"
      class="modal fade show d-block"
      tabindex="-1"
      style="background-color: rgba(0, 0, 0, 0.5)"
    >
      <div class="modal-dialog modal-dialog-centered">
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title">🧾 Tipo de Pago - Toda la Reserva</h5>
            <button
              class="btn-close"
              @click="cerrarModalFacturaReservaCompleta"
            ></button>
          </div>
          <div class="modal-body text-center">
            <!-- Paso 1: ¿Necesita factura? -->
            <div v-if="pasoModalFacturaRC === 1">
              <p class="mb-4">¿Desea generar factura para este pago?</p>
              <div class="d-flex justify-content-center gap-3">
                <button class="btn btn-success" @click="avanzarANitOCfRC">
                  ✅ Sí, con factura
                </button>
                <button
                  class="btn btn-secondary"
                  @click="seleccionarSinFacturaRC"
                >
                  ❌ No, sin factura
                </button>
              </div>
            </div>
            <!-- Paso 2: ¿NIT o CF? -->
            <div v-else-if="pasoModalFacturaRC === 2">
              <p class="mb-4">
                ¿La factura va a nombre de un NIT o Consumidor Final?
              </p>
              <div class="d-flex justify-content-center gap-3">
                <button
                  class="btn btn-primary"
                  @click="seleccionarTipoFacturaReservaCompleta(true)"
                >
                  🪦 Con NIT
                </button>
                <button
                  class="btn btn-secondary"
                  @click="seleccionarTipoFacturaReservaCompleta(false)"
                >
                  👤 Consumidor Final (CF)
                </button>
              </div>
              <div class="mt-3">
                <button
                  class="btn btn-link btn-sm text-muted"
                  @click="pasoModalFacturaRC = 1"
                >
                  ← Volver
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- Modal Pago Reserva Completa -->
    <div
      v-if="modalPagoReservaCompletaVisible"
      class="modal fade show d-block"
      tabindex="-1"
      style="background-color: rgba(0, 0, 0, 0.5)"
    >
      <div class="modal-dialog modal-dialog-centered modal-lg">
        <div class="modal-content">

          <!-- ══ VISTA 1: Selección de Ítems RC ══ -->
          <template v-if="vistaPagoRC === 'seleccion'">
            <div class="modal-header">
              <div>
                <h5 class="modal-title">
                  <i class="bi bi-list-check me-2 text-primary"></i>Seleccionar Ítems a Cobrar
                </h5>
                <small class="text-muted">Toda la Reserva · Paso 1 de 2</small>
              </div>
              <button class="btn-close" @click="cerrarModalPagoReservaCompleta"></button>
            </div>
            <div class="modal-body p-0">
              <!-- Instrucciones -->
              <div class="alert alert-light border-start border-4 border-primary rounded-0 mb-0 py-2 px-3">
                <small class="text-muted">
                  <i class="bi bi-info-circle me-1 text-primary"></i>
                  <strong>Instrucciones:</strong> Marca los cargos a cobrar de todas las habitaciones. Para pago parcial, ajusta el monto en el campo Q.
                </small>
              </div>
              <!-- Controles y total -->
              <div class="px-3 py-2 border-bottom bg-light d-flex align-items-center justify-content-between flex-wrap gap-2">
                <div class="d-flex gap-2">
                  <button class="btn btn-outline-secondary btn-sm" @click="deseleccionarTodoRC">
                    <i class="bi bi-square me-1"></i>Ninguno
                  </button>
                  <button class="btn btn-outline-primary btn-sm" @click="seleccionarTodoRC">
                    <i class="bi bi-check-all me-1"></i>Todo
                  </button>
                </div>
                <div class="fw-bold text-success fs-5">
                  Q{{ totalSeleccionadoRC.toFixed(2) }}
                  <small class="text-muted fw-normal fs-6 ms-1">seleccionado</small>
                </div>
              </div>
              <!-- Pago Combinado: repartir el total entre varios métodos con una sola factura -->
              <div v-if="generarFacturaRC" class="px-3 py-2 border-bottom bg-light">
                <div class="form-check">
                  <input
                    id="checkPagoCombinadoRC"
                    v-model="pagoCombinadoRC"
                    type="checkbox"
                    class="form-check-input"
                  />
                  <label class="form-check-label fw-semibold" for="checkPagoCombinadoRC">
                    🧩 Pago Combinado: generar solo una factura repartida entre varios métodos de pago
                  </label>
                </div>
              </div>
              <!-- Lista agrupada por tipo -->
              <div class="p-3 d-flex flex-column gap-1" style="max-height: 55vh; overflow-y: auto">
                <div v-if="Object.keys(seleccionRC).length === 0" class="text-center text-muted py-4">
                  <i class="bi bi-check-circle fs-3 d-block mb-2 text-success"></i>
                  No hay ítems pendientes de pago
                </div>

                <!-- CONSUMOS DE RESTAURANTE -->
                <template v-if="seleccionRCCuentas.length">
                  <div class="d-flex align-items-center gap-2 mt-2 mb-1">
                    <i class="bi bi-cup-straw text-warning"></i>
                    <span class="small fw-bold text-uppercase text-secondary">Consumos de Restaurante</span>
                    <hr class="flex-grow-1 my-0">
                    <span class="badge bg-warning text-dark rounded-pill">{{ seleccionRCCuentas.length }}</span>
                  </div>
                  <div
                    v-for="[key, item] in seleccionRCCuentas"
                    :key="key"
                    class="border rounded-3 p-3 cursor-pointer"
                    :class="item.activo ? 'border-warning bg-warning bg-opacity-10' : 'opacity-50 bg-light'"
                    role="button"
                    @click="toggleSeleccionRC(key)"
                  >
                    <div class="d-flex align-items-center gap-3">
                      <input type="checkbox" class="form-check-input flex-shrink-0" style="width:20px;height:20px"
                        :checked="item.activo" @change.stop="toggleSeleccionRC(key)" @click.stop />
                      <div class="flex-grow-1 min-w-0">
                        <div class="fw-semibold">{{ item.label }}</div>
                        <small class="text-muted d-block">
                          <i class="bi bi-door-open me-1"></i>Hab. {{ item.habNumero }}
                          <span v-if="item.idPedido" class="ms-2">
                            <i class="bi bi-receipt me-1"></i>Comanda #{{ item.idPedido }}
                          </span>
                        </small>
                      </div>
                      <div class="text-end flex-shrink-0" @click.stop>
                        <template v-if="item.activo">
                          <div class="d-flex align-items-center gap-1">
                            <span class="text-muted small">Q</span>
                            <input type="number" step="0.01" min="0.01" :max="item.max"
                              v-model.number="item.monto" @change="clampMontoSeleccionRC(key)"
                              class="form-control form-control-sm text-end" style="width:90px" />
                          </div>
                          <small class="text-muted d-block text-end">máx Q{{ item.max.toFixed(2) }}</small>
                        </template>
                        <div v-else class="fw-bold text-muted">Q{{ item.max.toFixed(2) }}</div>
                      </div>
                    </div>
                  </div>
                </template>

                <!-- SERVICIOS EXTRA -->
                <template v-if="seleccionRCServicios.length">
                  <div class="d-flex align-items-center gap-2 mt-2 mb-1">
                    <i class="bi bi-star text-info"></i>
                    <span class="small fw-bold text-uppercase text-secondary">Servicios Extra</span>
                    <hr class="flex-grow-1 my-0">
                    <span class="badge bg-info rounded-pill">{{ seleccionRCServicios.length }}</span>
                  </div>
                  <div
                    v-for="[key, item] in seleccionRCServicios"
                    :key="key"
                    class="border rounded-3 p-3"
                    :class="item.activo ? 'border-info bg-info bg-opacity-10' : 'opacity-50 bg-light'"
                    role="button"
                    @click="toggleSeleccionRC(key)"
                  >
                    <div class="d-flex align-items-center gap-3">
                      <input type="checkbox" class="form-check-input flex-shrink-0" style="width:20px;height:20px"
                        :checked="item.activo" @change.stop="toggleSeleccionRC(key)" @click.stop />
                      <div class="flex-grow-1 min-w-0">
                        <div class="fw-semibold">{{ item.label }}</div>
                        <small class="text-muted">
                          <i class="bi bi-door-open me-1"></i>Hab. {{ item.habNumero }}
                        </small>
                      </div>
                      <div class="text-end flex-shrink-0" @click.stop>
                        <template v-if="item.activo">
                          <div class="d-flex align-items-center gap-1">
                            <span class="text-muted small">Q</span>
                            <input type="number" step="0.01" min="0.01" :max="item.max"
                              v-model.number="item.monto" @change="clampMontoSeleccionRC(key)"
                              class="form-control form-control-sm text-end" style="width:90px" />
                          </div>
                          <small class="text-muted d-block text-end">máx Q{{ item.max.toFixed(2) }}</small>
                        </template>
                        <div v-else class="fw-bold text-muted">Q{{ item.max.toFixed(2) }}</div>
                      </div>
                    </div>
                  </div>
                </template>

                <!-- HOSPEDAJE -->
                <template v-if="seleccionRCHospedaje.length">
                  <div class="d-flex align-items-center gap-2 mt-2 mb-1">
                    <i class="bi bi-house-fill text-primary"></i>
                    <span class="small fw-bold text-uppercase text-secondary">Hospedaje</span>
                    <hr class="flex-grow-1 my-0">
                    <span class="badge bg-primary rounded-pill">{{ seleccionRCHospedaje.length }}</span>
                  </div>
                  <div
                    v-for="[key, item] in seleccionRCHospedaje"
                    :key="key"
                    class="border rounded-3 p-3"
                    :class="item.activo ? 'border-primary bg-primary bg-opacity-10' : 'opacity-50 bg-light'"
                    role="button"
                    @click="toggleSeleccionRC(key)"
                  >
                    <div class="d-flex align-items-center gap-3">
                      <input type="checkbox" class="form-check-input flex-shrink-0" style="width:20px;height:20px"
                        :checked="item.activo" @change.stop="toggleSeleccionRC(key)" @click.stop />
                      <div class="flex-grow-1 min-w-0">
                        <div class="fw-semibold">{{ item.label }}</div>
                        <small class="text-muted">
                          <i class="bi bi-door-open me-1"></i>Hab. {{ item.habNumero }}
                        </small>
                      </div>
                      <div class="text-end flex-shrink-0" @click.stop>
                        <template v-if="item.activo">
                          <div class="d-flex align-items-center gap-1">
                            <span class="text-muted small">Q</span>
                            <input type="number" step="0.01" min="0.01" :max="item.max"
                              v-model.number="item.monto" @change="clampMontoSeleccionRC(key)"
                              class="form-control form-control-sm text-end" style="width:90px" />
                          </div>
                          <small class="text-muted d-block text-end">máx Q{{ item.max.toFixed(2) }}</small>
                        </template>
                        <div v-else class="fw-bold text-muted">Q{{ item.max.toFixed(2) }}</div>
                      </div>
                    </div>
                  </div>
                </template>
              </div>
            </div>
            <div class="modal-footer justify-content-between">
              <button class="btn btn-secondary" @click="cerrarModalPagoReservaCompleta">Cancelar</button>
              <button class="btn btn-primary" @click="irAPagoRC" :disabled="!puedeIrAPagoRC">
                Continuar <i class="bi bi-arrow-right ms-1"></i> Q{{ totalSeleccionadoRC.toFixed(2) }}
              </button>
            </div>
          </template>

          <!-- ══ VISTA 2: Formulario de Pago RC ══ -->
          <template v-else>
            <div class="modal-header">
              <div class="d-flex align-items-center gap-2">
                <button class="btn btn-sm btn-outline-secondary" @click="volverASeleccionRC">← Volver</button>
                <h5 class="modal-title mb-0">💰 Pagar Toda la Reserva</h5>
              </div>
              <button class="btn-close" @click="cerrarModalPagoReservaCompleta"></button>
            </div>
            <div class="modal-body">
              <!-- Resumen de ítems seleccionados -->
              <div class="alert alert-info py-2 mb-3">
                <div class="d-flex justify-content-between align-items-center">
                  <strong>Total a pagar:</strong>
                  <span class="fs-5 fw-bold">Q{{ totalSeleccionadoRC.toFixed(2) }}</span>
                </div>
                <div class="small mt-1">
                  <div v-if="hayHospedajeRC" class="d-flex justify-content-between">
                    <span>Hospedaje:</span>
                    <span>Q{{ totalHospedajeRC.toFixed(2) }}</span>
                  </div>
                  <div v-if="hayCuentaRC" class="d-flex justify-content-between">
                    <span>Restaurante:</span>
                    <span class="text-warning fw-bold">Q{{ totalCuentasRC.toFixed(2) }}</span>
                  </div>
                  <div v-if="hayServicioRC" class="d-flex justify-content-between">
                    <span>Servicios:</span>
                    <span class="text-info fw-bold">Q{{ totalServiciosRC.toFixed(2) }}</span>
                  </div>
                </div>
              </div>

              <!-- Resumen de habitaciones -->
            <div class="alert alert-info p-2 mb-3">
              <h6 class="mb-2 px-1">
                <strong>Desglose por Habitación</strong>
              </h6>
              <table class="table table-sm mb-0 small">
                <thead>
                  <tr>
                    <th>Habitación</th>
                    <th class="text-end">Hospedaje</th>
                    <th class="text-end">Restaurante</th>
                    <th class="text-end">Extras</th>
                    <th class="text-end text-danger fw-bold">
                      Saldo Pendiente
                    </th>
                  </tr>
                </thead>
                <tbody>
                  <tr
                    v-for="hab in habitaciones"
                    :key="hab.IdReservaHabitacion"
                  >
                    <td>
                      Hab. {{ hab.habitacion?.Numero }}
                      <span v-if="hab.EstadoPago" class="badge bg-success ms-1"
                        >✓</span
                      >
                    </td>
                    <td class="text-end">
                      Q{{ Number(hab.TotalHabitacion || 0).toFixed(2) }}
                    </td>
                    <td class="text-end">
                      <span
                        :class="{
                          'text-warning fw-bold':
                            Number(
                              (hab.TotalRestaurantePendiente ??
                                hab.TotalRestaurante) ||
                                0,
                            ) > 0,
                        }"
                      >
                        Q{{
                          Number(
                            (hab.TotalRestaurantePendiente ??
                              hab.TotalRestaurante) ||
                              0,
                          ).toFixed(2)
                        }}
                      </span>
                    </td>
                    <td class="text-end">
                      <span
                        :class="{
                          'text-info fw-bold':
                            Number(hab.TotalServiciosExtra || 0) > 0,
                        }"
                      >
                        Q{{ Number(hab.TotalServiciosExtra || 0).toFixed(2) }}
                      </span>
                    </td>
                    <td class="text-end fw-bold text-danger">
                      Q{{
                        Number(hab.SaldoPendienteHabitacion || 0).toFixed(2)
                      }}
                    </td>
                  </tr>
                </tbody>
                <tfoot class="table-light">
                  <tr class="fw-bold">
                    <td>Totales:</td>
                    <td class="text-end">
                      Q{{ totalHospedajeReserva.toFixed(2) }}
                    </td>
                    <td class="text-end">
                      Q{{ totalRestauranteReserva.toFixed(2) }}
                    </td>
                    <td class="text-end">
                      Q{{ totalExtrasReserva.toFixed(2) }}
                    </td>
                    <td class="text-end text-danger fs-6">
                      Q{{ Number(saldoTotalPendiente).toFixed(2) }}
                    </td>
                  </tr>
                </tfoot>
              </table>
              <div class="text-muted small px-1 mt-1">
                <i class="bi bi-info-circle me-1"></i>
                "Saldo Pendiente" = total consumido menos pagos ya realizados.
                Es lo que se debe cobrar.
              </div>
            </div>

            <!-- Datos FEL receptor (reserva completa) -->
            <div v-if="tipoPagoReservaCompleta === 1" class="mb-3">
              <label class="form-label fw-semibold">NIT del Receptor</label>
              <div class="input-group">
                <input
                  v-model="nitReceptor"
                  @input="nitVerificado = false"
                  type="text"
                  class="form-control"
                  placeholder="Ej: 1234567"
                />
                <button
                  class="btn btn-outline-primary btn-sm"
                  type="button"
                  @click="verificarNitManual"
                  :disabled="cargandoVerificacionNit || !nitReceptor.trim()"
                >
                  <span
                    v-if="cargandoVerificacionNit"
                    class="spinner-border spinner-border-sm"
                  ></span>
                  <span v-else>Verificar</span>
                </button>
              </div>
              <small v-if="nitVerificado" class="text-success"
                ><i class="bi bi-check-circle-fill me-1"></i>NIT
                verificado</small
              >
              <small v-else-if="nitReceptor.trim()" class="text-warning"
                ><i class="bi bi-exclamation-triangle me-1"></i>Debes verificar
                el NIT antes de pagar</small
              >
            </div>
            <div v-if="tipoPagoReservaCompleta === 1" class="mb-3">
              <label class="form-label fw-semibold">Nombre del Receptor</label>
              <input
                v-model="nombreReceptor"
                type="text"
                class="form-control"
                placeholder="Nombre completo"
              />
            </div>
            <div
              v-if="generarFacturaRC && tipoPagoReservaCompleta === 2"
              class="alert alert-secondary py-2 mb-3"
            >
              <small>🧾 Factura: <strong>Consumidor Final (CF)</strong></small>
            </div>
            <div v-if="generarFacturaRC" class="mb-3">
              <label class="form-label fw-semibold">Dirección (opcional)</label>
              <input
                v-model="direccionReceptor"
                type="text"
                class="form-control"
                placeholder="Ciudad"
              />
            </div>

            <!-- Descripción detallada / Otros servicios -->
            <!-- Opciones de hospedaje: solo cuando NO es pago exclusivo de restaurante -->
            <template
              v-if="generarFacturaRC && conceptoPagoRC !== 'solo_restaurante'"
            >
              <div class="mb-2 form-check">
                <input
                  id="checkDetalladoHotelRC"
                  v-model="descripcionDetalladaHotel"
                  @change="onDetalladoHotelChange"
                  type="checkbox"
                  class="form-check-input"
                  :disabled="otroServicioHotel || otroServicioTodo || totalDetalleHospedajeRC <= 0"
                />
                <label
                  class="form-check-label"
                  :class="{
                    'text-muted': otroServicioHotel || otroServicioTodo || totalDetalleHospedajeRC <= 0,
                  }"
                  for="checkDetalladoHotelRC"
                >
                  Detallar hospedaje en factura (descripción, cantidad y precio unitario)
                </label>
              </div>
              <div v-if="descripcionDetalladaHotel && totalDetalleHospedajeRC > 0" class="mb-3">
                <EditorLineasFactura
                  :total-objetivo="totalDetalleHospedajeRC"
                  descripcion-sugerida="Hospedaje"
                  etiqueta="hospedaje"
                  placeholder-descripcion="Ej: Noches habitación doble"
                  v-model="lineasDetalleHotel"
                  @update:valido="lineasDetalleHotelValidas = $event"
                />
              </div>
              <div class="mb-2 form-check">
                <input
                  id="checkOtroServicioHotelRC"
                  v-model="otroServicioHotel"
                  @change="onOtroServicioHotelChange"
                  type="checkbox"
                  class="form-check-input"
                  :disabled="descripcionDetalladaHotel || otroServicioTodo"
                />
                <label
                  class="form-check-label"
                  :class="{
                    'text-muted': descripcionDetalladaHotel || otroServicioTodo,
                  }"
                  for="checkOtroServicioHotelRC"
                >
                  Facturar hospedaje como Otros servicios (solo IVA)
                </label>
              </div>
            </template>

            <!-- Opciones de restaurante: solo cuando NO es pago exclusivo de hospedaje -->
            <template
              v-if="generarFacturaRC && conceptoPagoRC !== 'solo_hospedaje'"
            >
              <div class="mb-2 form-check">
                <input
                  id="checkDetalladoRestRC"
                  v-model="descripcionDetalladaRestaurante"
                  @change="onDetalladoRestauranteChange"
                  type="checkbox"
                  class="form-check-input"
                  :disabled="otroServicioRestaurante || otroServicioTodo || totalDetalleCuentasRC <= 0"
                />
                <label
                  class="form-check-label"
                  :class="{
                    'text-muted': otroServicioRestaurante || otroServicioTodo || totalDetalleCuentasRC <= 0,
                  }"
                  for="checkDetalladoRestRC"
                >
                  Detallar restaurante en factura (descripción, cantidad y precio unitario)
                </label>
              </div>
              <div v-if="descripcionDetalladaRestaurante && totalDetalleCuentasRC > 0" class="mb-3">
                <EditorLineasFactura
                  :total-objetivo="totalDetalleCuentasRC"
                  descripcion-sugerida="Consumo Restaurante"
                  etiqueta="restaurante"
                  v-model="lineasDetalleRestaurante"
                  @update:valido="lineasDetalleRestauranteValidas = $event"
                />
              </div>
              <div class="mb-2 form-check">
                <input
                  id="checkOtroServicioRestRC"
                  v-model="otroServicioRestaurante"
                  @change="onOtroServicioRestauranteChange"
                  type="checkbox"
                  class="form-check-input"
                  :disabled="
                    descripcionDetalladaRestaurante || otroServicioTodo
                  "
                />
                <label
                  class="form-check-label"
                  :class="{
                    'text-muted':
                      descripcionDetalladaRestaurante || otroServicioTodo,
                  }"
                  for="checkOtroServicioRestRC"
                >
                  Facturar restaurante como Otros servicios (solo IVA)
                </label>
              </div>
            </template>

            <!-- "Facturar todo como Otros servicios": solo disponible cuando se paga todo -->
            <div
              v-if="
                generarFacturaRC &&
                tieneCargoRestauranteReserva &&
                conceptoPagoRC === 'todo'
              "
              class="mb-3 form-check"
            >
              <input
                id="checkOtroServicioTodoRC"
                v-model="otroServicioTodo"
                @change="onOtroServicioTodoChange"
                type="checkbox"
                class="form-check-input"
                :disabled="
                  descripcionDetalladaHotel || descripcionDetalladaRestaurante
                "
              />
              <label
                class="form-check-label"
                :class="{
                  'text-muted':
                    descripcionDetalladaHotel ||
                    descripcionDetalladaRestaurante,
                }"
                for="checkOtroServicioTodoRC"
              >
                Facturar todo como Otros servicios (solo IVA)
              </label>
            </div>

            <!-- Método de pago (un solo método) -->
            <template v-if="!pagoCombinadoRC">
              <div class="mb-3">
                <label class="form-label fw-semibold">Método de Pago</label>
                <select v-model="metodoPagoReservaCompleta" class="form-select">
                  <option :value="null" disabled>Seleccione un método</option>
                  <option
                    v-for="metodo in metodosPagoReservaCompleta"
                    :key="metodo.IdMetodoPago"
                    :value="metodo.IdMetodoPago"
                  >
                    {{ metodo.Metodo }}
                  </option>
                </select>
              </div>

              <!-- Cuenta Bancaria (solo si método es 2) -->
              <div v-if="metodoPagoReservaCompleta === 2" class="mb-3">
                <label class="form-label fw-semibold">Cuenta Bancaria</label>
                <select
                  v-model="cuentaBancariaReservaCompleta"
                  class="form-select"
                >
                  <option :value="null" disabled>Seleccione una cuenta</option>
                  <option
                    v-for="cuenta in cuentas"
                    :key="cuenta.IdCuentaBancaria"
                    :value="cuenta.IdCuentaBancaria"
                  >
                    {{ cuenta.Banco }} - {{ cuenta.NombreCuenta }} ({{
                      cuenta.NumeroCuenta
                    }})
                  </option>
                </select>
              </div>

              <!-- Monto -->
              <div class="mb-3">
                <label class="form-label fw-semibold">Monto a Pagar (Q)</label>
                <input
                  v-model.number="montoPagoReservaCompleta"
                  type="number"
                  step="0.01"
                  min="0.01"
                  class="form-control"
                  placeholder="Ingrese el monto"
                />
                <small class="text-muted"
                  >Ítems seleccionados: Q{{
                    totalSeleccionadoRC.toFixed(2)
                  }}</small
                >
              </div>

              <!-- Cambio -->
              <div
                v-if="cambioReservaCompleta > 0"
                class="alert alert-warning py-2 mb-3"
              >
                <div>
                  💵 Efectivo recibido:
                  <strong
                    >Q{{ Number(montoPagoReservaCompleta).toFixed(2) }}</strong
                  >
                </div>
                <div>
                  ➡️ <strong>CAMBIO:</strong>
                  <strong class="fs-5"
                    >Q{{ cambioReservaCompleta.toFixed(2) }}</strong
                  >
                </div>
              </div>

              <!-- Número de Referencia (solo si método es 2, 3 o 4) -->
              <div
                v-if="
                  metodoPagoReservaCompleta === 2 ||
                  metodoPagoReservaCompleta === 3 ||
                  metodoPagoReservaCompleta === 4
                "
                class="mb-3"
              >
                <label class="form-label fw-semibold">Número de Referencia</label>
                <input
                  v-model="numeroReferenciaReservaCompleta"
                  type="text"
                  class="form-control"
                  placeholder="Referencia de transacción"
                />
              </div>
            </template>

            <!-- Pago Combinado: repartir el total entre varios métodos -->
            <div v-else class="mb-3">
              <label class="form-label fw-semibold">Métodos de Pago</label>
              <SelectorPagosCombinados
                :total="totalSeleccionadoRC"
                :metodos-pago="metodosPagoReservaCompleta"
                :cuentas-bancarias="cuentas"
                v-model="pagosCombinadosRC"
                @update:valido="pagosCombinadosRCValidos = $event"
              />
            </div>
          </div>
          <div class="modal-footer">
            <button
              class="btn btn-secondary"
              @click="cerrarModalPagoReservaCompleta"
            >
              Cancelar
            </button>
            <button
              v-if="!pagoCombinadoRC"
              class="btn btn-success"
              @click="procesarPagoReservaCompleta"
              :disabled="
                cargandoPagoReservaCompleta ||
                !metodoPagoReservaCompleta ||
                !montoPagoReservaCompleta ||
                (metodoPagoReservaCompleta === 2 &&
                  !cuentaBancariaReservaCompleta) ||
                (requiereReferencia(metodoPagoReservaCompleta) &&
                  !String(numeroReferenciaReservaCompleta).trim()) ||
                (generarFacturaRC &&
                  tipoPagoReservaCompleta === 1 &&
                  !nitVerificado) ||
                detalleFacturaInvalidoRC
              "
            >
              <span
                v-if="cargandoPagoReservaCompleta"
                class="spinner-border spinner-border-sm me-2"
              ></span>
              <span
                v-if="
                  cargandoPagoReservaCompleta && tipoPagoReservaCompleta === 1
                "
                >Generando factura...</span
              >
              <span v-else>Confirmar Pago Total</span>
            </button>
            <button
              v-else
              class="btn btn-success"
              @click="procesarPagoCombinadoRC"
              :disabled="cargandoPagoCombinadoRC || !pagosCombinadosRCValidos || (tipoPagoReservaCompleta === 1 && !nitVerificado) || detalleFacturaInvalidoRC"
            >
              <span v-if="cargandoPagoCombinadoRC" class="spinner-border spinner-border-sm me-2"></span>
              <span v-if="cargandoPagoCombinadoRC">Generando factura...</span>
              <span v-else>Confirmar Pago Combinado Q{{ totalSeleccionadoRC.toFixed(2) }}</span>
            </button>
          </div>
          <div
            v-if="(cargandoPagoReservaCompleta && tipoPagoReservaCompleta === 1) || cargandoPagoCombinadoRC"
            class="text-center py-2 border-top"
          >
            <small class="text-muted">
              <i class="bi bi-shield-check me-1 text-success"></i>
              Procesando factura electrónica con la SAT...
            </small>
          </div>
          </template><!-- /vistaPagoRC pago -->

        </div><!-- /modal-content -->
      </div>
    </div>

    <!-- Modal Confirmación Checkout Reserva Completa -->
    <div
      v-if="modalCheckoutReservaCompletaVisible"
      class="modal fade show d-block"
      tabindex="-1"
      style="background-color: rgba(0, 0, 0, 0.6)"
    >
      <div class="modal-dialog modal-dialog-centered">
        <div class="modal-content">
          <div class="modal-header bg-danger text-white">
            <h5 class="modal-title">
              ⚠️ Confirmar Checkout de Toda la Reserva
            </h5>
            <button
              class="btn-close btn-close-white"
              @click="cerrarModalCheckoutReservaCompleta"
            ></button>
          </div>
          <div class="modal-body text-center">
            <p class="mb-3">
              ¿Está seguro de hacer checkout de todas las habitaciones de esta
              reserva?
            </p>
            <div class="alert alert-warning">
              <strong
                >Se realizará checkout de
                {{ habitacionesSinCheckout.length }} habitación(es):</strong
              >
              <ul class="list-unstyled mb-0 mt-2">
                <li
                  v-for="hab in habitacionesSinCheckout"
                  :key="hab.IdReservaHabitacion"
                >
                  <i class="bi bi-door-open me-1"></i> Habitación
                  {{ hab.habitacion?.Numero }}
                </li>
              </ul>
            </div>
            <p class="text-muted small">
              Esta acción marcará todas las habitaciones para limpieza y
              finalizará la reserva.
            </p>
          </div>
          <div class="modal-footer justify-content-center">
            <button
              class="btn btn-secondary"
              @click="cerrarModalCheckoutReservaCompleta"
            >
              Cancelar
            </button>
            <button
              class="btn btn-danger"
              @click="realizarCheckoutReservaCompleta"
              :disabled="cargandoCheckoutReservaCompleta"
            >
              <span
                v-if="cargandoCheckoutReservaCompleta"
                class="spinner-border spinner-border-sm me-2"
              ></span>
              Confirmar Checkout Total
            </button>
          </div>
        </div>
      </div>
    </div>

    <!-- Modal Revertir Checkout habitación -->
    <div
      v-if="modalRevertirCheckoutVisible"
      class="modal fade show d-block"
      tabindex="-1"
      style="background-color: rgba(0, 0, 0, 0.6)"
    >
      <div class="modal-dialog modal-dialog-centered">
        <div class="modal-content">
          <div class="modal-header bg-warning">
            <h5 class="modal-title">↩ Revertir Checkout</h5>
            <button
              class="btn-close"
              @click="modalRevertirCheckoutVisible = false"
            ></button>
          </div>
          <div class="modal-body text-center">
            <i
              class="bi bi-arrow-counterclockwise text-warning"
              style="font-size: 3rem"
            ></i>
            <p class="mt-3 mb-2">
              ¿Revertir el checkout de la Habitación
              <strong>{{ habitacionSeleccionada?.habitacion?.Numero }}</strong
              >?
            </p>
            <p class="text-muted small">
              La habitación volverá a estado Ocupada. Si es la única con
              checkout, la reserva volverá a Activo.
            </p>
          </div>
          <div class="modal-footer justify-content-center">
            <button
              class="btn btn-secondary"
              @click="modalRevertirCheckoutVisible = false"
              :disabled="cargandoPago"
            >
              Cancelar
            </button>
            <button
              class="btn btn-warning"
              @click="ejecutarRevertirCheckout"
              :disabled="cargandoPago"
            >
              <span
                v-if="cargandoPago"
                class="spinner-border spinner-border-sm me-1"
              ></span>
              Sí, Revertir
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import axios from "axios";
import { API_URL } from "@/config/config.js";
import { BRAND } from "@/config/branding";
import { useRoute, useRouter } from "vue-router";
import { imprimirReciboHotel } from "@/utils/impresion";
import debounce from "lodash/debounce";
import SelectorPagosCombinados from "@/components/comunes/SelectorPagosCombinados.vue";
import EditorLineasFactura from "@/components/comunes/EditorLineasFactura.vue";

const MENSAJE_DETALLE_INVALIDO =
  "Revisa el detalle de la factura: las líneas deben sumar el total a facturar";

export default {
  name: "PagarPorHabitaciones",
  components: { SelectorPagosCombinados, EditorLineasFactura },
  data() {
    return {
      route: useRoute(),
      router: useRouter(),
      cargando: true,
      cargandoPago: false,
      reserva: null,
      habitaciones: [],
      habitacionSeleccionada: null,
      metodos: [],
      metodosFacturados: [],
      metodosNoFacturados: [],
      cuentas: [],
      modalPagoVisible: false,
      // Pago Combinado (multi-método, por habitación) — checkbox dentro del
      // mismo modal de "Registrar Pago" (vista de selección), no un modal aparte.
      pagoCombinado: false,
      pagosCombinados: [],
      pagosCombinadosValidos: false,
      cargandoPagoCombinado: false,
      grupoPagoCombinado: "",
      // Pago Combinado (multi-método, reserva completa) — ídem, dentro del
      // modal de "Pagar Total de la Reserva".
      pagoCombinadoRC: false,
      pagosCombinadosRC: [],
      pagosCombinadosRCValidos: false,
      cargandoPagoCombinadoRC: false,
      grupoPagoCombinadoRC: "",
      modalRestauranteVisible: false,
      modalServiciosExtraVisible: false,
      // Agregar servicios extra a habitación
      modalAgregarServicioExtraVisible: false,
      busquedaServicioExtra: "",
      serviciosExtraResultados: [],
      carritoServiciosExtra: [],
      cargandoAgregarServicio: false,

      mostrarModalPagos: false,
      pagosHabitacion: [],
      pagoAAnular: null,
      mostrarConfirmacionAnular: false,
      // Sistema de pagos simple como restaurante
      mostrarModalFactura: false,
      pasoModalFactura: 0,
      generarFactura: false,
      requiereFactura: false,
      descripcionDetalladaHotel: false,
      descripcionDetalladaRestaurante: false,
      otroServicioHotel: false,
      otroServicioRestaurante: false,
      otroServicioTodo: false,
      metodosPago: [],
      metodoPagoSeleccionado: null,
      montoPago: null,
      numeroReferencia: "",
      cuentaBancariaSeleccionada: null,
      alerta: { mensaje: "", tipo: "success" },
      mostrarToast: false,
      toastTimer: null,
      // Descuento
      modalDescuentoVisible: false,
      codigoDescuento: "",
      cargandoDescuento: false,
      // Quitar descuento (F4 Parte D)
      modalQuitarDescuentoVisible: false,
      cargandoQuitarDescuento: false,
      // Pago y checkout de reserva completa
      mostrarModalFacturaReservaCompleta: false,
      pasoModalFacturaRC: 1,
      generarFacturaRC: false,
      modalPagoReservaCompletaVisible: false,
      metodoPagoReservaCompleta: null,
      montoPagoReservaCompleta: null,
      numeroReferenciaReservaCompleta: "",
      cuentaBancariaReservaCompleta: null,
      metodosPagoReservaCompleta: [],
      tipoPagoReservaCompleta: null,
      cargandoPagoReservaCompleta: false,
      modalCheckoutReservaCompletaVisible: false,
      modalRevertirCheckoutVisible: false,
      cargandoCheckoutReservaCompleta: false,
      esperandoImpresion: false,
      // Datos FEL receptor (se pre-rellenan según la elección NIT/CF)
      nitReceptor: "",
      nombreReceptor: "",
      direccionReceptor: "",
      nitVerificado: false,
      cargandoVerificacionNit: false,
      // Re-emitir FEL
      mostrarModalReemitir: false,
      reemitirPago: null,
      reemitirNit: "",
      reemitirNombre: "",
      cargandoReemitir: false,
      // Pago de extranjeros sin factura FEL
      esExtranjero: false,
      numeroFacturaManual: "",
      // Concepto de pago y descripciones personalizadas
      conceptoPago: "todo",
      conceptoPagoRC: "todo",
      // Líneas de la factura detallada (EditorLineasFactura), compartidas por ambos modales
      lineasDetalleHotel: [],
      lineasDetalleRestaurante: [],
      lineasDetalleHotelValidas: false,
      lineasDetalleRestauranteValidas: false,
      vistaPago: "seleccion",
      seleccion: {},
      vistaPagoRC: "seleccion",
      seleccionRC: {},
      // Pago a crédito (hotel)
      mostrarModalCreditoHotel: false,
      creditoHotelNombre: "",
      creditoHotelNit: "",
      creditoHotelDireccion: "",
      creditoHotelDescripcion: "",
      creditoHotelFechaVencimiento: "",
      creditoOtroServicio: false,
      cargandoCreditoHotel: false,
      creditoHotelPaso: 1,        // 1=¿factura?, 2=¿NIT o CF?, 3=formulario
      creditoConFactura: false,   // ¿generar factura en el crédito?
      creditoConNit: false,       // ¿NIT o CF?
      creditoNitVerificado: false,
      cargandoVerificacionNitCredito: false,
      // Cambiar habitación de comanda
      mostrarModalCambiarHabitacionComanda: false,
      cuentaCambiandoHabitacion: null,
      busquedaReservaCambioComanda: "",
      reservasCambioComanda: [],
      habitacionCambioComanda: null,
      cargandoCambioHabitacionComanda: false,
      debouncedBuscarReservaCambioComanda: null,
      // Propina de cuentas de restaurante desde el pago de reserva (F4 C.3)
      propinaCargando: null, // IdCuentaPedido con una petición de propina en curso
    };
  },
  async mounted() {
    this.debouncedBuscarReservaCambioComanda = debounce(this.buscarReservaCambioComanda, 400);
    const id = this.route.params.id;
    await this.obtenerDetalleReserva(id);
    await this.obtenerCuentas();
    this.cargando = false;
  },
  computed: {
    toastColor() {
      return (
        {
          success: "bg-success",
          danger: "bg-danger",
          warning: "bg-warning text-dark",
        }[this.alerta.tipo] || "bg-primary"
      );
    },
    iconoToast() {
      return (
        {
          success: "bi bi-check-circle-fill",
          danger: "bi bi-x-circle-fill",
          warning: "bi bi-exclamation-triangle-fill",
        }[this.alerta.tipo] || "bi bi-info-circle-fill"
      );
    },
    esAdminORecepcionista() {
      const rol = this.$store.getters.getUser?.IdRol;
      return rol === 1 || rol === 2;
    },
    totalCarritoServiciosExtra() {
      return this.carritoServiciosExtra.reduce(
        (t, i) => t + Number(i.precio) * i.cantidad,
        0,
      );
    },
    serviciosExtraFiltrados() {
      const q = this.busquedaServicioExtra.trim().toLowerCase();
      if (!q) return this.serviciosExtraResultados;
      return this.serviciosExtraResultados.filter((s) =>
        s.Nombre?.toLowerCase().includes(q),
      );
    },
    puedeHacerCheckout() {
      if (!this.habitacionSeleccionada) return false;
      const saldo = Number(
        this.habitacionSeleccionada.SaldoPendienteHabitacion || 0,
      );
      return saldo <= 0;
    },
    saldoTotalPendiente() {
      return this.habitaciones.reduce((total, hab) => {
        return total + Number(hab.SaldoPendienteHabitacion || 0);
      }, 0);
    },
    habitacionesSinCheckout() {
      return this.habitaciones.filter((hab) => !hab.CheckOut);
    },
    puedeHacerCheckoutReservaCompleta() {
      if (this.habitaciones.length <= 1) return false;
      const habsSinCheckout = this.habitacionesSinCheckout;
      if (habsSinCheckout.length === 0) return false;
      // Verificar que todas las habitaciones sin checkout tengan saldo 0 (igual que el botón individual)
      return habsSinCheckout.every((hab) => {
        const saldoCero = Number(hab.SaldoPendienteHabitacion || 0) <= 0;
        return saldoCero;
      });
    },
    mensajeEstadoCheckoutCompleto() {
      if (this.habitaciones.length <= 1) {
        return "Se requieren múltiples habitaciones";
      }
      const habsSinCheckout = this.habitacionesSinCheckout;
      if (habsSinCheckout.length === 0) {
        return "Todas las habitaciones ya tienen checkout";
      }

      // Contar habitaciones con saldo pendiente
      const habsConSaldo = habsSinCheckout.filter((hab) => {
        return Number(hab.SaldoPendienteHabitacion || 0) > 0;
      });

      if (habsConSaldo.length > 0) {
        const numeros = habsConSaldo
          .map((h) => h.habitacion?.Numero || h.IdHabitacion)
          .join(", ");
        return `${habsConSaldo.length} habitación(es) con saldo pendiente: ${numeros}`;
      }

      return "Hacer checkout de todas las habitaciones";
    },
    cambioHotel() {
      const total = this.totalSeleccionado;
      return this.esPagoEfectivo && this.montoPago > total
        ? Math.round((this.montoPago - total) * 100) / 100
        : 0;
    },
    cambioReservaCompleta() {
      const metodo = this.metodosPagoReservaCompleta.find(
        (m) => m.IdMetodoPago === this.metodoPagoReservaCompleta,
      );
      const esEfectivo =
        metodo?.Metodo?.toLowerCase().includes("efectivo") ?? false;
      const referencia =
        this.totalSeleccionadoRC > 0
          ? this.totalSeleccionadoRC
          : parseFloat(this.saldoTotalPendiente || 0);
      return esEfectivo && this.montoPagoReservaCompleta > referencia
        ? Math.round((this.montoPagoReservaCompleta - referencia) * 100) / 100
        : 0;
    },
    tieneCargoRestauranteHabitacion() {
      return parseFloat(this.habitacionSeleccionada?.TotalRestaurante || 0) > 0;
    },
    tieneCargoRestauranteReserva() {
      return (this.habitaciones || []).some(
        (h) => parseFloat(h.TotalRestaurante || 0) > 0,
      );
    },
    // Restaurante pendiente de pago: usa el campo TotalRestaurantePendiente
    // calculado en el backend (excluye cuentas con Estado=2 ya pagadas).
    // Fallback a TotalRestaurante si el backend aún no envía el campo.
    totalRestaurantePendienteHabitacion() {
      const ref = this.habitacionSeleccionada;
      const trp = ref?.TotalRestaurantePendiente;
      // trp != null cubre undefined y null, pero NO 0 (0 = todo restaurante pagado)
      if (trp != null) return parseFloat(trp);
      return parseFloat(ref?.TotalRestaurante || 0);
    },
    montoSoloHospedaje() {
      const saldo = parseFloat(
        this.habitacionSeleccionada?.SaldoPendienteHabitacion || 0,
      );
      return Math.max(0, saldo - this.totalRestaurantePendienteHabitacion);
    },
    montoSoloRestaurante() {
      const saldo = parseFloat(
        this.habitacionSeleccionada?.SaldoPendienteHabitacion || 0,
      );
      return Math.min(saldo, this.totalRestaurantePendienteHabitacion);
    },
    totalHospedajeReserva() {
      return (this.habitaciones || []).reduce((sum, h) => {
        return sum + Number(h.TotalHabitacion || 0);
      }, 0);
    },
    totalRestauranteReserva() {
      return (this.habitaciones || []).reduce((sum, h) => {
        return sum + Number(h.TotalRestaurante || 0);
      }, 0);
    },
    totalExtrasReserva() {
      return (this.habitaciones || []).reduce((sum, h) => {
        return sum + Number(h.TotalServiciosExtra || 0);
      }, 0);
    },
    saldoTotalRestaurantePendiente() {
      return (this.habitaciones || []).reduce((sum, h) => {
        return (
          sum + Number((h.TotalRestaurantePendiente ?? h.TotalRestaurante) || 0)
        );
      }, 0);
    },
    saldoTotalHospedajePendiente() {
      return Math.max(
        0,
        Number(this.saldoTotalPendiente) - this.saldoTotalRestaurantePendiente,
      );
    },
    itemsSeleccionados() {
      return Object.entries(this.seleccion)
        .filter(([, v]) => v.activo && v.monto > 0.009)
        .map(([key, v]) => {
          const [tipo, idStr] = key.split(":");
          const id = Number(idStr);
          const item = { tipo, monto: Math.round(v.monto * 100) / 100 };
          if (tipo === "hospedaje") item.id_reserva_habitacion = id;
          else if (tipo === "cuenta") item.id_cuenta_pedido = id;
          else if (tipo === "servicio") item.id_servicio_extra_total = id;
          return item;
        });
    },
    totalSeleccionado() {
      return (
        Math.round(
          Object.values(this.seleccion)
            .filter((v) => v.activo)
            .reduce((s, v) => s + (parseFloat(v.monto) || 0), 0) * 100,
        ) / 100
      );
    },
    puedeIrAPago() {
      return this.totalSeleccionado > 0 && this.itemsSeleccionados.length > 0;
    },
    hayHospedajeSeleccionado() {
      return Object.entries(this.seleccion).some(
        ([k, v]) => k.startsWith("hospedaje:") && v.activo,
      );
    },
    hayCuentaSeleccionada() {
      return Object.entries(this.seleccion).some(
        ([k, v]) => k.startsWith("cuenta:") && v.activo,
      );
    },
    hayServicioSeleccionado() {
      return Object.entries(this.seleccion).some(
        ([k, v]) => k.startsWith("servicio:") && v.activo,
      );
    },
    totalHospedajeSeleccionado() {
      return (
        Math.round(
          Object.entries(this.seleccion)
            .filter(([k, v]) => k.startsWith("hospedaje:") && v.activo)
            .reduce((s, [, v]) => s + (parseFloat(v.monto) || 0), 0) * 100,
        ) / 100
      );
    },
    totalCuentasSeleccionadas() {
      return (
        Math.round(
          Object.entries(this.seleccion)
            .filter(([k, v]) => k.startsWith("cuenta:") && v.activo)
            .reduce((s, [, v]) => s + (parseFloat(v.monto) || 0), 0) * 100,
        ) / 100
      );
    },
    totalServiciosSeleccionados() {
      return (
        Math.round(
          Object.entries(this.seleccion)
            .filter(([k, v]) => k.startsWith("servicio:") && v.activo)
            .reduce((s, [, v]) => s + (parseFloat(v.monto) || 0), 0) * 100,
        ) / 100
      );
    },
    esPagoEfectivo() {
      return (
        this.metodosPago
          .find((m) => m.IdMetodoPago === this.metodoPagoSeleccionado)
          ?.Metodo?.toLowerCase()
          .includes("efectivo") ?? false
      );
    },

    // Agrupación de selección individual por tipo (para template)
    seleccionCuentas() {
      return Object.entries(this.seleccion).filter(([k]) =>
        k.startsWith("cuenta:"),
      );
    },
    seleccionServicios() {
      return Object.entries(this.seleccion).filter(([k]) =>
        k.startsWith("servicio:"),
      );
    },
    seleccionHospedaje() {
      return Object.entries(this.seleccion).filter(([k]) =>
        k.startsWith("hospedaje:"),
      );
    },

    // ── Selección RC (todas las habitaciones) ──────────────────────────────
    itemsSeleccionadosRC() {
      return Object.entries(this.seleccionRC)
        .filter(([, v]) => v.activo && v.monto > 0.009)
        .map(([key, v]) => {
          const [tipo, idStr] = key.split(":");
          const id = Number(idStr);
          const item = { tipo, monto: Math.round(v.monto * 100) / 100 };
          if (tipo === "hospedaje") item.id_reserva_habitacion = id;
          else if (tipo === "cuenta") item.id_cuenta_pedido = id;
          else if (tipo === "servicio") item.id_servicio_extra_total = id;
          return item;
        });
    },
    totalSeleccionadoRC() {
      return (
        Math.round(
          Object.values(this.seleccionRC)
            .filter((v) => v.activo)
            .reduce((s, v) => s + (parseFloat(v.monto) || 0), 0) * 100,
        ) / 100
      );
    },
    puedeIrAPagoRC() {
      return this.totalSeleccionadoRC > 0 && this.itemsSeleccionadosRC.length > 0;
    },
    hayHospedajeRC() {
      return Object.entries(this.seleccionRC).some(
        ([k, v]) => k.startsWith("hospedaje:") && v.activo,
      );
    },
    hayServicioRC() {
      return Object.entries(this.seleccionRC).some(
        ([k, v]) => k.startsWith("servicio:") && v.activo,
      );
    },
    hayCuentaRC() {
      return Object.entries(this.seleccionRC).some(
        ([k, v]) => k.startsWith("cuenta:") && v.activo,
      );
    },
    // Ítems que realmente se envían en el pago de reserva completa (misma regla que el payload)
    itemsPagoRC() {
      return this.itemsSeleccionadosRC.length > 0
        ? this.itemsSeleccionadosRC
        : this.construirItemsTodasHabitaciones();
    },
    // ── Factura detallada: total de cada grupo que deben sumar las líneas ──
    totalDetalleHospedaje() {
      return this.sumarItemsPorTipo(this.itemsSeleccionados, "hospedaje");
    },
    totalDetalleCuentas() {
      return this.sumarItemsPorTipo(this.itemsSeleccionados, "cuenta");
    },
    totalDetalleHospedajeRC() {
      return this.sumarItemsPorTipo(this.itemsPagoRC, "hospedaje");
    },
    totalDetalleCuentasRC() {
      return this.sumarItemsPorTipo(this.itemsPagoRC, "cuenta");
    },
    detalleFacturaInvalido() {
      return (
        this.generarFactura &&
        this.detalleInvalido(this.totalDetalleHospedaje, this.totalDetalleCuentas)
      );
    },
    detalleFacturaInvalidoRC() {
      return (
        this.generarFacturaRC &&
        this.detalleInvalido(this.totalDetalleHospedajeRC, this.totalDetalleCuentasRC)
      );
    },
    totalHospedajeRC() {
      return (
        Math.round(
          Object.entries(this.seleccionRC)
            .filter(([k, v]) => k.startsWith("hospedaje:") && v.activo)
            .reduce((s, [, v]) => s + (parseFloat(v.monto) || 0), 0) * 100,
        ) / 100
      );
    },
    totalServiciosRC() {
      return (
        Math.round(
          Object.entries(this.seleccionRC)
            .filter(([k, v]) => k.startsWith("servicio:") && v.activo)
            .reduce((s, [, v]) => s + (parseFloat(v.monto) || 0), 0) * 100,
        ) / 100
      );
    },
    totalCuentasRC() {
      return (
        Math.round(
          Object.entries(this.seleccionRC)
            .filter(([k, v]) => k.startsWith("cuenta:") && v.activo)
            .reduce((s, [, v]) => s + (parseFloat(v.monto) || 0), 0) * 100,
        ) / 100
      );
    },
    // Agrupación RC por tipo (para template)
    seleccionRCCuentas() {
      return Object.entries(this.seleccionRC).filter(([k]) =>
        k.startsWith("cuenta:"),
      );
    },
    seleccionRCServicios() {
      return Object.entries(this.seleccionRC).filter(([k]) =>
        k.startsWith("servicio:"),
      );
    },
    seleccionRCHospedaje() {
      return Object.entries(this.seleccionRC).filter(([k]) =>
        k.startsWith("hospedaje:"),
      );
    },
    fechaMinimaCreditoHotel() {
      const t = new Date();
      t.setDate(t.getDate() + 1);
      return t.toISOString().split("T")[0];
    },
  },
  watch: {
    async metodoPagoSeleccionado(nuevoMetodo) {
      if (nuevoMetodo === 2) {
        // Cuenta bancaria ya está cargada
      } else {
        this.cuentaBancariaSeleccionada = null;
        this.numeroReferencia = "";
      }
    },
    async metodoPagoReservaCompleta(nuevoMetodo) {
      if (nuevoMetodo === 2) {
        // Cuenta bancaria ya está cargada
      } else {
        this.cuentaBancariaReservaCompleta = null;
        this.numeroReferenciaReservaCompleta = "";
      }
    },
  },
  methods: {
    async obtenerDetalleReserva(idReserva) {
      try {
        const res = await axios.get(`${API_URL}/reservas/detalle/${idReserva}`);
        this.reserva = res.data.reserva;
        this.habitaciones = this.reserva.habitaciones_reservadas || [];

        // Seleccionar la primera habitación por defecto
        if (this.habitaciones.length > 0) {
          this.habitacionSeleccionada = this.habitaciones[0];
        }
      } catch (error) {
        console.error("Error al obtener detalle de reserva:", error);
        this.mostrarAlerta("Error al cargar la reserva.", "danger");
      }
    },
    async obtenerCuentas() {
      const res = await axios.get(`${API_URL}/cuentas-bancarias`);
      this.cuentas = res.data;
    },
    // Recarga el detalle de la reserva preservando la habitación seleccionada
    // (obtenerDetalleReserva por sí sola siempre selecciona habitaciones[0]).
    async recargarDetalleReservaPreservandoSeleccion() {
      const idHabActual = this.habitacionSeleccionada?.IdReservaHabitacion;
      await this.obtenerDetalleReserva(this.reserva.IdReserva);
      if (idHabActual) {
        const habActualizada = this.habitaciones.find(
          (h) => h.IdReservaHabitacion === idHabActual,
        );
        if (habActualizada) {
          this.habitacionSeleccionada = habActualizada;
        }
      }
    },
    // Decisión del usuario: NO se crea propina de hospedaje. Se replica aquí el
    // mismo control de propina de restaurante (pagarcuenta.vue), apuntando al
    // endpoint existente /agregar-propina/{idCuentaPedido}, para cada cuenta de
    // restaurante cargada a la habitación.
    async togglePropinaCuentaHabitacion(cuenta, activar) {
      if (cuenta.Estado === 2 || cuenta.Estado === 3) return;
      this.propinaCargando = cuenta.IdCuentaPedido;
      try {
        const payload = { propina: activar ? 1 : 0 };
        if (!activar) {
          cuenta._propinaPersonalizada = null;
        }
        await axios.post(
          `${API_URL}/agregar-propina/${cuenta.IdCuentaPedido}`,
          payload,
        );
        this.mostrarAlerta(
          activar ? "Propina aplicada" : "Propina desactivada",
          "success",
        );
        await this.recargarDetalleReservaPreservandoSeleccion();
      } catch (error) {
        console.error("Error al actualizar la propina:", error);
        this.mostrarAlerta(
          error.response?.data?.message || "Error al actualizar la propina.",
          "danger",
        );
      } finally {
        this.propinaCargando = null;
      }
    },
    async aplicarPropinaPersonalizadaHabitacion(cuenta) {
      if (cuenta.Estado === 2 || cuenta.Estado === 3) return;
      if (!(Number(cuenta.Propina) > 0)) return;
      const monto = cuenta._propinaPersonalizada;
      if (monto === null || monto === undefined || monto === "") return;
      if (isNaN(monto) || Number(monto) <= 0) {
        this.mostrarAlerta("El monto de propina debe ser mayor a 0.", "danger");
        return;
      }
      this.propinaCargando = cuenta.IdCuentaPedido;
      try {
        await axios.post(`${API_URL}/agregar-propina/${cuenta.IdCuentaPedido}`, {
          propina: 1,
          monto_propina: Number(monto),
        });
        this.mostrarAlerta("Propina actualizada.", "success");
        await this.recargarDetalleReservaPreservandoSeleccion();
      } catch (error) {
        console.error("Error al actualizar la propina:", error);
        this.mostrarAlerta(
          error.response?.data?.message || "Error al actualizar la propina.",
          "danger",
        );
      } finally {
        this.propinaCargando = null;
      }
    },
    seleccionarHabitacion(hab) {
      this.habitacionSeleccionada = hab;
    },
    abrirModalRestaurante() {
      this.modalRestauranteVisible = true;
    },
    cerrarModalRestaurante() {
      this.modalRestauranteVisible = false;
    },
    abrirModalCambiarHabitacionComanda(cuenta) {
      this.cuentaCambiandoHabitacion = cuenta;
      this.busquedaReservaCambioComanda = "";
      this.reservasCambioComanda = [];
      this.habitacionCambioComanda = null;
      this.mostrarModalCambiarHabitacionComanda = true;
    },
    cerrarModalCambiarHabitacionComanda() {
      this.mostrarModalCambiarHabitacionComanda = false;
      this.cuentaCambiandoHabitacion = null;
      this.busquedaReservaCambioComanda = "";
      this.reservasCambioComanda = [];
      this.habitacionCambioComanda = null;
    },
    async buscarReservaCambioComanda() {
      if (this.busquedaReservaCambioComanda.length < 2) {
        this.reservasCambioComanda = [];
        return;
      }
      try {
        const { data } = await axios.get(`${API_URL}/reservas/buscar-avanzado`, {
          params: { q: this.busquedaReservaCambioComanda, solo_checkin_activo: 1 },
        });
        this.reservasCambioComanda = Array.isArray(data.data) ? data.data : [];
      } catch {
        this.reservasCambioComanda = [];
      }
    },
    seleccionarHabitacionCambioComanda(reserva, habitacion) {
      this.habitacionCambioComanda = habitacion;
      this.busquedaReservaCambioComanda = `R00${reserva.IdReserva} - Habitación ${habitacion.Numero}`;
      this.reservasCambioComanda = [];
    },
    async confirmarCambioHabitacionComanda() {
      if (!this.habitacionCambioComanda || !this.cuentaCambiandoHabitacion) return;
      try {
        this.cargandoCambioHabitacionComanda = true;
        const { data } = await axios.put(
          `${API_URL}/pagar-cuenta-pedido/${this.cuentaCambiandoHabitacion.IdCuentaPedido}/cargar-habitacion`,
          { id_reserva_habitacion: this.habitacionCambioComanda.IdReservaHabitacion },
        );
        this.mostrarAlerta(data.message || "Comanda movida correctamente", "success");
        this.cerrarModalCambiarHabitacionComanda();
        this.cerrarModalRestaurante();
        await this.obtenerDetalleReserva(this.route.params.id);
        await this.cargarPagosHabitacion();
      } catch (err) {
        this.mostrarAlerta(
          err.response?.data?.message || "Error al cambiar la habitación",
          "danger",
        );
      } finally {
        this.cargandoCambioHabitacionComanda = false;
      }
    },
    sumarItemsPorTipo(items, tipo) {
      return (
        Math.round(
          items
            .filter((i) => i.tipo === tipo)
            .reduce((s, i) => s + (Number(i.monto) || 0), 0) * 100,
        ) / 100
      );
    },
    // Solo se envían las líneas de un grupo detallado con monto a facturar: con el
    // editor oculto (grupo en 0) pueden quedar líneas viejas o incompletas.
    lineasDetallePayload(totalHospedaje, totalCuentas) {
      return {
        lineas_detalle_hotel:
          this.descripcionDetalladaHotel && totalHospedaje > 0
            ? this.lineasDetalleHotel
            : null,
        lineas_detalle_restaurante:
          this.descripcionDetalladaRestaurante && totalCuentas > 0
            ? this.lineasDetalleRestaurante
            : null,
      };
    },
    // Un grupo detallado con monto a facturar exige líneas válidas (que cuadren)
    detalleInvalido(totalHospedaje, totalCuentas) {
      return (
        (this.descripcionDetalladaHotel &&
          totalHospedaje > 0 &&
          !this.lineasDetalleHotelValidas) ||
        (this.descripcionDetalladaRestaurante &&
          totalCuentas > 0 &&
          !this.lineasDetalleRestauranteValidas)
      );
    },
    onDetalladoHotelChange() {
      if (this.descripcionDetalladaHotel) {
        this.otroServicioHotel = false;
        this.otroServicioTodo = false;
      } else {
        this.lineasDetalleHotel = [];
      }
    },
    onOtroServicioHotelChange() {
      if (this.otroServicioHotel) {
        this.descripcionDetalladaHotel = false;
        this.lineasDetalleHotel = [];
        this.otroServicioTodo = false;
      }
    },
    onDetalladoRestauranteChange() {
      if (this.descripcionDetalladaRestaurante) {
        this.otroServicioRestaurante = false;
        this.otroServicioTodo = false;
      } else {
        this.lineasDetalleRestaurante = [];
      }
    },
    onOtroServicioRestauranteChange() {
      if (this.otroServicioRestaurante) {
        this.descripcionDetalladaRestaurante = false;
        this.lineasDetalleRestaurante = [];
        this.otroServicioTodo = false;
      }
    },
    onOtroServicioTodoChange() {
      if (this.otroServicioTodo) {
        this.otroServicioHotel = false;
        this.otroServicioRestaurante = false;
        this.descripcionDetalladaHotel = false;
        this.descripcionDetalladaRestaurante = false;
        this.lineasDetalleHotel = [];
        this.lineasDetalleRestaurante = [];
        // Restaurar el saldo completo (hotel + restaurante) para que la factura sume todo
        this.montoPago =
          parseFloat(
            this.habitacionSeleccionada?.SaldoPendienteHabitacion || 0,
          ) || null;
      }
    },
    onConceptoPagoChange() {
      // Reset description options when changing concept
      this.descripcionDetalladaHotel = false;
      this.descripcionDetalladaRestaurante = false;
      this.lineasDetalleHotel = [];
      this.lineasDetalleRestaurante = [];
      this.otroServicioHotel = false;
      this.otroServicioRestaurante = false;
      this.otroServicioTodo = false;
      // Auto-fill amount based on concept
      if (this.conceptoPago === "solo_hospedaje") {
        this.montoPago = this.montoSoloHospedaje || null;
      } else if (this.conceptoPago === "solo_restaurante") {
        this.montoPago = this.montoSoloRestaurante || null;
      } else {
        this.montoPago =
          parseFloat(
            this.habitacionSeleccionada?.SaldoPendienteHabitacion || 0,
          ) || null;
      }
    },
    // Cuando el recepcionista edita el monto manualmente, sincronizar conceptoPago
    // para que la FEL nunca se genere con ítems incorrectos.
    // REGLA: solo hacer auto-corrección HACIA ARRIBA (detectar coincidencia exacta).
    // Nunca forzar 'todo' si el usuario seleccionó un concepto parcial — eso permitiría
    // pagar hospedaje en varios abonos (ej. 3 facturas de Q143.33 de Q430 total).
    onMontoPagoInput() {
      if (!this.tieneCargoRestauranteHabitacion) return;
      const monto = parseFloat(this.montoPago) || 0;
      const delta = 0.02;
      const saldoTotal = parseFloat(
        this.habitacionSeleccionada?.SaldoPendienteHabitacion || 0,
      );
      if (
        monto > 0 &&
        this.montoSoloHospedaje > 0 &&
        Math.abs(monto - this.montoSoloHospedaje) < delta
      ) {
        this.conceptoPago = "solo_hospedaje";
      } else if (
        monto > 0 &&
        this.montoSoloRestaurante > 0 &&
        Math.abs(monto - this.montoSoloRestaurante) < delta
      ) {
        this.conceptoPago = "solo_restaurante";
      } else if (monto > 0 && Math.abs(monto - saldoTotal) < delta) {
        // El monto coincide con el total pendiente → pago completo
        this.conceptoPago = "todo";
      } else if (
        // 'todo' seleccionado pero monto < restaurante pendiente:
        // auto-corregir a 'solo_restaurante' para que la factura sea correcta.
        this.conceptoPago === "todo" &&
        this.montoSoloRestaurante > 0 &&
        monto > 0 &&
        monto < this.montoSoloRestaurante - delta
      ) {
        this.conceptoPago = "solo_restaurante";
      }
      // Para montos parciales que no coinciden exactamente con ningún concepto,
      // se respeta la selección explícita del radio button del recepcionista.
    },
    abrirModalServiciosExtra() {
      this.modalServiciosExtraVisible = true;
    },
    cerrarModalServiciosExtra() {
      this.modalServiciosExtraVisible = false;
    },
    // ── Agregar Servicios Extra a Habitación ─────────────────
    async abrirModalAgregarServicioExtra() {
      this.busquedaServicioExtra = "";
      this.serviciosExtraResultados = [];
      this.carritoServiciosExtra = [];
      this.modalAgregarServicioExtraVisible = true;
      try {
        const { data } = await axios.get(`${API_URL}/servicios-extra`);
        this.serviciosExtraResultados = (Array.isArray(data) ? data : []).map(
          (s) => ({
            ...s,
            precio: Number(s.precio || s.Precio),
          }),
        );
      } catch {
        this.serviciosExtraResultados = [];
      }
    },
    cerrarModalAgregarServicioExtra() {
      this.modalAgregarServicioExtraVisible = false;
      this.busquedaServicioExtra = "";
      this.serviciosExtraResultados = [];
      this.carritoServiciosExtra = [];
    },
    agregarServicioExtraAlCarrito(serv) {
      const existente = this.carritoServiciosExtra.find(
        (s) => s.IdServicio === serv.IdServicio,
      );
      if (existente) {
        existente.cantidad++;
      } else {
        this.carritoServiciosExtra.push({ ...serv, cantidad: 1 });
      }
    },
    async confirmarAgregarServiciosExtra() {
      if (!this.carritoServiciosExtra.length) return;
      try {
        this.cargandoAgregarServicio = true;
        const payload = {
          Total: this.totalCarritoServiciosExtra,
          IdReservaHabitacion: this.habitacionSeleccionada.IdReservaHabitacion,
          IdEmpleado: this.$store.getters.getUser?.IdEmpleado || null,
          Facturado: 2,
          detalles: this.carritoServiciosExtra.map((s) => ({
            IdServicio: s.IdServicio,
            Cantidad: s.cantidad,
          })),
          pagos: [],
        };
        await axios.post(`${API_URL}/venta-servicios-extra`, payload);
        this.mostrarAlerta(
          "Servicios extra agregados a la habitación",
          "success",
        );
        this.cerrarModalAgregarServicioExtra();
        await this.obtenerDetalleReserva(this.route.params.id);
      } catch (err) {
        this.mostrarAlerta(
          err.response?.data?.message || "Error al agregar servicios extra",
          "danger",
        );
      } finally {
        this.cargandoAgregarServicio = false;
      }
    },
    async abrirModalPagos() {
      await this.cargarPagosHabitacion();
      this.mostrarModalPagos = true;
    },
    cerrarModalPagos() {
      this.mostrarModalPagos = false;
    },
    abrirModalReemitir(pago) {
      this.reemitirPago = pago;
      this.reemitirNit = "";
      this.reemitirNombre = "";
      this.mostrarModalReemitir = true;
    },
    cerrarModalReemitir() {
      this.mostrarModalReemitir = false;
      this.reemitirPago = null;
    },
    async reemitirFactura() {
      if (!this.reemitirPago) return;
      try {
        this.cargandoReemitir = true;
        const { data } = await axios.post(
          `${API_URL}/pago-hospedaje-hotel/${this.reemitirPago.IdPagoHospedajeHotel}/reemitir`,
          {
            receptor_nit: this.reemitirNit.trim() || "CF",
            receptor_nombre: this.reemitirNombre.trim() || "Consumidor Final",
          },
        );
        this.cerrarModalReemitir();
        this.mostrarAlerta(
          "✔ Factura re-emitida correctamente",
          "success",
          8000,
        );
        if (data.factura?.uuid) {
          this.esperandoImpresion = true;
          setTimeout(() => this.imprimirFacturaCarta(data.factura.uuid), 600);
        }
        // Recargar pagos para mostrar nueva factura
        await this.cargarPagosHabitacion();
      } catch (err) {
        this.mostrarAlerta(
          "⚠ Error: " +
            (err.response?.data?.message || "No se pudo re-emitir la factura"),
          "danger",
          10000,
        );
      } finally {
        this.cargandoReemitir = false;
      }
    },
    async cargarPagosHabitacion() {
      try {
        const idHabitacion = this.habitacionSeleccionada?.IdReservaHabitacion;
        const { data } = await axios.get(
          `${API_URL}/pagos-habitacion/${idHabitacion}`,
        );
        this.pagosHabitacion = Array.isArray(data.pagos) ? data.pagos : [];
      } catch (err) {
        console.error("Error al cargar pagos:", err);
        this.mostrarAlerta("Error al cargar los pagos", "danger");
      }
    },
    formatearFechaHora(fechaHora) {
      if (!fechaHora) return "";
      const fecha = new Date(fechaHora);
      const dia = fecha.getDate().toString().padStart(2, "0");
      const mes = (fecha.getMonth() + 1).toString().padStart(2, "0");
      const anio = fecha.getFullYear();
      const hora = fecha.getHours().toString().padStart(2, "0");
      const minutos = fecha.getMinutes().toString().padStart(2, "0");
      return `${dia}/${mes}/${anio} ${hora}:${minutos}`;
    },
    confirmarAnularPago(pago) {
      this.pagoAAnular = pago;
      this.mostrarConfirmacionAnular = true;
    },
    cancelarAnulacion() {
      this.pagoAAnular = null;
      this.mostrarConfirmacionAnular = false;
    },
    async anularPago() {
      if (!this.pagoAAnular) return;

      try {
        this.cargandoPago = true;
        const { data } = await axios.post(
          `${API_URL}/anular-pago-habitacion/${this.pagoAAnular.IdPagoHospedajeHotel}`,
        );

        this.mostrarAlerta(
          data.message || "Pago cancelado correctamente",
          "success",
        );

        this.cancelarAnulacion();

        // Recargar pagos y datos de reserva
        await this.cargarPagosHabitacion();
        await this.obtenerDetalleReserva(this.route.params.id);
      } catch (err) {
        console.error(err);
        this.mostrarAlerta(
          err.response?.data?.message || "Error al cancelar el pago",
          "danger",
        );
      } finally {
        this.cargandoPago = false;
      }
    },
    async abrirModalPago() {
      // Si ya se hizo checkout, no permitir más pagos ni cambios
      if (this.habitacionSeleccionada?.CheckOut) {
        this.mostrarAlerta(
          "No se pueden realizar más pagos después del checkout",
          "warning",
        );
        return;
      }

      // No permitir pago si el saldo pendiente ya es cero
      if (
        Number(this.habitacionSeleccionada?.SaldoPendienteHabitacion || 0) <= 0
      ) {
        this.mostrarAlerta(
          "Esta habitación no tiene saldo pendiente. El pago ya fue registrado.",
          "warning",
        );
        return;
      }

      // Siempre empezar desde el paso 0 (¿normal o crédito?)
      this.pasoModalFactura = 0;
      this.mostrarModalFactura = true;
    },
    // ── Pago Combinado (multi-método, por habitación) ──────────────────────
    // Vive DENTRO del mismo modal de "Registrar Pago": el checkbox
    // "pagoCombinado" en la vista de selección alterna la vista de pago entre
    // el <select> de un solo método y el repetidor SelectorPagosCombinados.
    // Reutiliza generarFactura/requiereFactura/nitReceptor/etc. — por eso el
    // checkbox solo aparece cuando generarFactura === true.
    async procesarPagoCombinado() {
      if (this.detalleFacturaInvalido) {
        return this.mostrarAlerta(MENSAJE_DETALLE_INVALIDO, "danger");
      }
      if (!this.pagosCombinadosValidos) {
        return this.mostrarAlerta(
          "Revisa los métodos de pago capturados",
          "danger",
        );
      }
      if (this.requiereFactura && !this.nitVerificado) {
        return this.mostrarAlerta("Verifique el NIT antes de pagar", "danger");
      }

      try {
        this.cargandoPagoCombinado = true;

        const total = this.totalSeleccionado;
        const payload = {
          IdReserva: this.reserva.IdReserva,
          items: this.itemsSeleccionados,
          pagos: this.pagosCombinados.map((p) => ({
            Monto: p.Monto,
            IdMetodoPago: p.IdMetodoPago,
            NumeroReferencia: this.requiereReferencia(p.IdMetodoPago)
              ? p.NumeroReferencia
              : null,
            IdCuentaBancaria: p.IdMetodoPago === 2 ? p.IdCuentaBancaria : null,
          })),
          GrupoPago: this.grupoPagoCombinado,
          factura: {
            generar: true,
            receptor_nit: this.requiereFactura
              ? this.nitReceptor.trim()
              : "CF",
            receptor_nombre: this.requiereFactura
              ? this.nombreReceptor.trim() || "Consumidor Final"
              : "Consumidor Final",
            receptor_direccion: this.direccionReceptor.trim() || null,
            otro_servicio_hotel: this.otroServicioHotel,
            otro_servicio_restaurante: this.otroServicioRestaurante,
            otro_servicio_todo: this.otroServicioTodo,
            descripcion_detallada_hotel: this.descripcionDetalladaHotel,
            descripcion_detallada_restaurante:
              this.descripcionDetalladaRestaurante,
            ...this.lineasDetallePayload(
              this.totalDetalleHospedaje,
              this.totalDetalleCuentas,
            ),
          },
          NumeroFacturaManual: null,
        };

        const { data } = await axios.post(
          `${API_URL}/pago-combinado-items`,
          payload,
        );

        if (data.TotalPagado && Math.abs(data.TotalPagado - total) > 0.02) {
          this.mostrarAlerta(
            `⚠ ATENCIÓN: Se solicitó Q${total.toFixed(
              2,
            )} pero se registró Q${data.TotalPagado.toFixed(
              2,
            )}. Contacte al administrador.`,
            "warning",
            15000,
          );
        }

        this.mostrarAlerta(
          data.message || "Pago combinado registrado correctamente",
          "success",
        );

        if (data.factura?.uuid) {
          this.esperandoImpresion = true;
          setTimeout(() => this.imprimirFacturaCarta(data.factura.uuid), 900);
        }

        this.cerrarModalPago();

        await this.obtenerDetalleReserva(this.route.params.id);
        await this.cargarPagosHabitacion();
      } catch (err) {
        console.error(err);
        this.mostrarAlerta(
          err.response?.data?.message || "Error al procesar el pago combinado",
          "danger",
          8000,
        );
      } finally {
        this.cargandoPagoCombinado = false;
      }
    },
    cerrarModalFactura() {
      this.mostrarModalFactura = false;
      this.pasoModalFactura = 0;
    },
    avanzarANitOCf() {
      this.pasoModalFactura = 2;
    },
    avanzarASinFactura() {
      // Mantenido por compatibilidad — ya no se usa desde el template
      this.seleccionarSinFactura();
    },
    iniciarFlujoCreditoDesdeModal() {
      this.mostrarModalFactura = false;
      this.pasoModalFactura = 0;
      const hab = this.habitacionSeleccionada;
      const h = this.reserva?.huesped;
      this.creditoHotelNombre = h ? `${h.Nombre || ""} ${h.Apellido || ""}`.trim() : "";
      this.creditoHotelNit = h?.NIT || "";
      this.creditoHotelDireccion = "";
      this.creditoHotelDescripcion = `Hospedaje y consumos - Hab. ${hab?.habitacion?.Numero || ""}`;
      this.creditoHotelFechaVencimiento = "";
      this.creditoConFactura = false;
      this.creditoConNit = false;
      this.creditoHotelPaso = 1;
      this.creditoNitVerificado = false;
      this.creditoOtroServicio = false;
      this.mostrarModalCreditoHotel = true;
    },
    cerrarModalCreditoHotel() {
      this.mostrarModalCreditoHotel = false;
      this.creditoHotelNombre = "";
      this.creditoHotelNit = "";
      this.creditoHotelDireccion = "";
      this.creditoHotelDescripcion = "";
      this.creditoHotelFechaVencimiento = "";
      this.creditoHotelPaso = 1;
      this.creditoConFactura = false;
      this.creditoConNit = false;
      this.creditoNitVerificado = false;
      this.creditoOtroServicio = false;
    },
    async verificarNitCreditoHotel() {
      if (!this.creditoHotelNit.trim()) return;
      this.cargandoVerificacionNitCredito = true;
      this.creditoNitVerificado = false;
      try {
        const { data: nitInfo } = await axios.get(
          `${API_URL}/facturas-fel/verificar-nit/${encodeURIComponent(this.creditoHotelNit.trim())}`
        );
        if (nitInfo.valido) {
          this.creditoNitVerificado = true;
          if (nitInfo.nombre) this.creditoHotelNombre = nitInfo.nombre;
          this.mostrarAlerta("NIT verificado correctamente", "success");
        } else {
          this.mostrarAlerta("NIT no válido o no encontrado", "danger");
        }
      } catch {
        this.mostrarAlerta("Error al verificar el NIT", "danger");
      } finally {
        this.cargandoVerificacionNitCredito = false;
      }
    },
    async procesarPagoCreditoHotel() {
      if (!this.creditoHotelFechaVencimiento) {
        return this.mostrarAlerta("Ingrese una fecha de vencimiento", "danger");
      }
      if (this.creditoConFactura && this.creditoConNit && !this.creditoHotelNit.trim()) {
        return this.mostrarAlerta("Ingrese el NIT del cliente", "danger");
      }
      const hab = this.habitacionSeleccionada;
      if (!hab) return;

      try {
        this.cargandoCreditoHotel = true;

        const total = hab.SaldoPendienteHabitacion;
        if (total <= 0) {
          return this.mostrarAlerta("No hay saldo pendiente en la habitación", "danger");
        }

        // Determinar NIT según el sub-flujo elegido
        let receptorNit = null;
        if (this.creditoConFactura) {
          receptorNit = this.creditoConNit ? this.creditoHotelNit.trim() : 'CF';
        }

        const { data } = await axios.post(`${API_URL}/pagos-credito/hotel`, {
          IdReservaHabitacion: hab.IdReservaHabitacion,
          Monto: total,
          FechaVencimiento: this.creditoHotelFechaVencimiento,
          IdEmpleado: this.$store.state.user?.IdEmpleado,
          ReceptorNIT: receptorNit,
          ReceptorNombre: this.creditoHotelNombre.trim() || null,
          ReceptorDireccion: this.creditoHotelDireccion.trim() || null,
          Descripcion: this.creditoHotelDescripcion.trim() || null,
          NumeroHabitacion: hab.habitacion?.Numero?.toString() || null,
          NombreHuesped: this.creditoHotelNombre.trim() || null,
          generar_factura: this.creditoConFactura,
          otro_servicio: this.creditoConFactura ? this.creditoOtroServicio : false,
        });

        // Abrir factura si se generó
        if (data.factura?.pdf_url) {
          setTimeout(() => window.open(data.factura.pdf_url, '_blank'), 600);
        }

        const mensaje = this.creditoConFactura
          ? "Crédito registrado con factura generada"
          : "Crédito registrado correctamente";
        this.mostrarAlerta(mensaje, "success");
        this.cerrarModalCreditoHotel();
        await this.obtenerDetalleReserva(this.route.params.id);
        await this.cargarPagosHabitacion();
      } catch (err) {
        this.mostrarAlerta(
          err.response?.data?.message || "Error al registrar el pago a crédito",
          "danger",
          8000,
        );
      } finally {
        this.cargandoCreditoHotel = false;
      }
    },
    async seleccionarSinFactura() {
      try {
        this.cargandoPago = true;
        // Guardar como no facturado en el backend
        await axios.post(
          `${API_URL}/definir-factura-habitacion/${this.habitacionSeleccionada.IdReservaHabitacion}`,
          { facturado: 2 },
        );
        this.habitacionSeleccionada.Facturado = 2;
        this.mostrarModalFactura = false;
        this.pasoModalFactura = 0;
        this.requiereFactura = false;
        this.generarFactura = false;
        this.nitReceptor = "";
        this.nombreReceptor = "";
        this.direccionReceptor = "";
        this.esExtranjero = false;
        this.numeroFacturaManual = "";
        await this.cargarMetodosPago(false);
      } catch (err) {
        console.error(err);
        this.mostrarAlerta(
          err.response?.data?.message || "Error al definir facturación",
          "danger",
        );
      } finally {
        this.cargandoPago = false;
      }
    },
    async verificarNitManual() {
      if (!this.nitReceptor.trim()) return;
      this.cargandoVerificacionNit = true;
      this.nitVerificado = false;
      try {
        const { data: nitInfo } = await axios.get(
          `${API_URL}/facturas-fel/verificar-nit/${encodeURIComponent(
            this.nitReceptor.trim(),
          )}`,
        );
        if (nitInfo.valido) {
          this.nitVerificado = true;
          if (nitInfo.nombre) this.nombreReceptor = nitInfo.nombre;
          this.mostrarAlerta("NIT verificado correctamente", "success");
        } else {
          this.mostrarAlerta("NIT no válido o no encontrado", "danger");
        }
      } catch {
        this.mostrarAlerta("Error al verificar el NIT", "danger");
      } finally {
        this.cargandoVerificacionNit = false;
      }
    },
    async seleccionarTipoFactura(conFactura) {
      try {
        this.cargandoPago = true;

        // Guardar como facturado (el usuario ya indicó "Sí" en paso 1)
        await axios.post(
          `${API_URL}/definir-factura-habitacion/${this.habitacionSeleccionada.IdReservaHabitacion}`,
          { facturado: 1 },
        );
        this.habitacionSeleccionada.Facturado = 1;

        this.mostrarModalFactura = false;
        this.pasoModalFactura = 0;
        this.generarFactura = true;
        this.requiereFactura = conFactura; // true=NIT, false=CF

        if (conFactura) {
          const h = this.reserva?.huesped;
          const nitHuesped = h?.NIT || "";
          if (nitHuesped) {
            this.nitReceptor = nitHuesped;
            try {
              const { data: nitInfo } = await axios.get(
                `${API_URL}/facturas-fel/verificar-nit/${encodeURIComponent(
                  nitHuesped,
                )}`,
              );
              this.nombreReceptor =
                nitInfo.valido && nitInfo.nombre
                  ? nitInfo.nombre
                  : [h?.Nombre, h?.Apellido].filter(Boolean).join(" ");
              this.nitVerificado = !!nitInfo.valido;
            } catch {
              this.nombreReceptor = [h?.Nombre, h?.Apellido]
                .filter(Boolean)
                .join(" ");
            }
          } else {
            // No tiene NIT registrado — dejar campos vacíos para ingreso manual
            this.nitReceptor = "";
            this.nombreReceptor = [h?.Nombre, h?.Apellido]
              .filter(Boolean)
              .join(" ");
          }
        } else {
          this.nitReceptor = "";
          this.nombreReceptor = "";
        }

        // Cargar métodos de pago facturados
        await this.cargarMetodosPago(true);
      } catch (err) {
        console.error("Error al definir facturación:", err);
        this.mostrarAlerta(
          err.response?.data?.message || "Error al definir facturación",
          "danger",
        );
      } finally {
        this.cargandoPago = false;
      }
    },
    async cargarMetodosPago(conFactura) {
      try {
        this.cargandoPago = true;

        // Cargar métodos de pago según si es facturado o no
        const endpoint = conFactura
          ? `${API_URL}/metodos-pago/facturados`
          : `${API_URL}/metodos-pago/no-facturados`;

        const { data } = await axios.get(endpoint);
        this.metodosPago = Array.isArray(data) ? data : [];

        this.popularSeleccion(this.habitacionSeleccionada);
        this.vistaPago = "seleccion";

        this.modalPagoVisible = true;
      } catch (err) {
        console.error("Error al cargar métodos de pago:", err);
        this.mostrarAlerta("Error al cargar métodos de pago", "danger");
      } finally {
        this.cargandoPago = false;
      }
    },
    cerrarModalPago() {
      this.modalPagoVisible = false;
      this.resetearFormularioPago();
    },
    resetearFormularioPago() {
      this.metodoPagoSeleccionado = null;
      this.montoPago = null;
      this.numeroReferencia = "";
      this.metodosPago = [];
      this.cuentaBancariaSeleccionada = null;
      this.nitReceptor = "";
      this.nombreReceptor = "";
      this.direccionReceptor = "";
      this.nitVerificado = false;
      this.otroServicioHotel = false;
      this.otroServicioRestaurante = false;
      this.otroServicioTodo = false;
      this.esExtranjero = false;
      this.numeroFacturaManual = "";
      this.conceptoPago = "todo";
      this.descripcionDetalladaHotel = false;
      this.descripcionDetalladaRestaurante = false;
      this.lineasDetalleHotel = [];
      this.lineasDetalleRestaurante = [];
      this.seleccion = {};
      this.vistaPago = "seleccion";
      this.pagoCombinado = false;
      this.pagosCombinados = [];
      this.pagosCombinadosValidos = false;
      this.grupoPagoCombinado = "";
    },
    requiereReferencia(idMetodo) {
      return [2, 3, 4].includes(Number(idMetodo));
    },
    async procesarPago() {
      if (this.detalleFacturaInvalido) {
        return this.mostrarAlerta(MENSAJE_DETALLE_INVALIDO, "danger");
      }
      if (!this.metodoPagoSeleccionado || this.totalSeleccionado <= 0) {
        return this.mostrarAlerta(
          "Seleccione un método de pago y al menos un ítem",
          "danger",
        );
      }

      if (
        this.metodoPagoSeleccionado === 2 &&
        !this.cuentaBancariaSeleccionada
      ) {
        return this.mostrarAlerta("Seleccione una cuenta bancaria", "danger");
      }

      if (
        [2, 3, 4].includes(this.metodoPagoSeleccionado) &&
        !this.numeroReferencia
      ) {
        return this.mostrarAlerta("Ingrese el número de referencia", "danger");
      }

      if (this.requiereFactura && !this.nitReceptor.trim()) {
        return this.mostrarAlerta(
          "Ingrese el NIT del receptor para la factura",
          "danger",
        );
      }
      if (this.requiereFactura) {
        try {
          const { data: nitInfo } = await axios.get(
            `${API_URL}/facturas-fel/verificar-nit/${encodeURIComponent(
              this.nitReceptor.trim(),
            )}`,
          );
          if (!nitInfo.valido) {
            return this.mostrarAlerta(
              "El NIT ingresado no existe en el RTU de la SAT. Verifique el NIT o use CF.",
              "danger",
            );
          }
        } catch (_e) {
          if (!/^\d{1,8}(-[\dK])?$/i.test(this.nitReceptor.trim())) {
            return this.mostrarAlerta(
              "El NIT ingresado no tiene un formato válido. Ejemplo: 1234567-8 ó 1234567-K",
              "danger",
            );
          }
        }
      }

      try {
        this.cargandoPago = true;

        const total = this.totalSeleccionado;
        const payload = {
          IdReserva: this.reserva.IdReserva,
          items: this.itemsSeleccionados,
          pagos: [
            {
              Monto: total,
              IdMetodoPago: this.metodoPagoSeleccionado,
              NumeroReferencia: [2, 3, 4].includes(this.metodoPagoSeleccionado)
                ? this.numeroReferencia
                : null,
              IdCuentaBancaria:
                this.metodoPagoSeleccionado === 2
                  ? this.cuentaBancariaSeleccionada
                  : null,
            },
          ],
          GrupoPago: this.generarUUID(),
          factura: {
            generar: this.generarFactura,
            receptor_nit: this.requiereFactura ? this.nitReceptor.trim() : "CF",
            receptor_nombre: this.requiereFactura
              ? this.nombreReceptor.trim() || "Consumidor Final"
              : "Consumidor Final",
            receptor_direccion: this.generarFactura
              ? this.direccionReceptor.trim() || null
              : null,
            otro_servicio_hotel: this.otroServicioHotel,
            otro_servicio_restaurante: this.otroServicioRestaurante,
            otro_servicio_todo: this.otroServicioTodo,
            descripcion_detallada_hotel: this.descripcionDetalladaHotel,
            descripcion_detallada_restaurante:
              this.descripcionDetalladaRestaurante,
            ...this.lineasDetallePayload(
              this.totalDetalleHospedaje,
              this.totalDetalleCuentas,
            ),
          },
          NumeroFacturaManual:
            !this.generarFactura && this.esExtranjero
              ? this.numeroFacturaManual.trim() || null
              : null,
        };

        const { data } = await axios.post(
          `${API_URL}/pago-items-seleccionados`,
          payload,
        );

        if (data.TotalPagado && Math.abs(data.TotalPagado - total) > 0.02) {
          this.mostrarAlerta(
            `⚠ ATENCIÓN: Se solicitó Q${total.toFixed(
              2,
            )} pero se registró Q${data.TotalPagado.toFixed(
              2,
            )}. El saldo en BD era diferente al mostrado. Contacte al administrador.`,
            "warning",
            15000,
          );
        }

        this.mostrarAlerta(
          data.message || "Pago registrado correctamente",
          "success",
        );

        if (!data.factura?.uuid) {
          setTimeout(() => {
            this.imprimirComprobanteAutomatico({
              Monto: total,
              NumeroReferencia: [2, 3, 4].includes(this.metodoPagoSeleccionado)
                ? this.numeroReferencia
                : null,
              metodo_pago: {
                Metodo:
                  this.metodosPago.find(
                    (m) => m.IdMetodoPago === this.metodoPagoSeleccionado,
                  )?.Metodo || "N/A",
              },
              cuenta_bancaria: null,
            });
          }, 500);
        }

        if (data.factura?.uuid) {
          this.esperandoImpresion = true;
          setTimeout(() => this.imprimirFacturaCarta(data.factura.uuid), 900);
        }

        this.cerrarModalPago();

        await this.obtenerDetalleReserva(this.route.params.id);
        await this.cargarPagosHabitacion();
      } catch (err) {
        console.error(err);
        this.mostrarAlerta(
          err.response?.data?.message || "Error al procesar el pago",
          "danger",
          8000,
        );
      } finally {
        this.cargandoPago = false;
      }
    },
    construirItemsTodasHabitaciones() {
      const items = [];
      for (const hab of this.habitaciones) {
        const saldo = parseFloat(hab.SaldoPendienteHabitacion) || 0;
        if (saldo <= 0.009) continue;

        let restante = saldo;

        const cuentas = (hab.cuentas_pedido || [])
          .filter((c) => c.Estado != 2)
          .sort((a, b) => a.IdCuentaPedido - b.IdCuentaPedido);

        for (const c of cuentas) {
          if (restante <= 0.009) break;
          const cSaldo =
            parseFloat(c.SaldoPendienteCuenta) || parseFloat(c.Total) || 0;
          const asignado = Math.min(restante, cSaldo);
          if (asignado > 0.009) {
            items.push({
              tipo: "cuenta",
              id_cuenta_pedido: c.IdCuentaPedido,
              monto: Math.round(asignado * 100) / 100,
            });
            restante -= asignado;
          }
        }

        const servicios = (hab.servicios_extra || [])
          .filter((s) => s.EstadoPago == 0)
          .sort((a, b) => a.IdServicioExtraTotal - b.IdServicioExtraTotal);

        for (const s of servicios) {
          if (restante <= 0.009) break;
          const total = parseFloat(s.Total) || 0;
          const asignado = Math.min(restante, total);
          if (asignado > 0.009) {
            items.push({
              tipo: "servicio",
              id_servicio_extra_total: s.IdServicioExtraTotal,
              monto: Math.round(asignado * 100) / 100,
            });
            restante -= asignado;
          }
        }

        if (restante > 0.009) {
          items.push({
            tipo: "hospedaje",
            id_reserva_habitacion: hab.IdReservaHabitacion,
            monto: Math.round(restante * 100) / 100,
          });
        }
      }
      return items;
    },

    construirHabitacionesAfectadas(items) {
      const montos = {};
      for (const item of items) {
        let idHab;
        if (item.tipo === "hospedaje") {
          idHab = item.id_reserva_habitacion;
        } else if (item.tipo === "cuenta") {
          for (const hab of this.habitaciones) {
            if (
              (hab.cuentas_pedido || []).some(
                (c) => c.IdCuentaPedido === item.id_cuenta_pedido,
              )
            ) {
              idHab = hab.IdReservaHabitacion;
              break;
            }
          }
        } else if (item.tipo === "servicio") {
          for (const hab of this.habitaciones) {
            if (
              (hab.servicios_extra || []).some(
                (s) =>
                  s.IdServicioExtraTotal === item.id_servicio_extra_total,
              )
            ) {
              idHab = hab.IdReservaHabitacion;
              break;
            }
          }
        }
        if (idHab != null) {
          montos[idHab] = (montos[idHab] || 0) + item.monto;
        }
      }
      return Object.entries(montos).map(([idHab, monto]) => {
        const hab = this.habitaciones.find(
          (h) => h.IdReservaHabitacion == idHab,
        );
        return {
          IdReservaHabitacion: Number(idHab),
          NumeroHabitacion: hab?.habitacion?.Numero || idHab,
          MontoPagado: Math.round(monto * 100) / 100,
        };
      });
    },

    popularSeleccion(hab) {
      this.seleccion = {};
      const saldo = parseFloat(hab.SaldoPendienteHabitacion) || 0;
      if (saldo <= 0.009) return;

      const cuentas = (hab.cuentas_pedido || [])
        .filter((c) => c.Estado != 2)
        .sort((a, b) => a.IdCuentaPedido - b.IdCuentaPedido);

      for (const c of cuentas) {
        const max =
          Math.round(
            (parseFloat(c.SaldoPendienteCuenta) ||
              parseFloat(c.Total) ||
              0) * 100,
          ) / 100;
        if (max > 0.009) {
          this.seleccion[`cuenta:${c.IdCuentaPedido}`] = {
            monto: max,
            max,
            label: c.NombreCuenta || `Cuenta #${c.IdCuentaPedido}`,
            subtipo: "cuenta",
            activo: true,
            idHab: hab.IdReservaHabitacion,
            idPedido: c.IdPedido || null,
          };
        }
      }

      const servicios = (hab.servicios_extra || [])
        .filter((s) => s.EstadoPago == 0)
        .sort((a, b) => a.IdServicioExtraTotal - b.IdServicioExtraTotal);

      for (const s of servicios) {
        const max = Math.round((parseFloat(s.Total) || 0) * 100) / 100;
        if (max > 0.009) {
          this.seleccion[`servicio:${s.IdServicioExtraTotal}`] = {
            monto: max,
            max,
            label: s.Nombre || `Servicio #${s.IdServicioExtraTotal}`,
            subtipo: "servicio",
            activo: true,
            idHab: hab.IdReservaHabitacion,
          };
        }
      }

      const totalCuentas = cuentas.reduce(
        (s, c) =>
          s + (parseFloat(c.SaldoPendienteCuenta) || parseFloat(c.Total) || 0),
        0,
      );
      const totalServicios = servicios.reduce(
        (s, sv) => s + (parseFloat(sv.Total) || 0),
        0,
      );
      const hospedajePuro = Math.max(0, saldo - totalCuentas - totalServicios);
      if (hospedajePuro > 0.009) {
        const max = Math.round(hospedajePuro * 100) / 100;
        this.seleccion[`hospedaje:${hab.IdReservaHabitacion}`] = {
          monto: max,
          max,
          label: "Hospedaje",
          subtipo: "hospedaje",
          activo: true,
          idHab: hab.IdReservaHabitacion,
        };
      }
    },

    toggleSeleccion(key) {
      if (this.seleccion[key]) {
        this.seleccion[key].activo = !this.seleccion[key].activo;
        if (!this.seleccion[key].activo) {
          this.seleccion[key].monto = this.seleccion[key].max;
        }
      }
    },

    clampMontoSeleccion(key) {
      const item = this.seleccion[key];
      if (!item) return;
      const v = parseFloat(item.monto) || 0;
      item.monto = Math.min(Math.max(0.01, v), item.max);
      if (item.monto < 0.009) item.activo = false;
    },

    seleccionarTodo() {
      for (const key in this.seleccion) {
        this.seleccion[key].activo = true;
        this.seleccion[key].monto = this.seleccion[key].max;
      }
    },

    deseleccionarTodo() {
      for (const key in this.seleccion) {
        this.seleccion[key].activo = false;
      }
    },

    irAPago() {
      if (this.pagoCombinado) {
        this.pagosCombinados = [];
        this.pagosCombinadosValidos = false;
        this.grupoPagoCombinado = this.generarUUID();
      } else {
        this.montoPago = this.totalSeleccionado;
      }
      this.vistaPago = "pago";
    },

    volverASeleccion() {
      this.vistaPago = "seleccion";
    },

    // ── Métodos para selección RC (todas las habitaciones) ─────────────────
    popularSeleccionRC() {
      this.seleccionRC = {};
      for (const hab of this.habitaciones) {
        const saldo = parseFloat(hab.SaldoPendienteHabitacion) || 0;
        if (saldo <= 0.009) continue;
        const habNumero = hab.habitacion?.Numero || hab.IdReservaHabitacion;

        const cuentas = (hab.cuentas_pedido || [])
          .filter((c) => c.Estado != 2)
          .sort((a, b) => a.IdCuentaPedido - b.IdCuentaPedido);

        for (const c of cuentas) {
          const max =
            Math.round(
              (parseFloat(c.SaldoPendienteCuenta) ||
                parseFloat(c.Total) ||
                0) * 100,
            ) / 100;
          if (max > 0.009) {
            this.seleccionRC[`cuenta:${c.IdCuentaPedido}`] = {
              monto: max,
              max,
              label: c.NombreCuenta || `Cuenta #${c.IdCuentaPedido}`,
              subtipo: "cuenta",
              activo: true,
              idHab: hab.IdReservaHabitacion,
              habNumero,
              idPedido: c.IdPedido || null,
            };
          }
        }

        const servicios = (hab.servicios_extra || [])
          .filter((s) => s.EstadoPago == 0)
          .sort((a, b) => a.IdServicioExtraTotal - b.IdServicioExtraTotal);

        for (const s of servicios) {
          const max = Math.round((parseFloat(s.Total) || 0) * 100) / 100;
          if (max > 0.009) {
            this.seleccionRC[`servicio:${s.IdServicioExtraTotal}`] = {
              monto: max,
              max,
              label: s.Nombre || `Servicio #${s.IdServicioExtraTotal}`,
              subtipo: "servicio",
              activo: true,
              idHab: hab.IdReservaHabitacion,
              habNumero,
            };
          }
        }

        const totalCuentas = cuentas.reduce(
          (s, c) =>
            s +
            (parseFloat(c.SaldoPendienteCuenta) || parseFloat(c.Total) || 0),
          0,
        );
        const totalServicios = servicios.reduce(
          (s, sv) => s + (parseFloat(sv.Total) || 0),
          0,
        );
        const hospedajePuro = Math.max(0, saldo - totalCuentas - totalServicios);
        if (hospedajePuro > 0.009) {
          const max = Math.round(hospedajePuro * 100) / 100;
          this.seleccionRC[`hospedaje:${hab.IdReservaHabitacion}`] = {
            monto: max,
            max,
            label: `Hospedaje Hab. ${habNumero}`,
            subtipo: "hospedaje",
            activo: true,
            idHab: hab.IdReservaHabitacion,
            habNumero,
          };
        }
      }
    },

    toggleSeleccionRC(key) {
      if (this.seleccionRC[key]) {
        this.seleccionRC[key].activo = !this.seleccionRC[key].activo;
        if (!this.seleccionRC[key].activo) {
          this.seleccionRC[key].monto = this.seleccionRC[key].max;
        }
      }
    },

    clampMontoSeleccionRC(key) {
      const item = this.seleccionRC[key];
      if (!item) return;
      const v = parseFloat(item.monto) || 0;
      item.monto = Math.min(Math.max(0.01, v), item.max);
      if (item.monto < 0.009) item.activo = false;
    },

    seleccionarTodoRC() {
      for (const key in this.seleccionRC) {
        this.seleccionRC[key].activo = true;
        this.seleccionRC[key].monto = this.seleccionRC[key].max;
      }
    },

    deseleccionarTodoRC() {
      for (const key in this.seleccionRC) {
        this.seleccionRC[key].activo = false;
      }
    },

    irAPagoRC() {
      // Derivar conceptoPagoRC desde la selección para que los condicionales FEL funcionen
      const hasHotel = this.hayHospedajeRC || this.hayServicioRC;
      const hasRest = this.hayCuentaRC;
      if (hasHotel && hasRest) this.conceptoPagoRC = "todo";
      else if (hasHotel) this.conceptoPagoRC = "solo_hospedaje";
      else this.conceptoPagoRC = "solo_restaurante";

      if (this.pagoCombinadoRC) {
        this.pagosCombinadosRC = [];
        this.pagosCombinadosRCValidos = false;
        this.grupoPagoCombinadoRC = this.generarUUID();
      } else {
        this.montoPagoReservaCompleta = this.totalSeleccionadoRC;
      }
      this.vistaPagoRC = "pago";
    },

    volverASeleccionRC() {
      this.vistaPagoRC = "seleccion";
    },

    generarUUID() {
      return "xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx".replace(/[xy]/g, (c) => {
        const r = (Math.random() * 16) | 0;
        const v = c === "x" ? r : (r & 0x3) | 0x8;
        return v.toString(16);
      });
    },

    construirItemsDesdeConcepto() {
      const items = [];
      const hab = this.habitacionSeleccionada;
      const monto = parseFloat(this.montoPago) || 0;

      if (this.conceptoPago === "solo_hospedaje") {
        items.push({
          tipo: "hospedaje",
          id_reserva_habitacion: hab.IdReservaHabitacion,
          monto,
        });
        return items;
      }

      if (this.conceptoPago === "solo_restaurante") {
        const cuentas = (hab.cuentas_pedido || [])
          .filter((c) => c.Estado != 2)
          .sort((a, b) => a.IdCuentaPedido - b.IdCuentaPedido);
        let restante = monto;
        for (const c of cuentas) {
          if (restante <= 0.009) break;
          const saldo =
            parseFloat(c.SaldoPendienteCuenta) || parseFloat(c.Total) || 0;
          const asignado = Math.min(restante, saldo);
          if (asignado > 0.009) {
            items.push({
              tipo: "cuenta",
              id_cuenta_pedido: c.IdCuentaPedido,
              monto: Math.round(asignado * 100) / 100,
            });
            restante -= asignado;
          }
        }
        return items;
      }

      // conceptoPago === "todo": cuentas primero, luego servicios, luego hospedaje
      const cuentas = (hab.cuentas_pedido || [])
        .filter((c) => c.Estado != 2)
        .sort((a, b) => a.IdCuentaPedido - b.IdCuentaPedido);
      let restante = monto;

      for (const c of cuentas) {
        if (restante <= 0.009) break;
        const saldo =
          parseFloat(c.SaldoPendienteCuenta) || parseFloat(c.Total) || 0;
        const asignado = Math.min(restante, saldo);
        if (asignado > 0.009) {
          items.push({
            tipo: "cuenta",
            id_cuenta_pedido: c.IdCuentaPedido,
            monto: Math.round(asignado * 100) / 100,
          });
          restante -= asignado;
        }
      }

      const servicios = (hab.servicios_extra || [])
        .filter((s) => s.EstadoPago == 0)
        .sort((a, b) => a.IdServicioExtraTotal - b.IdServicioExtraTotal);

      for (const s of servicios) {
        if (restante <= 0.009) break;
        const total = parseFloat(s.Total) || 0;
        const asignado = Math.min(restante, total);
        if (asignado > 0.009) {
          items.push({
            tipo: "servicio",
            id_servicio_extra_total: s.IdServicioExtraTotal,
            monto: Math.round(asignado * 100) / 100,
          });
          restante -= asignado;
        }
      }

      if (restante > 0.009) {
        items.push({
          tipo: "hospedaje",
          id_reserva_habitacion: hab.IdReservaHabitacion,
          monto: Math.round(restante * 100) / 100,
        });
      }

      return items;
    },

    volver() {
      this.router.push("/reservas");
    },
    mostrarAlerta(mensaje, tipo = "success", duracion = 4000) {
      clearTimeout(this.toastTimer);
      this.alerta = { mensaje, tipo };
      this.mostrarToast = true;
      this.toastTimer = setTimeout(() => {
        this.mostrarToast = false;
      }, duracion);
    },
    cerrarToast() {
      this.mostrarToast = false;
    },
    imprimirPago(pago) {
      // Preparar datos del pago para impresión
      const pagoFormateado = {
        Monto: pago.Monto,
        NumeroReferencia: pago.NumeroReferencia,
        metodo_pago: pago.metodo_pago?.Metodo || "N/A",
        cuenta_bancaria: pago.cuenta_bancaria
          ? `${pago.cuenta_bancaria.NombreCuenta} - ${pago.cuenta_bancaria.Banco} - ${pago.cuenta_bancaria.NumeroCuenta}`
          : null,
      };

      // Preparar datos de habitación con número
      // Para pagos históricos, NO mostramos saldo (undefined) para evitar confusión
      const habitacionConNumero = {
        Numero: this.habitacionSeleccionada.habitacion?.Numero || "N/A",
      };

      imprimirReciboHotel(pagoFormateado, habitacionConNumero, this.reserva);
    },
    descargarFacturaCarta(uuid) {
      import("axios").then(({ default: axios }) => {
        axios
          .get(`facturas-fel/${uuid}/carta`, { responseType: "blob" })
          .then((res) => {
            const url = URL.createObjectURL(
              new Blob([res.data], { type: "application/pdf" }),
            );
            const a = document.createElement("a");
            a.href = url;
            a.download = `factura-${uuid}.pdf`;
            a.click();
            URL.revokeObjectURL(url);
          })
          .catch(() => {});
      });
    },
    descargarTicketTermica(uuid) {
      import("axios").then(({ default: axios }) => {
        axios
          .get(`facturas-fel/${uuid}/ticket`, { responseType: "blob" })
          .then((res) => {
            const url = URL.createObjectURL(
              new Blob([res.data], { type: "application/pdf" }),
            );
            const a = document.createElement("a");
            a.href = url;
            a.download = `ticket-${uuid}.pdf`;
            a.click();
            URL.revokeObjectURL(url);
          })
          .catch(() => {});
      });
    },
    descargarPdfFel(uuid) {
      import("axios").then(({ default: axios }) => {
        axios
          .get(`facturas-fel/${uuid}/pdf`, { responseType: "blob" })
          .then((res) => {
            const url = URL.createObjectURL(
              new Blob([res.data], { type: "application/pdf" }),
            );
            const a = document.createElement("a");
            a.href = url;
            a.download = `certificador-${uuid}.pdf`;
            a.click();
            URL.revokeObjectURL(url);
          })
          .catch(() => {});
      });
    },
    imprimirPdfFel(uuid) {
      // Fetch del PDF a través del proxy del backend (sirve inline con auth)
      import("axios").then(({ default: axios }) => {
        axios
          .get(`facturas-fel/${uuid}/pdf`, { responseType: "blob" })
          .then((res) => {
            const blobUrl = URL.createObjectURL(
              new Blob([res.data], { type: "application/pdf" }),
            );
            const existente = document.getElementById("fel-pdf-frame");
            if (existente) existente.remove();
            const iframe = document.createElement("iframe");
            iframe.id = "fel-pdf-frame";
            iframe.style.cssText =
              "position:fixed;width:1px;height:1px;opacity:0;border:none;";
            iframe.src = blobUrl;
            document.body.appendChild(iframe);
            iframe.onload = () => {
              try {
                iframe.contentWindow.print();
              } catch (e) {
                /* bloqueado por el navegador */
              }
            };
          })
          .catch(() => {
            /* fallo silencioso */
          });
      });
    },
    imprimirTicketTermica(uuid, cambio = 0) {
      // Genera ticket térmico 80mm desde el backend y abre el diálogo de impresión
      import("axios").then(({ default: axios }) => {
        const params = cambio > 0 ? { cambio } : {};
        axios
          .get(`facturas-fel/${uuid}/ticket`, { responseType: "blob", params })
          .then((res) => {
            const blobUrl = URL.createObjectURL(
              new Blob([res.data], { type: "application/pdf" }),
            );
            const existente = document.getElementById("fel-ticket-frame");
            if (existente) existente.remove();
            const iframe = document.createElement("iframe");
            iframe.id = "fel-ticket-frame";
            iframe.style.cssText =
              "position:fixed;width:1px;height:1px;opacity:0;border:none;";
            iframe.src = blobUrl;
            document.body.appendChild(iframe);
            iframe.onload = () => {
              try {
                this.esperandoImpresion = false;
                iframe.contentWindow.print();
              } catch (e) {
                this.esperandoImpresion = false;
                window.open(blobUrl, "_blank");
              }
            };
          })
          .catch(() => {
            this.esperandoImpresion = false;
          });
      });
    },
    imprimirFacturaCarta(uuid) {
      // Genera factura en hoja carta (estilo formal café) y abre el diálogo de impresión
      import("axios").then(({ default: axios }) => {
        axios
          .get(`facturas-fel/${uuid}/carta`, { responseType: "blob" })
          .then((res) => {
            const blobUrl = URL.createObjectURL(
              new Blob([res.data], { type: "application/pdf" }),
            );
            const existente = document.getElementById("fel-carta-frame");
            if (existente) existente.remove();
            const iframe = document.createElement("iframe");
            iframe.id = "fel-carta-frame";
            iframe.style.cssText =
              "position:fixed;width:1px;height:1px;opacity:0;border:none;";
            iframe.src = blobUrl;
            document.body.appendChild(iframe);
            iframe.onload = () => {
              try {
                this.esperandoImpresion = false;
                iframe.contentWindow.print();
              } catch (e) {
                this.esperandoImpresion = false;
                window.open(blobUrl, "_blank");
              }
            };
          })
          .catch(() => {
            this.esperandoImpresion = false;
          });
      });
    },

    imprimirComprobanteAutomatico(pago) {
      // Preparar datos del pago desde la respuesta del servidor
      const pagoFormateado = {
        Monto: pago.Monto,
        NumeroReferencia: pago.NumeroReferencia,
        metodo_pago: pago.metodo_pago?.Metodo || "N/A",
        cuenta_bancaria: pago.cuenta_bancaria
          ? `${pago.cuenta_bancaria.NombreCuenta} - ${pago.cuenta_bancaria.Banco} - ${pago.cuenta_bancaria.NumeroCuenta}`
          : null,
      };

      // Preparar datos de habitación con número y saldo ANTES del pago
      // El backend devuelve el saldo ya actualizado, así que sumamos el monto del pago
      const saldoAnterior =
        parseFloat(this.habitacionSeleccionada.SaldoPendienteHabitacion || 0) +
        parseFloat(pago.Monto);

      const habitacionConNumero = {
        ...this.habitacionSeleccionada,
        Numero: this.habitacionSeleccionada.habitacion?.Numero || "N/A",
        SaldoPendiente: saldoAnterior,
      };

      imprimirReciboHotel(pagoFormateado, habitacionConNumero, this.reserva);
    },
    abrirModalDescuento() {
      this.codigoDescuento = "";
      this.modalDescuentoVisible = true;
    },
    cerrarModalDescuento() {
      this.modalDescuentoVisible = false;
      this.codigoDescuento = "";
    },
    async aplicarDescuento() {
      if (!this.codigoDescuento) {
        return this.mostrarAlerta("Ingrese un código de descuento", "danger");
      }

      try {
        this.cargandoDescuento = true;

        const idReservacionHabitacion =
          this.habitacionSeleccionada.IdReservaHabitacion;
        const { data } = await axios.post(
          `${API_URL}/aplicar-descuento/${idReservacionHabitacion}`,
          { codigo: this.codigoDescuento },
        );

        this.mostrarAlerta(
          `${data.message} - Monto descontado: Q${parseFloat(
            data.montoDescuento,
          ).toFixed(2)}`,
          "success",
        );

        this.cerrarModalDescuento();

        // Recargar datos para actualizar saldo
        await this.obtenerDetalleReserva(this.route.params.id);
      } catch (err) {
        console.error(err);
        this.mostrarAlerta(
          err.response?.data?.message || "Error al aplicar el descuento",
          "danger",
        );
      } finally {
        this.cargandoDescuento = false;
      }
    },
    async confirmarQuitarDescuento() {
      if (!this.habitacionSeleccionada?.IdReservaHabitacion) return;
      try {
        this.cargandoQuitarDescuento = true;
        const idReservacionHabitacion =
          this.habitacionSeleccionada.IdReservaHabitacion;
        const { data } = await axios.post(
          `${API_URL}/quitar-descuento/${idReservacionHabitacion}`,
        );

        this.mostrarAlerta(
          data.message ||
            `Descuento revertido: Q${parseFloat(data.montoRevertido || 0).toFixed(2)}`,
          "success",
        );

        this.modalQuitarDescuentoVisible = false;
        await this.recargarDetalleReservaPreservandoSeleccion();
      } catch (err) {
        console.error(err);
        this.mostrarAlerta(
          err.response?.data?.message || "Error al quitar el descuento",
          "danger",
        );
      } finally {
        this.cargandoQuitarDescuento = false;
      }
    },
    async revertirCheckout() {
      if (!this.habitacionSeleccionada?.IdReservaHabitacion) return;
      this.modalRevertirCheckoutVisible = true;
    },
    async ejecutarRevertirCheckout() {
      try {
        this.cargandoPago = true;
        const { data } = await axios.put(
          `${API_URL}/reservas-habitacion/revertir-checkout/${this.habitacionSeleccionada.IdReservaHabitacion}`,
        );
        this.modalRevertirCheckoutVisible = false;
        this.mostrarAlerta(
          data.message || "Checkout revertido correctamente",
          "success",
        );
        await this.obtenerDetalleReserva(this.route.params.id);
      } catch (err) {
        console.error(err);
        this.mostrarAlerta(
          err.response?.data?.message || "Error al revertir el checkout",
          "danger",
        );
      } finally {
        this.cargandoPago = false;
      }
    },
    async realizarCheckout() {
      // Validar usando el saldo pendiente
      const saldo = Number(
        this.habitacionSeleccionada?.SaldoPendienteHabitacion || 0,
      );
      if (saldo > 0) {
        return this.mostrarAlerta(
          "Debe pagar completamente la habitación antes de hacer checkout",
          "danger",
        );
      }

      if (this.habitacionSeleccionada?.CheckOut) {
        return this.mostrarAlerta("El checkout ya fue realizado", "warning");
      }

      try {
        this.cargandoPago = true;

        const { data } = await axios.put(
          `${API_URL}/reservas-habitacion/checkout/${this.habitacionSeleccionada.IdReservaHabitacion}`,
        );

        this.mostrarAlerta(
          data.message || "Checkout realizado correctamente",
          "success",
        );

        // Recargar datos
        await this.obtenerDetalleReserva(this.route.params.id);
      } catch (err) {
        console.error(err);
        this.mostrarAlerta(
          err.response?.data?.message || "Error al realizar el checkout",
          "danger",
        );
      } finally {
        this.cargandoPago = false;
      }
    },
    // Métodos para operaciones de reserva completa
    async abrirModalPagoReservaCompleta() {
      // Resetear concepto de pago y opciones FEL
      this.conceptoPagoRC = "todo";
      this.descripcionDetalladaHotel = false;
      this.lineasDetalleHotel = [];
      this.descripcionDetalladaRestaurante = false;
      this.lineasDetalleRestaurante = [];
      this.otroServicioHotel = false;
      this.otroServicioRestaurante = false;
      this.otroServicioTodo = false;
      // Abrir modal desde el paso 1 (¿factura?)
      this.pasoModalFacturaRC = 1;
      this.mostrarModalFacturaReservaCompleta = true;
    },
    // ── Pago Combinado de la reserva completa (multi-método) ────────────────
    // Vive DENTRO del modal de "Pagar Total de la Reserva": el checkbox
    // "pagoCombinadoRC" en la vista de selección alterna la vista de pago.
    // Reutiliza generarFacturaRC/tipoPagoReservaCompleta/nitReceptor/etc.
    async procesarPagoCombinadoRC() {
      if (this.detalleFacturaInvalidoRC) {
        return this.mostrarAlerta(MENSAJE_DETALLE_INVALIDO, "danger");
      }
      if (!this.pagosCombinadosRCValidos) {
        return this.mostrarAlerta(
          "Revisa los métodos de pago capturados",
          "danger",
        );
      }
      if (this.tipoPagoReservaCompleta === 1 && !this.nitVerificado) {
        return this.mostrarAlerta("Verifique el NIT antes de pagar", "danger");
      }

      try {
        this.cargandoPagoCombinadoRC = true;

        const items = this.itemsPagoRC;
        const payload = {
          IdReserva: this.reserva.IdReserva,
          items,
          pagos: this.pagosCombinadosRC.map((p) => ({
            Monto: p.Monto,
            IdMetodoPago: p.IdMetodoPago,
            NumeroReferencia: this.requiereReferencia(p.IdMetodoPago)
              ? p.NumeroReferencia
              : null,
            IdCuentaBancaria: p.IdMetodoPago === 2 ? p.IdCuentaBancaria : null,
          })),
          GrupoPago: this.grupoPagoCombinadoRC,
          factura: {
            generar: true,
            receptor_nit:
              this.tipoPagoReservaCompleta === 1
                ? this.nitReceptor.trim()
                : "CF",
            receptor_nombre:
              this.tipoPagoReservaCompleta === 1
                ? this.nombreReceptor.trim() || "Consumidor Final"
                : "Consumidor Final",
            receptor_direccion: this.direccionReceptor.trim() || null,
            otro_servicio_hotel: this.otroServicioHotel,
            otro_servicio_restaurante: this.otroServicioRestaurante,
            otro_servicio_todo: this.otroServicioTodo,
            descripcion_detallada_hotel: this.descripcionDetalladaHotel,
            descripcion_detallada_restaurante:
              this.descripcionDetalladaRestaurante,
            ...this.lineasDetallePayload(
              this.totalDetalleHospedajeRC,
              this.totalDetalleCuentasRC,
            ),
          },
          NumeroFacturaManual: null,
        };

        const { data } = await axios.post(
          `${API_URL}/pago-combinado-items`,
          payload,
        );

        this.mostrarAlerta(
          data.message || "Pago combinado registrado correctamente",
          "success",
        );

        if (data.factura?.uuid) {
          this.esperandoImpresion = true;
          setTimeout(() => this.imprimirFacturaCarta(data.factura.uuid), 900);
        }

        this.cerrarModalPagoReservaCompleta();

        await this.obtenerDetalleReserva(this.route.params.id);
      } catch (err) {
        console.error(err);
        this.mostrarAlerta(
          err.response?.data?.message || "Error al procesar el pago combinado",
          "danger",
          8000,
        );
      } finally {
        this.cargandoPagoCombinadoRC = false;
      }
    },
    cerrarModalFacturaReservaCompleta() {
      this.mostrarModalFacturaReservaCompleta = false;
      this.pasoModalFacturaRC = 1;
    },
    onConceptoPagoRCChange() {
      // Ajustar monto según concepto
      if (this.conceptoPagoRC === "solo_hospedaje") {
        this.montoPagoReservaCompleta = parseFloat(
          this.saldoTotalHospedajePendiente.toFixed(2),
        );
        // Limpiar opciones FEL de restaurante (no aplican)
        this.descripcionDetalladaRestaurante = false;
        this.lineasDetalleRestaurante = [];
        this.otroServicioRestaurante = false;
        this.otroServicioTodo = false;
      } else if (this.conceptoPagoRC === "solo_restaurante") {
        this.montoPagoReservaCompleta = parseFloat(
          this.saldoTotalRestaurantePendiente.toFixed(2),
        );
        // Limpiar opciones FEL de hospedaje (no aplican)
        this.descripcionDetalladaHotel = false;
        this.lineasDetalleHotel = [];
        this.otroServicioHotel = false;
        this.otroServicioTodo = false;
      } else {
        this.montoPagoReservaCompleta = parseFloat(
          Number(this.saldoTotalPendiente).toFixed(2),
        );
      }
    },
    avanzarANitOCfRC() {
      this.pasoModalFacturaRC = 2;
    },
    async seleccionarSinFacturaRC() {
      try {
        this.cargandoPagoReservaCompleta = true;
        this.generarFacturaRC = false;
        this.tipoPagoReservaCompleta = 2;
        this.mostrarModalFacturaReservaCompleta = false;
        this.pasoModalFacturaRC = 1;
        this.nitReceptor = "";
        this.nombreReceptor = "";
        const { data } = await axios.get(
          `${API_URL}/metodos-pago/no-facturados`,
        );
        this.metodosPagoReservaCompleta = Array.isArray(data) ? data : [];
        this.montoPagoReservaCompleta = this.saldoTotalPendiente;
        this.popularSeleccionRC();
        this.vistaPagoRC = "seleccion";
        this.modalPagoReservaCompletaVisible = true;
      } catch (err) {
        console.error(err);
        this.mostrarAlerta("Error al cargar métodos de pago", "danger");
      } finally {
        this.cargandoPagoReservaCompleta = false;
      }
    },
    async seleccionarTipoFacturaReservaCompleta(conFactura) {
      try {
        this.cargandoPagoReservaCompleta = true;

        this.generarFacturaRC = true;
        this.tipoPagoReservaCompleta = conFactura ? 1 : 2;
        this.mostrarModalFacturaReservaCompleta = false;
        this.pasoModalFacturaRC = 1;

        if (conFactura) {
          const h = this.reserva?.huesped;
          const nitHuesped = h?.NIT || "";
          if (nitHuesped) {
            this.nitReceptor = nitHuesped;
            try {
              const { data: nitInfo } = await axios.get(
                `${API_URL}/facturas-fel/verificar-nit/${encodeURIComponent(
                  nitHuesped,
                )}`,
              );
              this.nombreReceptor =
                nitInfo.valido && nitInfo.nombre
                  ? nitInfo.nombre
                  : [h?.Nombre, h?.Apellido].filter(Boolean).join(" ");
              this.nitVerificado = !!nitInfo.valido;
            } catch {
              this.nombreReceptor = [h?.Nombre, h?.Apellido]
                .filter(Boolean)
                .join(" ");
              this.nitVerificado = false;
            }
          } else {
            this.nitReceptor = "";
            this.nitVerificado = false;
            this.nombreReceptor = [h?.Nombre, h?.Apellido]
              .filter(Boolean)
              .join(" ");
          }
        } else {
          this.nitReceptor = "";
          this.nitVerificado = false;
          this.nombreReceptor = "";
        }

        const { data } = await axios.get(`${API_URL}/metodos-pago/facturados`);
        this.metodosPagoReservaCompleta = Array.isArray(data) ? data : [];
        this.montoPagoReservaCompleta = this.saldoTotalPendiente;
        this.popularSeleccionRC();
        this.vistaPagoRC = "seleccion";
        this.modalPagoReservaCompletaVisible = true;
      } catch (err) {
        console.error("Error al cargar métodos de pago:", err);
        this.mostrarAlerta("Error al cargar métodos de pago", "danger");
      } finally {
        this.cargandoPagoReservaCompleta = false;
      }
    },
    cerrarModalPagoReservaCompleta() {
      this.modalPagoReservaCompletaVisible = false;
      this.metodoPagoReservaCompleta = null;
      this.montoPagoReservaCompleta = null;
      this.numeroReferenciaReservaCompleta = "";
      this.cuentaBancariaReservaCompleta = null;
      this.metodosPagoReservaCompleta = [];
      this.tipoPagoReservaCompleta = null;
      this.nitReceptor = "";
      this.nombreReceptor = "";
      this.nitVerificado = false;
      this.otroServicioHotel = false;
      this.otroServicioRestaurante = false;
      this.otroServicioTodo = false;
      this.descripcionDetalladaHotel = false;
      this.descripcionDetalladaRestaurante = false;
      this.lineasDetalleHotel = [];
      this.lineasDetalleRestaurante = [];
      this.seleccionRC = {};
      this.vistaPagoRC = "seleccion";
      this.pagoCombinadoRC = false;
      this.pagosCombinadosRC = [];
      this.pagosCombinadosRCValidos = false;
      this.grupoPagoCombinadoRC = "";
    },
    async procesarPagoReservaCompleta() {
      if (this.detalleFacturaInvalidoRC) {
        return this.mostrarAlerta(MENSAJE_DETALLE_INVALIDO, "danger");
      }
      if (
        !this.metodoPagoReservaCompleta ||
        !this.montoPagoReservaCompleta ||
        !this.tipoPagoReservaCompleta
      ) {
        return this.mostrarAlerta(
          "Complete todos los campos requeridos",
          "danger",
        );
      }

      if (
        this.metodoPagoReservaCompleta === 2 &&
        !this.cuentaBancariaReservaCompleta
      ) {
        return this.mostrarAlerta("Seleccione una cuenta bancaria", "danger");
      }

      // Validar referencia para métodos 2, 3 y 4
      if (
        [2, 3, 4].includes(this.metodoPagoReservaCompleta) &&
        !this.numeroReferenciaReservaCompleta
      ) {
        return this.mostrarAlerta("Ingrese el número de referencia", "danger");
      }

      if (this.tipoPagoReservaCompleta === 1 && !this.nitReceptor.trim()) {
        return this.mostrarAlerta(
          "Ingrese el NIT del receptor para la factura",
          "danger",
        );
      }
      if (this.tipoPagoReservaCompleta === 1) {
        try {
          const { data: nitInfo } = await axios.get(
            `${API_URL}/facturas-fel/verificar-nit/${encodeURIComponent(
              this.nitReceptor.trim(),
            )}`,
          );
          if (!nitInfo.valido) {
            return this.mostrarAlerta(
              "El NIT ingresado no existe en el RTU de la SAT. Verifique el NIT o use CF.",
              "danger",
            );
          }
        } catch (_e) {
          // Si el servicio de verificación no responde, validar solo el formato
          if (!/^\d{1,8}(-[\dK])?$/i.test(this.nitReceptor.trim())) {
            return this.mostrarAlerta(
              "El NIT ingresado no tiene un formato válido. Ejemplo: 1234567-8 ó 1234567-K",
              "danger",
            );
          }
        }
      }

      try {
        this.cargandoPagoReservaCompleta = true;

        const items = this.itemsPagoRC;
        const payload = {
          IdReserva: this.reserva.IdReserva,
          items,
          pagos: [
            {
              Monto: this.montoPagoReservaCompleta,
              IdMetodoPago: this.metodoPagoReservaCompleta,
              NumeroReferencia: [2, 3, 4].includes(
                this.metodoPagoReservaCompleta,
              )
                ? this.numeroReferenciaReservaCompleta
                : null,
              IdCuentaBancaria:
                this.metodoPagoReservaCompleta === 2
                  ? this.cuentaBancariaReservaCompleta
                  : null,
            },
          ],
          GrupoPago: this.generarUUID(),
          factura: {
            generar: this.generarFacturaRC,
            receptor_nit:
              this.tipoPagoReservaCompleta === 1
                ? this.nitReceptor.trim()
                : "CF",
            receptor_nombre:
              this.tipoPagoReservaCompleta === 1
                ? this.nombreReceptor.trim() || "Consumidor Final"
                : "Consumidor Final",
            receptor_direccion: this.generarFacturaRC
              ? this.direccionReceptor.trim() || null
              : null,
            otro_servicio_hotel: this.otroServicioHotel,
            otro_servicio_restaurante: this.otroServicioRestaurante,
            otro_servicio_todo: this.otroServicioTodo,
            descripcion_detallada_hotel: this.descripcionDetalladaHotel,
            descripcion_detallada_restaurante: this.descripcionDetalladaRestaurante,
            ...this.lineasDetallePayload(
              this.totalDetalleHospedajeRC,
              this.totalDetalleCuentasRC,
            ),
          },
          NumeroFacturaManual: null,
        };

        const { data } = await axios.post(
          `${API_URL}/pago-items-seleccionados`,
          payload,
        );

        this.mostrarAlerta(
          data.message ||
            `Pago total registrado correctamente.`,
          "success",
        );

        // Solo imprimir recibo cuando NO hay factura (la factura reemplaza al recibo)
        if (!data.factura?.uuid) {
          setTimeout(() => {
            if (data.TotalPagado > 0) {
              const habitacionesAfectadas =
                this.construirHabitacionesAfectadas(items);
              this.imprimirResumenPagoTotal(
                {
                  ...data,
                  habitacionesAfectadas,
                  HabitacionesAfectadas: habitacionesAfectadas.length,
                },
                {
                  IdMetodoPago: this.metodoPagoReservaCompleta,
                  IdCuentaBancaria: this.cuentaBancariaReservaCompleta,
                  NumeroReferencia: [2, 3, 4].includes(
                    this.metodoPagoReservaCompleta,
                  )
                    ? this.numeroReferenciaReservaCompleta
                    : null,
                  Monto: this.montoPagoReservaCompleta,
                },
              );
            }
          }, 500);
        }

        // Imprimir factura carta FEL si se generó factura
        if (data.factura?.uuid) {
          this.esperandoImpresion = true;
          setTimeout(() => this.imprimirFacturaCarta(data.factura.uuid), 900);
        }

        this.cerrarModalPagoReservaCompleta();

        // Recargar datos para actualizar saldos
        await this.obtenerDetalleReserva(this.route.params.id);
      } catch (err) {
        console.error(err);
        this.mostrarAlerta(
          err.response?.data?.message || "Error al procesar el pago total",
          "danger",
          8000,
        );
      } finally {
        this.cargandoPagoReservaCompleta = false;
      }
    },
    confirmarCheckoutReservaCompleta() {
      console.log("=== DEBUG CHECKOUT COMPLETO ===");
      console.log("Habitaciones:", this.habitaciones.length);
      console.log(
        "Habitaciones sin checkout:",
        this.habitacionesSinCheckout.length,
      );
      console.log(
        "Puede hacer checkout:",
        this.puedeHacerCheckoutReservaCompleta,
      );

      this.habitacionesSinCheckout.forEach((hab, idx) => {
        console.log(`Habitación ${idx + 1}:`, {
          Numero: hab.habitacion?.Numero || hab.IdHabitacion,
          CheckIn: hab.CheckIn,
          CheckOut: hab.CheckOut,
          SaldoPendiente: hab.SaldoPendienteHabitacion,
        });
      });

      if (!this.puedeHacerCheckoutReservaCompleta) {
        return this.mostrarAlerta(this.mensajeEstadoCheckoutCompleto, "danger");
      }

      if (this.habitacionesSinCheckout.length === 0) {
        return this.mostrarAlerta(
          "No hay habitaciones pendientes de checkout",
          "warning",
        );
      }

      this.modalCheckoutReservaCompletaVisible = true;
    },
    cerrarModalCheckoutReservaCompleta() {
      this.modalCheckoutReservaCompletaVisible = false;
    },
    async realizarCheckoutReservaCompleta() {
      try {
        this.cargandoCheckoutReservaCompleta = true;

        const { data } = await axios.put(
          `${API_URL}/reservas/checkout-completo/${this.reserva.IdReserva}`,
        );

        this.mostrarAlerta(
          data.message ||
            `Checkout realizado para ${data.totalHabitaciones} habitación(es)`,
          "success",
        );

        this.cerrarModalCheckoutReservaCompleta();

        // Recargar datos
        await this.obtenerDetalleReserva(this.route.params.id);
      } catch (err) {
        console.error(err);
        this.mostrarAlerta(
          err.response?.data?.message || "Error al realizar el checkout total",
          "danger",
        );
      } finally {
        this.cargandoCheckoutReservaCompleta = false;
      }
    },
    imprimirResumenPagoTotal(data, payload) {
      // Preparar información del pago total
      const width = 800;
      const height = 600;
      const left = window.screen.width / 2 - width / 2;
      const top = window.screen.height / 2 - height / 2;

      const win = window.open(
        "",
        "Imprimir",
        `width=${width},height=${height},left=${left},top=${top},toolbar=0,scrollbars=1,status=0,resizable=1`,
      );
      if (win) win.blur();

      win.onload = () => {
        win.print();
        win.close();
      };

      const metodoPago = this.metodosPagoReservaCompleta.find(
        (m) => m.IdMetodoPago === payload.IdMetodoPago,
      );
      const cuentaBancaria = this.cuentas.find(
        (c) => c.IdCuentaBancaria === payload.IdCuentaBancaria,
      );
      const tipoFactura =
        this.tipoPagoReservaCompleta === 1 ? "Con Factura" : "Sin Factura";

      let habitacionesHtml = "";
      if (data.habitacionesAfectadas) {
        data.habitacionesAfectadas.forEach((hab) => {
          habitacionesHtml += `
            <div class="fila">
              <span>Hab. ${
                hab.NumeroHabitacion || hab.IdReservaHabitacion
              }</span>
              <span>Q${Number(hab.MontoPagado || 0).toFixed(2)}</span>
            </div>
          `;
        });
      }

      const html = `
        <!DOCTYPE html>
        <html>
        <head>
          <meta charset="utf-8">
          <title>Comprobante de Pago Total - Reserva</title>
          <style>
            body {
              font-family: monospace;
              font-size: 12px;
              margin: 0;
              padding: 10px;
              line-height: 1.4;
            }
            .titulo-hotel {
              text-align: center;
              font-size: 16px;
              font-weight: bold;
              margin-bottom: 5px;
            }
            .subtitulo {
              text-align: center;
              font-size: 11px;
              margin-bottom: 10px;
              color: #555;
            }
            .linea {
              border-top: 1px dashed #000;
              margin: 8px 0;
            }
            .linea-doble {
              border-top: 2px solid #000;
              margin: 8px 0;
            }
            .fila {
              display: flex;
              justify-content: space-between;
              margin-bottom: 3px;
            }
            .total {
              font-weight: bold;
              font-size: 14px;
            }
            .centrado {
              text-align: center;
            }
          </style>
        </head>
        <body>
          <div class="titulo-hotel">${BRAND.nombre.toUpperCase()}</div>
          <div class="subtitulo">Comprobante de Pago Total - Reserva</div>
          <div class="linea"></div>

          <div class="fila">
            <span>Fecha:</span>
            <span>${new Date().toLocaleDateString(
              "es-GT",
            )} ${new Date().toLocaleTimeString("es-GT", {
        hour: "2-digit",
        minute: "2-digit",
      })}</span>
          </div>
          <div class="fila">
            <span>Reserva:</span>
            <span>#${this.reserva.IdReserva}</span>
          </div>
          <div class="fila">
            <span>Cliente:</span>
            <span>${this.reserva.huesped?.Nombre || "N/A"}</span>
          </div>
          <div class="fila">
            <span>Tipo:</span>
            <span>${tipoFactura}</span>
          </div>

          <div class="linea"></div>
          <div style="font-weight: bold; margin-bottom: 5px;">HABITACIONES PAGADAS:</div>
          ${habitacionesHtml}

          <div class="linea"></div>
          <div class="fila">
            <span>Método de Pago:</span>
            <span>${metodoPago?.Metodo || "N/A"}</span>
          </div>
          ${
            cuentaBancaria
              ? `
          <div class="fila">
            <span>Cuenta:</span>
            <span>${cuentaBancaria.NombreCuenta} - ${cuentaBancaria.Banco}</span>
          </div>
          `
              : ""
          }
          ${
            payload.NumeroReferencia
              ? `
          <div class="fila">
            <span>Referencia:</span>
            <span>${payload.NumeroReferencia}</span>
          </div>
          `
              : ""
          }

          <div class="linea-doble"></div>
          <div class="fila total">
            <span>TOTAL PAGADO:</span>
            <span>Q${Number(payload.Monto).toFixed(2)}</span>
          </div>
          <div class="fila">
            <span>Habitaciones:</span>
            <span>${data.HabitacionesAfectadas || 0}</span>
          </div>
          <div class="fila">
            <span>Saldo Pendiente:</span>
            <span>Q${Number(data.SaldoPendienteReserva || 0).toFixed(2)}</span>
          </div>

          <div class="linea"></div>
          <div class="centrado" style="margin-top: 15px; font-size: 10px;">
            ¡Gracias por su preferencia!
          </div>
        </body>
        </html>
      `;

      win.document.write(html);
      win.document.close();
    },
    calcularTotalConsumidoReserva() {
      return this.habitaciones.reduce((total, hab) => {
        return total + Number(hab.TotalConsumido || 0);
      }, 0);
    },
    calcularTotalPagadoReserva() {
      return this.habitaciones.reduce((total, hab) => {
        const consumido = Number(hab.TotalConsumido || 0);
        const saldoPendiente = Number(hab.SaldoPendienteHabitacion || 0);
        return total + (consumido - saldoPendiente);
      }, 0);
    },
    async imprimirResumenTodosPagos() {
      try {
        // Obtener todos los pagos de todas las habitaciones
        const promesas = this.habitaciones.map((hab) =>
          axios.get(`${API_URL}/pagos-habitacion/${hab.IdReservaHabitacion}`),
        );

        const respuestas = await Promise.all(promesas);
        const todosPagos = respuestas.flatMap((res) => res.data.pagos || []);

        // Generar comprobante de todos los pagos
        const width = 800;
        const height = 800;
        const left = window.screen.width / 2 - width / 2;
        const top = window.screen.height / 2 - height / 2;

        const win = window.open(
          "",
          "Imprimir",
          `width=${width},height=${height},left=${left},top=${top},toolbar=0,scrollbars=1,status=0,resizable=1`,
        );
        if (win) win.blur();

        win.onload = () => {
          win.print();
          win.close();
        };

        // Agrupar pagos por habitación
        let pagosPorHabitacionHtml = "";
        this.habitaciones.forEach((hab) => {
          const pagosHab = todosPagos.filter(
            (p) =>
              p.IdReservaHabitacion === hab.IdReservaHabitacion &&
              p.Anulado === 0,
          );
          if (pagosHab.length > 0) {
            const totalHab = pagosHab.reduce(
              (sum, p) => sum + Number(p.Monto),
              0,
            );
            pagosPorHabitacionHtml += `
              <div style="margin-bottom: 15px; padding: 10px; background: #f9f9f9; border-radius: 5px;">
                <div style="font-weight: bold; margin-bottom: 8px;">Habitación ${
                  hab.habitacion?.Numero
                }</div>
                ${pagosHab
                  .map(
                    (p) => `
                  <div class="fila" style="font-size: 11px; padding-left: 10px;">
                    <span>${new Date(p.FechaHora).toLocaleDateString(
                      "es-GT",
                    )} - ${p.metodo_pago?.Metodo || "N/A"}</span>
                    <span>Q${Number(p.Monto).toFixed(2)}</span>
                  </div>
                `,
                  )
                  .join("")}
                <div class="fila" style="font-weight: bold; padding-left: 10px; margin-top: 5px; border-top: 1px solid #ddd; padding-top: 5px;">
                  <span>Subtotal Hab. ${hab.habitacion?.Numero}:</span>
                  <span>Q${totalHab.toFixed(2)}</span>
                </div>
              </div>
            `;
          }
        });

        const totalPagado = this.calcularTotalPagadoReserva();
        const totalConsumido = this.calcularTotalConsumidoReserva();

        const html = `
          <!DOCTYPE html>
          <html>
          <head>
            <meta charset="utf-8">
            <title>Resumen de Pagos - Reserva #${this.reserva.IdReserva}</title>
            <style>
              body {
                font-family: monospace;
                font-size: 12px;
                margin: 0;
                padding: 10px;
                line-height: 1.4;
              }
              .titulo-hotel {
                text-align: center;
                font-size: 16px;
                font-weight: bold;
                margin-bottom: 5px;
              }
              .subtitulo {
                text-align: center;
                font-size: 11px;
                margin-bottom: 10px;
                color: #555;
              }
              .linea {
                border-top: 1px dashed #000;
                margin: 8px 0;
              }
              .linea-doble {
                border-top: 2px solid #000;
                margin: 8px 0;
              }
              .fila {
                display: flex;
                justify-content: space-between;
                margin-bottom: 3px;
              }
              .total {
                font-weight: bold;
                font-size: 14px;
              }
              .centrado {
                text-align: center;
              }
            </style>
          </head>
          <body>
            <div class="titulo-hotel">${BRAND.nombre.toUpperCase()}</div>
            <div class="subtitulo">Resumen Completo de Pagos</div>
            <div class="linea"></div>

            <div class="fila">
              <span>Fecha Impresión:</span>
              <span>${new Date().toLocaleDateString(
                "es-GT",
              )} ${new Date().toLocaleTimeString("es-GT", {
          hour: "2-digit",
          minute: "2-digit",
        })}</span>
            </div>
            <div class="fila">
              <span>Reserva:</span>
              <span>#${this.reserva.IdReserva}</span>
            </div>
            <div class="fila">
              <span>Cliente:</span>
              <span>${this.reserva.huesped?.Nombre || "N/A"}</span>
            </div>
            <div class="fila">
              <span>Habitaciones:</span>
              <span>${this.habitaciones.length}</span>
            </div>

            <div class="linea"></div>
            <div style="font-weight: bold; margin-bottom: 10px;">DETALLE DE PAGOS POR HABITACIÓN:</div>
            ${pagosPorHabitacionHtml}

            <div class="linea-doble"></div>
            <div class="fila total">
              <span>TOTAL CONSUMIDO:</span>
              <span>Q${totalConsumido.toFixed(2)}</span>
            </div>
            <div class="fila total">
              <span>TOTAL PAGADO:</span>
              <span>Q${totalPagado.toFixed(2)}</span>
            </div>
            <div class="fila total" style="color: ${
              this.saldoTotalPendiente > 0 ? "#dc3545" : "#28a745"
            }">
              <span>SALDO PENDIENTE:</span>
              <span>Q${Number(this.saldoTotalPendiente).toFixed(2)}</span>
            </div>

            <div class="linea"></div>
            <div class="centrado" style="margin-top: 15px; font-size: 10px;">
              ¡Gracias por su preferencia!
            </div>
          </body>
          </html>
        `;

        win.document.write(html);
        win.document.close();
      } catch (err) {
        console.error("Error al imprimir resumen:", err);
        this.mostrarAlerta("Error al generar el resumen de pagos", "danger");
      }
    },
  },
};
</script>

<style scoped>
label {
  font-weight: 500;
}

.operaciones-generales {
  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
  border: none !important;
  color: white;
}

.operaciones-generales h5 {
  color: white;
  font-weight: 600;
}

.habitaciones-tabs {
  display: flex;
  flex-wrap: wrap;
  border-bottom: 2px solid #dee2e6;
  padding-bottom: 15px;
}

.info-card {
  background: #f8f9fa;
  border-radius: 10px;
  padding: 20px;
  height: 100%;
}

.info-card.totales {
  background: #e8f4fd;
}

.info-card h5 {
  color: #495057;
  margin-bottom: 15px;
  border-bottom: 1px solid #dee2e6;
  padding-bottom: 10px;
}

.seccion {
  background: #fff;
  border: 1px solid #dee2e6;
  border-radius: 10px;
  padding: 20px;
}

.seccion-titulo {
  color: #495057;
  margin-bottom: 15px;
}
</style>
